/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useCallback } from "react";
import React from "react";
import { supabase } from "../supabaseClient";
import axios from "axios";
import toast from "react-hot-toast";
import { API_URL } from "../config";
import { useLocation } from "react-router-dom";
import * as XLSX from "xlsx";

// Dip Tarama: DB'den gelen periyot label → backend key köprüsü
const DIP_PERIYOT_BRIDGE = {
    "1 Yıl": "yil",
    "6 Ay":  "yari",
    "3 Ay":  "ceyrek",
    "1 Ay":  "ay",
};

const TOLERANS_MAP = {
    "%1": 0.01,
    "%3": 0.03,
    "%5": 0.05,
};

function getiriRengi(pct) {
    if (pct === null || pct === undefined) return "#94a3b8";
    if (pct >= 100) return "#047857";
    if (pct >= 50)  return "#059669";
    if (pct >= 20)  return "#10b981";
    if (pct >= 0)   return "#16a34a";
    if (pct >= -20) return "#dc2626";
    return "#991b1b";
}

// --- Bilgi İçerikleri ---
const BILGI_ICERIK = {
    "Tolerans": {
        baslik: "Tolerans",
        icerik: "Dip seviyesinin ne kadar yakınına gelindiğinde 'dip teyidi' sayılacağını belirleyen tolerans payı. Örneğin %5 tolerans, fiyatın referans dip seviyesinin en fazla %5 üzerinde/altında olması durumunda dahi bu seviyeye ulaşıldığının kabul edildiği anlamına gelir.",
    },
    "Dip Seviyesi": {
        baslik: "Dip Seviyesi",
        icerik: "Seçilen periyot (1 Ay, 3 Ay, 6 Ay, 1 Yıl) içindeki en düşük kapanış/fiyat seviyesidir. Simülasyon tarihinde hissenin bu dip seviyeye (tolerans payı dahilinde) ne kadar yakın olduğu kontrol edilerek sinyal üretilir.",
    },
    "Durum": {
        baslik: "Durum",
        icerik: "Hissenin simülasyon tarihindeki fiyatının, tarama kriterine göre beklenen seviyeye (ör. dip seviyesi, OTE bölgesi) göre durumunu özetler. Modüle göre farklı etiketler alabilir (ör. 'Dipte', 'Yakın', 'Uzak').",
    },
    "Lookback (Mum)": {
        baslik: "Lookback (Mum)",
        icerik: "Sweep taramasının geriye doğru kaç mum (bar) içinde swing high/low seviyelerini arayacağını belirler. Daha yüksek değer daha eski/uzak seviyeleri de dikkate alır, daha düşük değer sadece yakın geçmişe odaklanır.",
    },
    "Min Fitil Oranı": {
        baslik: "Min Fitil Oranı",
        icerik: "Bir mumun 'sweep' (likidite avı) sayılması için fitilinin (wick) mumun toplam boyuna oranının en az yüzde kaç olması gerektiğini belirler. Yüksek fitil oranı, fiyatın bir seviyeyi kısa süreliğine geçip hızla geri döndüğünü, yani gerçek bir likidite avını gösterir.",
    },
    "Ref. Seviye": {
        baslik: "Referans Seviye",
        icerik: "Sweep edilen (avlanan) swing high/low seviyesinin fiyat değeridir. Sinyalin dayandığı referans noktasıdır — fiyatın bu seviyeyi kısa süreliğine geçip geri dönmesiyle sweep tespit edilir.",
    },
    "Fitil %": {
        baslik: "Fitil %",
        icerik: "Sweep mumunun fitilinin (wick), mumun toplam yüksekliğine (high-low) oranıdır. Bu oran ne kadar yüksekse, fiyatın referans seviyeyi o kadar güçlü bir şekilde geçip hızla geri döndüğü, yani sinyalin o kadar güçlü olduğu anlamına gelir.",
    },
    "EQH/EQL": {
        baslik: "EQH/EQL (Eşit Tepe/Dip)",
        icerik: "EQH (Equal Highs) birbirine çok yakın seviyede oluşan iki veya daha fazla tepe, EQL (Equal Lows) ise birbirine çok yakın seviyede oluşan iki veya daha fazla diptir. Bu seviyeler üzerinde biriken stop emirleri nedeniyle yüksek kaliteli likidite bölgeleri sayılır ve sweep ihtimali daha güçlü kabul edilir.",
    },
    "Kalite": {
        baslik: "Kalite",
        icerik: "Sweep sinyalinin genel güvenilirlik puanlaması: 🟢 Yüksek Kalite, 🟡 Orta Kalite, ⚪ Standart. Fitil oranı, EQH/EQL varlığı ve diğer teyit kriterlerinin birleşiminden hesaplanır — 'Kalite Skoru' bu puanlamanın sayısal karşılığıdır.",
    },
    "BSL Seviye": {
        baslik: "BSL Seviye (Buy-Side Liquidity)",
        icerik: "Henüz sweep edilmemiş (avlanmamış), fiyatın üzerinde duran bir swing high seviyesidir. Üzerinde alım tarafı stop emirlerinin (likiditenin) biriktiği düşünülür; fiyatın gelecekte bu seviyeye doğru çekilme potansiyeli olduğuna işaret eder.",
    },
    "BSL Mesafe %": {
        baslik: "BSL Mesafe %",
        icerik: "Güncel/simülasyon anındaki fiyat ile BSL seviyesi arasındaki yüzde mesafedir. Bu mesafe ne kadar küçükse, fiyatın o likidite havuzuna o kadar yakın olduğu anlamına gelir.",
    },
    "SSL Seviye": {
        baslik: "SSL Seviye (Sell-Side Liquidity)",
        icerik: "Henüz sweep edilmemiş (avlanmamış), fiyatın altında duran bir swing low seviyesidir. Altında satış tarafı stop emirlerinin (likiditenin) biriktiği düşünülür; fiyatın gelecekte bu seviyeye doğru çekilme potansiyeli olduğuna işaret eder.",
    },
    "SSL Mesafe %": {
        baslik: "SSL Mesafe %",
        icerik: "Güncel/simülasyon anındaki fiyat ile SSL seviyesi arasındaki yüzde mesafedir. Bu mesafe ne kadar küçükse, fiyatın o likidite havuzuna o kadar yakın olduğu anlamına gelir.",
    },
    "BPR Kontrol": {
        baslik: "BPR Kontrol",
        icerik: "iFVG (dönüşmüş/mitigate edilmiş FVG) tespit edildiğinde, bu bölgenin aynı zamanda bir BPR (Balanced Price Range — dengelenmiş fiyat aralığı) oluşturup oluşturmadığını kontrol eder. BPR, art arda gelen iki FVG'nin kesişiminden oluşan, daha güçlü bir teyit bölgesidir. Sadece FVG Tipi'nde iFVG, Boğa/Ayı FVG ile birlikte seçildiğinde aktif olur.",
    },
    "Tarama Metodu": {
        baslik: "Tarama Metodu",
        icerik: "'Dip Altı Hisselerde' seçilirse, sadece belirlenen Dip Periyodu'na göre dip seviyesinde/yakınında olan hisseler taranır — bu, FVG sinyalini güçlü bir dip teyidiyle birleştirir. 'Tüm Hisselerde' seçilirse dip şartı aranmaz, evrendeki tüm hisseler FVG kriterine göre taranır.",
    },
    "Dip Periyodu": {
        baslik: "Dip Periyodu",
        icerik: "Tarama Metodu 'Dip Altı Hisselerde' seçiliyken, dip seviyesinin hangi geçmiş zaman aralığında (Yıllık, 6 Aylık, 3 Aylık, Aylık) hesaplanacağını belirler. Sadece bu metod seçiliyken aktif olur.",
    },
    "Mum Sayısı": {
        baslik: "Mum Sayısı",
        icerik: "FVG (Fair Value Gap) taramasının geriye doğru kaç mum (bar) içinde yapılacağını belirler. Daha yüksek değer daha eski FVG bölgelerini de dahil eder, daha düşük değer sadece güncel/yakın geçmişteki boşlukları tarar.",
    },
    "Alt Sınır": {
        baslik: "Alt Sınır",
        icerik: "FVG (Fair Value Gap) bölgesinin alt fiyat sınırıdır. Boğa FVG'de bir önceki mumun tepe (high) seviyesi, Ayı FVG'de ise sonraki mumun tepe seviyesidir — boşluğun alt ucunu temsil eder.",
    },
    "Üst Sınır": {
        baslik: "Üst Sınır",
        icerik: "FVG (Fair Value Gap) bölgesinin üst fiyat sınırıdır. Boğa FVG'de sonraki mumun dip (low) seviyesi, Ayı FVG'de ise bir önceki mumun dip seviyesidir — boşluğun üst ucunu temsil eder.",
    },
    "Mesafe": {
        baslik: "Mesafe %",
        icerik: "Güncel/simülasyon anındaki fiyat ile FVG bölgesi arasındaki yüzde mesafedir. Bu mesafe ne kadar küçükse, fiyatın o FVG bölgesine o kadar yakın olduğu, dolayısıyla bölgenin doldurulma/tepki verme ihtimalinin o kadar güncel olduğu anlamına gelir.",
    },
    "FVG Durumu": {
        baslik: "FVG Durumu",
        icerik: "FVG bölgesinin fiyat tarafından ne ölçüde doldurulduğunu (fill edildiğini) gösterir. 'Dolu' bölge tamamen kapanmış, 'Kısmi' bölge kısmen doldurulmuş, 'Taze/Bakir' bölge ise hiç dokunulmamış anlamına gelir — taze bölgeler genelde daha güçlü tepki verme potansiyeli taşır.",
    },
    "BPR": {
        baslik: "BPR Durumu",
        icerik: "İlgili FVG'nin bir BPR (Balanced Price Range) oluşturup oluşturmadığını gösterir. BPR, iki ardışık FVG'nin (biri normal biri dönüşmüş/iFVG) kesişiminden oluşan, tek bir FVG'ye göre daha güvenilir kabul edilen bir teyit bölgesidir.",
    },
    "Çapa Tolerans": {
        baslik: "Tolerans",
        icerik: "Fiyatın, tespit edilen FVG (Fair Value Gap) çapa bölgesine ne kadar yakın olması gerektiğini belirleyen tolerans payı. Örneğin %50 tolerans, fiyatın FVG bölgesinin sınırlarına göre daha geniş bir aralıkta kabul edilmesini sağlar — düşük tolerans sadece bölgeye çok yakın/içindeki fiyatları, yüksek tolerans daha uzak fiyatları da 'çapa' olarak kabul eder.",
    },
    "Temas Sayısı": {
        baslik: "Temas Sayısı",
        icerik: "Fiyatın, tespit edilen FVG (Fair Value Gap) çapa bölgesine geçmişte kaç kez temas ettiğini (dokunup geri döndüğünü) gösterir. Temas sayısı arttıkça bölgenin piyasa tarafından tanınan/saygı duyulan bir seviye olduğu, dolayısıyla gelecekte de tepki verme ihtimalinin yüksek olduğu düşünülür.",
    },
    "Çapa Durumu": {
        baslik: "Çapa Durumu",
        icerik: "Fiyatın çapa (FVG) bölgesine göre güncel/simülasyon anındaki konumunu özetler — bölgenin içinde mi, üzerinde mi yoksa altında mı olduğunu gösterir. Bu durum, çapa bölgesinin hâlâ geçerli bir destek/direnç olarak işlev görüp görmediğini anlamaya yardımcı olur.",
    },
    "Swing Penceresi": {
        baslik: "Swing Penceresi",
        icerik: "MSB (Market Structure Shift — piyasa yapısı kırılımı) tespitinde, bir fiyat noktasının swing high/low (tepe/dip) sayılması için sağında ve solunda kaç mum bulunması gerektiğini belirler. Daha büyük pencere daha az ama daha güvenilir/anlamlı swing noktaları bulur, daha küçük pencere daha fazla ama daha hassas/gürültülü noktalar üretir.",
    },
    "Kırılan Seviye": {
        baslik: "Kırılan Seviye",
        icerik: "MSB sinyaline yol açan, fiyatın kırdığı önceki swing high veya swing low seviyesinin fiyat değeridir. Bu kırılma, piyasa yapısının (trendin) yön değiştirdiğinin teyidi olarak kabul edilir.",
    },
    "Güçlü Kırılım": {
        baslik: "Güçlü Kırılım",
        icerik: "Tespit edilen MSB'nin (yapısal kırılımın), kırılan seviyenin sadece hafifçe mi yoksa belirgin bir mesafeyle mi (genellikle hacim/momentum artışıyla birlikte) aşıldığını gösterir. 'Evet' ise kırılım geniş katılımlı ve güçlü, 'Hayır' ise zayıf/sınırda bir kırılımdır.",
    },
    "OTE Alt": {
        baslik: "OTE Alt",
        icerik: "OTE (Optimal Trade Entry) bölgesinin alt fiyat sınırıdır — genellikle Fibonacci %79 seviyesine karşılık gelir. Fiyatın bu seviyeye kadar geri çekilmesi, girişin hâlâ optimal bölge içinde kaldığı anlamına gelir.",
    },
    "OTE Orta": {
        baslik: "OTE Orta",
        icerik: "OTE (Optimal Trade Entry) bölgesinin orta noktasıdır — genellikle Fibonacci %70.5 seviyesine karşılık gelir. Bölge içindeki en dengeli giriş noktası olarak kabul edilir.",
    },
    "OTE Üst": {
        baslik: "OTE Üst",
        icerik: "OTE (Optimal Trade Entry) bölgesinin üst fiyat sınırıdır — genellikle Fibonacci %61.8 seviyesine karşılık gelir. Fiyatın bu seviyenin ötesine geçmesi, geri çekilmenin henüz OTE bölgesine ulaşmadığı anlamına gelir.",
    },
    "Fib %": {
        baslik: "Fib %",
        icerik: "Fiyatın, son swing hareketinin (dip-tepe arası) Fibonacci geri çekilme seviyelerinden hangisine denk geldiğini gösterir. OTE stratejisinde %61.8 ile %79 arası bölge 'optimal giriş bölgesi' (OTE) olarak kabul edilir.",
    },
    "R/R": {
        baslik: "R/R (Risk/Ödül Oranı)",
        icerik: "Potansiyel kazancın (hedefe olan mesafe) potansiyel riske (stop seviyesine olan mesafe) oranıdır. R/R değeri ne kadar yüksekse, alınan risk başına beklenen getiri o kadar caziptir — genellikle 1.5-2 ve üzeri değerler tercih edilir.",
    },
    "Min Gövde Oranı": {
        baslik: "Min Gövde Oranı",
        icerik: "Bir mumun geçerli bir OB (Order Block) veya BB (Breaker Block) sayılması için gövdesinin (açılış-kapanış arası), mumun toplam boyuna (yüksek-düşük arası) oranının en az yüzde kaç olması gerektiğini belirler. Yüksek oran, daha kararlı/net gövdeli (az fitilli) mumları filtreler; bu tür mumlar genellikle daha güçlü kurumsal katılıma işaret eder.",
    },
    "Sadece Taze": {
        baslik: "Sadece Taze",
        icerik: "İşaretlendiğinde, yalnızca fiyat tarafından henüz hiç test edilmemiş (dokunulmamış) 'taze' OB/BB bölgeleri listelenir. Taze bölgeler, henüz gücünü kaybetmediği için ilk tepkide daha güvenilir kabul edilir.",
    },
    "OB Alt": {
        baslik: "OB Alt",
        icerik: "OB (Order Block) veya BB (Breaker Block) bölgesinin alt fiyat sınırıdır — genellikle ilgili mumun düşük (low) veya gövde alt seviyesidir.",
    },
    "OB Üst": {
        baslik: "OB Üst",
        icerik: "OB (Order Block) veya BB (Breaker Block) bölgesinin üst fiyat sınırıdır — genellikle ilgili mumun yüksek (high) veya gövde üst seviyesidir.",
    },
    "Displacement": {
        baslik: "Displacement",
        icerik: "OB/BB bölgesinden sonra gelen güçlü, geniş gövdeli ve genelde bir FVG (Fair Value Gap) bırakan hızlı fiyat hareketidir. Displacement'in varlığı, kurumsal/büyük hacimli katılımın olduğunu ve bölgenin gerçek bir Order Block olma ihtimalinin yüksek olduğunu gösterir.",
    },
    "FVG Onayı": {
        baslik: "FVG Onayı",
        icerik: "OB/BB bölgesinden çıkan hareketin, bir FVG (Fair Value Gap — fiyat boşluğu) bırakıp bırakmadığını gösterir. 'Evet' ise bölge, güçlü ve hızlı bir hareketle teyit edilmiş demektir — bu, sinyalin güvenilirliğini artıran ek bir teyit katmanıdır.",
    },
    "Tazelik": {
        baslik: "Tazelik",
        icerik: "OB/BB bölgesinin, tespit edildiğinden bu yana fiyat tarafından kaç kez test edildiğini/kullanıldığını gösterir. 'Taze' bir bölge hiç test edilmemiş, kullanılmış bir bölge ise gücünü kısmen kaybetmiş olabilir.",
    },
    "Güç": {
        baslik: "Güç",
        icerik: "OB/BB sinyalinin genel güvenilirlik puanlamasıdır; gövde oranı, displacement varlığı, FVG onayı ve tazelik gibi kriterlerin birleşiminden hesaplanır. Yüksek güç, sinyalin daha fazla teyit kriterini karşıladığı ve daha güvenilir olduğu anlamına gelir.",
    },
    "IDM Seviyesi": {
        baslik: "IDM Seviyesi",
        icerik: "IDM (Inducement) yapısının tespit edildiği fiyat seviyesidir — piyasanın önce zayıf bir seviyeyi kırarak (tuzak) katılımcıları yanlış yöne çektiği, ardından asıl hareketin başladığı referans noktasıdır.",
    },
    "Pullback Sayısı": {
        baslik: "Pullback Sayısı",
        icerik: "IDM seviyesi oluştuktan sonra fiyatın bu seviyeye kaç kez geri çekilip (pullback) tekrar test ettiğini gösterir. Çok sayıda pullback, seviyenin piyasa tarafından hâlâ önemsendiğini ancak zayıfladığını da gösterebilir.",
    },
    "Sweep Durumu": {
        baslik: "Sweep Durumu",
        icerik: "IDM seviyesinin fiyat tarafından sweep edilip edilmediğini (kısa süreliğine geçilip hızla geri dönülüp dönülmediğini) gösterir. Sweep gerçekleşmesi, tuzağın tamamlandığı ve asıl yönlü hareketin başlayabileceğine dair bir teyittir.",
    },
    "Sonraki Hedef": {
        baslik: "Sonraki Hedef",
        icerik: "IDM yapısı teyit edildikten sonra fiyatın yöneleceği bir sonraki önemli likidite/yapısal seviyedir (ör. bir sonraki swing high/low veya BSL/SSL bölgesi). Potansiyel kâr alma noktası olarak değerlendirilir.",
    },
    "Range Penceresi": {
        baslik: "Range Penceresi",
        icerik: "Discount/Equilibrium/Premium bölgelerinin hesaplanacağı fiyat aralığının (range'in) geriye doğru kaç mum (bar) üzerinden belirleneceğini gösterir. Daha büyük pencere daha geniş/uzun vadeli bir range, daha küçük pencere daha yakın/kısa vadeli bir range kullanır.",
    },
    "Discount Üst": {
        baslik: "Discount Üst",
        icerik: "Discount (ucuz) bölgesinin üst fiyat sınırıdır. Bu seviyenin altındaki fiyatlar, range'in alt (ucuz) yarısında sayılır ve genellikle alım için daha avantajlı kabul edilir.",
    },
    "Premium Alt": {
        baslik: "Premium Alt",
        icerik: "Premium (pahalı) bölgesinin alt fiyat sınırıdır. Bu seviyenin üzerindeki fiyatlar, range'in üst (pahalı) yarısında sayılır ve genellikle satış/kâr alma için daha avantajlı kabul edilir.",
    },
    "Denge (EQ)": {
        baslik: "Denge (EQ — Equilibrium)",
        icerik: "Range'in tam orta noktasıdır (Discount ile Premium bölgeleri arasındaki sınır). Fiyatın bu seviyenin altında olması Discount, üstünde olması Premium bölgede olduğu anlamına gelir.",
    },
    "PD Fib %": {
        baslik: "Fib %",
        icerik: "Fiyatın, belirlenen range (Range Penceresi) içindeki konumunun Fibonacci/yüzdesel karşılığıdır. %0 range'in dibi, %100 range'in tepesini, %50 ise Denge (EQ) noktasını temsil eder.",
    },
    "Delta Volume %": {
        baslik: "Delta Volume %",
        icerik: "İlgili bölgedeki alım ve satım hacmi arasındaki farkın yüzdesel büyüklüğüdür. Pozitif değer net alım baskısını, negatif değer net satım baskısını gösterir — bölgenin gerçek işlem hacmiyle ne ölçüde desteklendiğini ortaya koyar.",
    },
    "Bölge": {
        baslik: "Bölge",
        icerik: "Fiyatın range içindeki güncel/simülasyon anındaki konumunu üç kategoriden birine ayırır: Discount (ucuz, range'in alt yarısı), Equilibrium (denge, orta nokta civarı) veya Premium (pahalı, range'in üst yarısı).",
    },
    "Yön Önerisi": {
        baslik: "Yön Önerisi",
        icerik: "Fiyatın bulunduğu bölgeye (Discount/Equilibrium/Premium) göre önerilen işlem yönüdür. Discount bölgesi genellikle alım (Boğa), Premium bölgesi genellikle satış (Ayı) yönünde bir önyargı oluşturur; Equilibrium'da net bir yön önerisi olmayabilir.",
    },
    "Min. Korelasyon": {
        baslik: "Min. Korelasyon",
        icerik: "SMT (Smart Money Divergence) sinyalinin geçerli sayılması için hissenin, referans varlıkla (örn. BIST100 veya BTC) geçmiş fiyat hareketleri arasında en az yüzde kaç korelasyon bulunması gerektiğini belirler. Yüksek eşik, sadece güçlü bağlantılı çiftler arasındaki uyumsuzlukları (divergence) yakalar.",
    },
    "Hisse Swing": {
        baslik: "Hisse Swing",
        icerik: "İncelenen hissenin son swing high/low (tepe/dip) seviyesidir. SMT sinyali, bu swing'in referans varlığın swing'iyle aynı yönde hareket etmemesi (uyumsuzluk göstermesi) durumunda oluşur.",
    },
    "Referans Swing": {
        baslik: "Referans Swing",
        icerik: "Referans varlığın (örn. BIST100, BTC) aynı zaman aralığındaki son swing high/low (tepe/dip) seviyesidir. Hissenin swing'i ile karşılaştırılarak SMT (uyumsuzluk) tespit edilir.",
    },
    "Kolerasyon": {
        baslik: "Korelasyon",
        icerik: "Hissenin fiyat hareketi ile referans varlığın fiyat hareketi arasındaki geçmiş dönem istatistiksel ilişkinin gücüdür (0-100 arası). Yüksek korelasyon, ikilinin normalde birlikte hareket ettiğini, dolayısıyla aralarında oluşan bir uyumsuzluğun (SMT) daha anlamlı olduğunu gösterir.",
    },
    "SMT Güç": {
        baslik: "Güç",
        icerik: "SMT sinyalinin genel güvenilirlik puanlamasıdır; korelasyon seviyesi, swing'ler arasındaki uyumsuzluğun belirginliği gibi kriterlerin birleşiminden hesaplanır. Yüksek güç, sinyalin daha güvenilir olduğu anlamına gelir.",
    },
    "Killzone Seçimi": {
        baslik: "Killzone Seçimi",
        icerik: "Piyasadaki en yoğun/kurumsal işlem hacminin görüldüğü belirli gün içi zaman aralıklarıdır (ör. Londra açılışı, New York açılışı, BIST açılışı). Bu aralıklarda oluşan fiyat hareketlerinin (FVG, MSB, Sweep) daha güvenilir olduğu kabul edilir.",
    },
    "Yapı Tipi": {
        baslik: "Yapı Tipi",
        icerik: "Killzone aralığı içinde aranacak piyasa yapısı türüdür: FVG (Fair Value Gap — fiyat boşluğu), MSB (Market Structure Shift — yapısal kırılım) veya Sweep (likidite avı). Birden fazla tip aynı anda seçilebilir.",
    },
    "Geriye Bakış (Gün)": {
        baslik: "Geriye Bakış (Gün)",
        icerik: "Taramanın geriye doğru kaç günlük killzone verisini inceleyeceğini belirler. Daha yüksek değer daha fazla geçmiş killzone penceresini tarar, dolayısıyla daha fazla (ama görece daha eski) sinyal bulma ihtimalini artırır.",
    },
    "Hacim Onayı": {
        baslik: "Hacim Onayı",
        icerik: "Killzone içinde tespit edilen yapının (FVG/MSB/Sweep), o anki işlem hacminin ortalamanın üzerinde olup olmadığıyla teyit edilip edilmediğini gösterir. 'Evet' ise sinyal, artmış işlem hacmiyle destekleniyor demektir — bu, sinyalin güvenilirliğini artıran ek bir teyit katmanıdır.",
    },
    "Sınıf": {
        baslik: "Sınıf",
        icerik: "Killzone sinyalinin genel güvenilirlik sınıflandırmasıdır; killzone'un önemi, yapı tipi ve hacim onayı gibi kriterlerin birleşiminden hesaplanır. Yüksek sınıf, sinyalin daha güçlü/güvenilir olduğu anlamına gelir.",
    },
    "EMA200": {
        baslik: "EMA200",
        icerik: "Günlük zaman diliminde 200 periyotluk Üstel Hareketli Ortalama'dır (Exponential Moving Average). Topdown Cascade'in 1. Aşama filtresinde ana trend yönünü belirlemek için kullanılır: fiyat EMA200'ün üzerindeyse LONG, altındaysa SHORT trend kabul edilir.",
    },
    "4H Sweep": {
        baslik: "4H Sweep",
        icerik: "Topdown Cascade'in 2. Aşama (teyit) filtresidir. 4 saatlik zaman diliminde, son dönemin swing high/low (BSL/SSL) seviyesinin bir fitille (wick) delinip fiyatın seviyenin ters yönünde kapanmasıdır — yani likidite avlanmış ve ardından ana trend yönünde teyit gelmiştir. 'Fitil %' değeri, bu delinmenin seviyeye göre büyüklüğünü gösterir; yüksek değer daha belirgin/güçlü bir sweep anlamına gelir.",
    },
    "Sinyal Filtresi": {
        baslik: "Sinyal Filtresi",
        icerik: "Hacim Profili taramasının hangi bölgesel sinyalleri arayacağını belirler: POC Yakını (fiyatın en yoğun işlem gören seviyeye yakınlığı), Discount/Premium (fiyatın value area'nın alt/üst yarısında olması), HVN Yakın (yüksek hacimli düğüme yakınlık) veya LVN İçi (düşük hacimli, boşluk bölgesinde olma).",
    },
    "Min Hacim Skoru": {
        baslik: "Min Hacim Skoru",
        icerik: "Hacim Profili sinyalinin listelenebilmesi için en az kaç puanlık bir Hacim Profili (HP) Skoru'na sahip olması gerektiğini belirler. Yüksek eşik, sadece en güçlü/en net hacim yapısına sahip hisseleri listeler.",
    },
    "POC": {
        baslik: "POC (Point of Control)",
        icerik: "Belirlenen periyot içinde en yüksek işlem hacminin gerçekleştiği tek fiyat seviyesidir. Piyasanın 'adil değer' olarak kabul ettiği, en çok alıcı-satıcı buluşmasının olduğu seviyedir; genellikle güçlü bir destek/direnç işlevi görür.",
    },
    "VAH": {
        baslik: "VAH (Value Area High)",
        icerik: "Value Area'nın (işlem hacminin yaklaşık %70'inin gerçekleştiği fiyat aralığının) üst sınırıdır. Fiyatın bu seviyenin üzerine çıkması, değer alanının dışına (Premium bölgeye) geçildiği anlamına gelir.",
    },
    "VAL": {
        baslik: "VAL (Value Area Low)",
        icerik: "Value Area'nın (işlem hacminin yaklaşık %70'inin gerçekleştiği fiyat aralığının) alt sınırıdır. Fiyatın bu seviyenin altına inmesi, değer alanının dışına (Discount bölgeye) geçildiği anlamına gelir.",
    },
    "POC Uzaklık %": {
        baslik: "POC Uzaklık %",
        icerik: "Güncel/simülasyon anındaki fiyat ile POC (en yoğun işlem gören seviye) arasındaki yüzde mesafedir. Bu mesafe ne kadar küçükse, fiyatın piyasanın 'adil değer' kabul ettiği seviyeye o kadar yakın olduğu anlamına gelir.",
    },
    "VA Durumu": {
        baslik: "VA Durumu",
        icerik: "Fiyatın Value Area'ya (VAL-VAH aralığına) göre güncel/simülasyon anındaki konumunu gösterir: Value Area içinde, üzerinde (Premium) veya altında (Discount) olabilir. Bu durum, fiyatın 'adil değer' bölgesine göre pahalı mı ucuz mu olduğuna işaret eder.",
    },
    "HVN Yakın": {
        baslik: "HVN Yakın",
        icerik: "HVN (High Volume Node — yüksek hacimli düğüm), hacim profilinde belirgin şekilde yoğunlaşmış işlem hacmine sahip bir fiyat bölgesidir. Fiyatın böyle bir bölgeye yakın olması, güçlü bir destek/direnç seviyesine yakın olunduğu, dolayısıyla fiyatın burada yavaşlama/tepki gösterme ihtimalinin yüksek olduğu anlamına gelir.",
    },
    "LVN İçi": {
        baslik: "LVN İçi",
        icerik: "LVN (Low Volume Node — düşük hacimli düğüm), hacim profilinde işlem hacminin belirgin şekilde az olduğu bir fiyat bölgesidir (bir tür 'boşluk'). Fiyatın bu bölge içinde olması, burada uzun süre kalmayacağı, hızlı geçiş yapma eğiliminde olduğu anlamına gelir — fiyatlar genelde LVN bölgelerinden hızla geçip HVN'lere doğru çekilir.",
    },
    "HP Skoru": {
        baslik: "HP Skoru (Hacim Profili Skoru)",
        icerik: "Hacim Profili sinyalinin genel güvenilirlik puanlamasıdır (0'dan yukarı); POC'a yakınlık, VA durumu, HVN/LVN konumu gibi kriterlerin birleşiminden hesaplanır. Yüksek skor, sinyalin daha güçlü/güvenilir bir hacim yapısına dayandığı anlamına gelir.",
    },
    "Ort. Pencere (Gün)": {
        baslik: "Ort. Pencere (Gün)",
        icerik: "Ortalama hacmin hesaplanacağı geriye dönük gün sayısıdır. Bu pencere içindeki günlük hacimlerin ortalaması 'Ort. Hacim' değerini oluşturur ve güncel hacmin bu ortalamaya oranı (Spike Katsayısı) buna göre hesaplanır. Daha büyük pencere daha stabil/uzun vadeli bir referans, daha küçük pencere daha güncel/hassas bir referans sağlar.",
    },
    "Min Spike (xOrt.)": {
        baslik: "Min Spike (xOrt.)",
        icerik: "Bir sinyalin listelenebilmesi için güncel hacmin, ortalama hacmin en az kaç katı olması gerektiğini belirler. Örneğin 2x, güncel hacmin ortalamanın en az 2 katı olması gerektiği anlamına gelir — yüksek eşik yalnızca en belirgin hacim patlamalarını (spike) yakalar.",
    },
    "Sinyal Tipi": {
        baslik: "Sinyal Tipi",
        icerik: "Hacim Akışı taramasının arayacağı sinyal yönü ve gücüdür: Güçlü/Orta/Zayıf Alım (fiyat yükselirken hacim artışı — net alım baskısı) veya Güçlü/Orta/Zayıf Satım (fiyat düşerken hacim artışı — net satım baskısı). Birden fazla tip aynı anda seçilebilir.",
    },
    "Fiyat Değişim %": {
        baslik: "Fiyat Değişim %",
        icerik: "İlgili mumda/günde fiyatın yüzde kaç değiştiğini gösterir. Hacim Akışı sinyalinin yönünü (alım mı satım mı) belirlemede, hacim artışıyla birlikte değerlendirilen temel göstergedir — fiyat yükselirken hacim artışı alım, düşerken hacim artışı satım sinyali sayılır.",
    },
    "Hacim": {
        baslik: "Hacim",
        icerik: "İlgili mumda/günde gerçekleşen toplam işlem hacmidir. Ortalama hacimle (Ort. Hacim) karşılaştırılarak sinyalin ne kadar 'olağan dışı' olduğu (Spike Katsayısı) hesaplanır.",
    },
    "Ort. Hacim": {
        baslik: "Ort. Hacim",
        icerik: "Belirlenen Ort. Pencere (Gün) içindeki günlük hacimlerin ortalamasıdır. Güncel hacmin bu ortalamaya oranı, sinyalin gücünü belirleyen Spike Katsayısı'nı oluşturur.",
    },
    "Spike Katsayısı": {
        baslik: "Spike Katsayısı",
        icerik: "Güncel hacmin, ortalama hacme (Ort. Hacim) oranıdır (ör. 2.5x = ortalamanın 2.5 katı). Bu katsayı Min Spike eşiğinin üzerinde olmalıdır ki sinyal listelensin — yüksek katsayı, olağan dışı derecede yoğun bir işlem hacmine işaret eder.",
    },
    "Hacim Değişim %": {
        baslik: "Hacim Değişim %",
        icerik: "Güncel hacmin, bir önceki döneme (veya ortalamaya) göre yüzde kaç değiştiğini gösterir. Pozitif değer hacimde artışı, negatif değer azalışı ifade eder.",
    },
    "Momentum": {
        baslik: "Momentum",
        icerik: "Fiyat ve hacim hareketinin birleşiminden türetilen, hareketin gücünü/ivmesini gösteren bir puandır. Pozitif ve yüksek momentum güçlü bir yukarı ivmeyi, negatif ve düşük momentum güçlü bir aşağı ivmeyi gösterir.",
    },
    "Süreklilik (Gün)": {
        baslik: "Süreklilik (Gün)",
        icerik: "Tespit edilen hacim/fiyat yönünün kaç gündür kesintisiz sürdüğünü gösterir. Yüksek süreklilik, sinyalin geçici bir tek günlük hareket değil, kalıcı bir eğilim olduğuna işaret eder.",
    },
    "HA Skoru": {
        baslik: "HA Skoru (Hacim Akışı Skoru)",
        icerik: "Hacim Akışı sinyalinin genel güvenilirlik puanlamasıdır (0-100 arası); spike katsayısı, momentum ve süreklilik gibi kriterlerin birleşiminden hesaplanır. Yüksek skor, sinyalin daha güçlü ve güvenilir olduğu anlamına gelir.",
    },
    "Pivot Modu": {
        baslik: "Pivot Modu",
        icerik: "Divergence taramasının fiyat tepe/dip noktalarını (pivot) hangi yöntemle tespit edeceğini belirler. 'Fractal' modu sabit sayıda mumluk bir pencereye göre (Swing Penceresi) pivot arar; 'ZigZag' modu ise belirli bir yüzdesel eşiği (ZigZag Eşik %) aşan hareketlere göre pivot belirler.",
    },
    "Osilatörler": {
        baslik: "Osilatörler",
        icerik: "Divergence (uyumsuzluk) aranacak teknik göstergelerdir: RSI, MACD Histogram, Stokastik RSI veya OBV. Fiyat bir yönde hareket ederken seçilen osilatör(ler) ters yönde hareket ediyorsa, bu bir divergence sinyali olarak değerlendirilir. Birden fazla osilatör aynı anda seçilebilir.",
    },
    "Divergence Tipleri": {
        baslik: "Divergence Tipleri",
        icerik: "Aranacak uyumsuzluk türleridir: Regular Bullish/Bearish (klasik, trend dönüşü işareti) veya Hidden Bullish/Bearish (gizli, mevcut trendin devamı işareti). Regular tipler tepe/dip noktalarında, Hidden tipler ise trend içi düzeltmelerde aranır.",
    },
    "Tip": {
        baslik: "Tip",
        icerik: "Tespit edilen divergence'ın türüdür: Regular Bullish/Bearish (trend dönüşü potansiyeli) veya Hidden Bullish/Bearish (mevcut trendin devam etme potansiyeli). Bullish yükseliş, Bearish düşüş yönünde bir sinyale işaret eder.",
    },
    "Konfluence Skoru": {
        baslik: "Konfluence Skoru",
        icerik: "Aynı anda kaç farklı osilatörde (RSI, MACD, Stokastik RSI, OBV) aynı yönde divergence tespit edildiğini gösteren bir puandır. Birden fazla göstergenin aynı sinyali vermesi (konfluence — örtüşme), sinyalin güvenilirliğini artırır; yüksek konfluence skoru daha güçlü bir teyit anlamına gelir.",
    },
    "Onay Durumu": {
        baslik: "Onay Durumu",
        icerik: "Tespit edilen divergence'ın fiyat hareketiyle teyit edilip edilmediğini gösterir — örneğin son pivot noktasından sonra fiyatın beklenen yönde hareket etmeye başlayıp başlamadığı. Onaylanmış sinyaller, henüz teyit gelmemiş sinyallere göre daha güvenilir kabul edilir.",
    },
    "Divergence Güç": {
        baslik: "Güç",
        icerik: "Tespit edilen divergence'ın genel güvenilirlik puanlamasıdır: Çok Güçlü, Güçlü veya Orta. Konfluence skoru (kaç osilatörün aynı yönde sinyal verdiği), pivot mesafesi ve onay durumu gibi kriterlerin birleşiminden hesaplanır — yüksek güç, sinyalin daha fazla teyit kriterini karşıladığı anlamına gelir.",
    },
    "Pivot Tipi": {
        baslik: "Pivot Tipi",
        icerik: "Divergence'ın tespit edildiği pivot noktasının türüdür — bir tepe (high) mi yoksa dip (low) mi olduğunu gösterir. Bullish divergence'lar genellikle dip pivotlarında, Bearish divergence'lar ise tepe pivotlarında aranır.",
    },
    "Pivot Mesafe": {
        baslik: "Pivot Mesafe",
        icerik: "Karşılaştırılan iki pivot noktası arasındaki mum sayısıdır. Bu mesafe, Min Pivot Mesafe kriteriyle karşılaştırılır; çok yakın pivotlar arasındaki karşılaştırmalar genelde daha az anlamlı/gürültülü kabul edilir, bu yüzden belirli bir minimum mesafe şartı aranır.",
    },
    "İşlem Tipi": {
        baslik: "İşlem Tipi",
        icerik: "Planlanan işlemin Spot (doğrudan varlık alım-satımı) mı yoksa Kaldıraçlı (marj/türev, borçlanarak büyütülmüş pozisyon) mu olacağını belirler. BIST'te veya Kripto'da TL/USD (spot) para birimi seçiliyken sadece Spot; Kripto'da kaldıraçlı para birimi seçiliyken sadece Kaldıraç kullanılabilir.",
    },
    "İşlem Yönü": {
        baslik: "İşlem Yönü",
        icerik: "Planlanan pozisyonun yönüdür: Long (fiyatın yükseleceği beklentisiyle alım) veya Short (fiyatın düşeceği beklentisiyle açığa satış). Short işlemler sadece kaldıraçlı işlem tipinde mümkün olduğu için, İşlem Tipi Spot'a zorunlu olduğunda bu seçenek pasif hale gelir (sadece Long kabul edilir).",
    },
    "Önceki Yıl Seviyesi": {
        baslik: "Önceki Yıl Seviyesi",
        icerik: "Bir önceki takvim yılının en düşük (veya referans alınan) fiyat seviyesidir. Uzun vadeli destek/direnç ve işlem planlaması için önemli bir referans seviyesi olarak kullanılır.",
    },
    "3 Aylık Açılış": {
        baslik: "3 Aylık Açılış",
        icerik: "İçinde bulunulan çeyreğin (3 aylık dönemin) ilk işlem gününün açılış fiyatıdır. Kurumsal/algoritmik işlemcilerin sıkça referans aldığı bir seviye olup, fiyatın bu seviyenin üzerinde mi altında mı olduğu genel çeyreklik eğilim hakkında fikir verir.",
    },
    "Aylık Açılış": {
        baslik: "Aylık Açılış",
        icerik: "İçinde bulunulan ayın ilk işlem gününün açılış fiyatıdır. Fiyatın bu seviyeye göre konumu, ay içi kısa vadeli eğilimi değerlendirmede kullanılan bir referans noktasıdır.",
    },
    "Haftalık Açılış": {
        baslik: "Haftalık Açılış",
        icerik: "İçinde bulunulan haftanın ilk işlem gününün (genellikle Pazartesi) açılış fiyatıdır. Kısa vadeli işlem planlamasında sık kullanılan bir gün-içi/hafta-içi referans seviyesidir.",
    },
    "Min. Puan": {
        baslik: "Min. Puan",
        icerik: "Bir sinyalin listelenebilmesi için Güven Skoru'nun en az kaç olması gerektiğini belirler. Yüksek eşik, sadece en güçlü/en çok teyit kriterini karşılayan sinyalleri listeler.",
    },
    "Güven Skoru": {
        baslik: "Güven Skoru",
        icerik: "Sinyalin genel güvenilirliğini özetleyen 0-100 arası bileşik bir puandır. Kapanış Şiddeti, HTF POI, Hacim, PDH/PDL, Liderlik/RS ve P/D Zone gibi alt kriterlerin ağırlıklı birleşiminden hesaplanır. 75+ Yüksek, 50-74 Orta, 50 altı Düşük güven seviyesi olarak sınıflandırılır.",
    },
    "Kapanış Şiddeti": {
        baslik: "Kapanış Şiddeti",
        icerik: "Mumun kapanışının, o mumun toplam aralığına (yüksek-düşük) göre hangi uçta gerçekleştiğini gösteren bir alt kriterdir. Güçlü bir yönde (ör. mumun tepesine yakın) kapanış, o yöndeki alım/satım baskısının güçlü olduğuna işaret eder ve Güven Skoru'na olumlu katkı sağlar.",
    },
    "HTF POI": {
        baslik: "HTF POI (Higher Timeframe Point of Interest)",
        icerik: "Daha büyük zaman diliminde (ör. günlük/haftalık) önemli bir ilgi bölgesine (destek/direnç, Order Block, FVG vb.) yakınlığı ölçen bir alt kriterdir. Fiyatın böyle bir üst zaman dilimi seviyesine yakın olması, sinyalin büyük resimle uyumlu olduğunu gösterir ve Güven Skoru'nu artırır.",
    },
    "PDH/PDL": {
        baslik: "PDH/PDL (Previous Day High/Low)",
        icerik: "Bir önceki günün en yüksek (PDH) ve en düşük (PDL) seviyeleridir. Fiyatın bu seviyelere yakınlığı veya bu seviyeleri kırıp kırmadığı, kısa vadeli işlem planlamasında önemli bir referans olarak Güven Skoru'na dahil edilir.",
    },
    "Liderlik/RS": {
        baslik: "Liderlik/RS (Relative Strength)",
        icerik: "Hissenin, genel piyasaya (endekse) veya sektörüne göre görece güç/zayıflığını ölçen bir alt kriterdir. Piyasadan daha güçlü performans gösteren (lider) hisseler, Güven Skoru'na olumlu katkı sağlar.",
    },
    "P/D Zone": {
        baslik: "P/D Zone (Premium/Discount Zone)",
        icerik: "Fiyatın güncel range içinde Premium (pahalı/üst yarı) mı yoksa Discount (ucuz/alt yarı) bölgede mi olduğunu değerlendiren bir alt kriterdir. Long sinyaller için Discount bölgede olmak, Short sinyaller için Premium bölgede olmak Güven Skoru'na olumlu katkı sağlar.",
    },
    "Hedef": {
        baslik: "Hedef Fiyat",
        icerik: "İşlem planının kâr alma hedefi olarak belirlediği fiyat seviyesidir. Genellikle bir sonraki önemli likidite/yapısal seviyeye (swing, POI, FVG vb.) göre hesaplanır.",
    },
    "Hedef Üst": {
        baslik: "Hedef Üst",
        icerik: "Hedef bölgesinin üst sınırıdır — hedef tek bir fiyat noktası değil bir aralık olarak tanımlandığında, bu aralığın üst (daha iyimser) ucunu temsil eder.",
    },
    "Stop": {
        baslik: "Stop (Stop-Loss)",
        icerik: "İşlem planının zarar durdurma seviyesidir — fiyat bu seviyeye ulaşırsa pozisyonun kapatılması önerilir, riskin sınırlandırılması amaçlanır.",
    },
    "Fark %": {
        baslik: "Fark %",
        icerik: "Güncel/simülasyon anındaki fiyat ile hedef fiyat arasındaki yüzde farktır. Bu fark, hedefe ulaşmak için fiyatın ne kadar hareket etmesi gerektiğini gösterir.",
    },
    "Min. Skor": {
        baslik: "Min. Skor",
        icerik: "Bir sinyalin listelenebilmesi için Giriş Skoru'nun en az kaç olması gerektiğini belirler. Yüksek eşik, sadece en güçlü/en çok teyit kriterini karşılayan sinyalleri listeler.",
    },
    "Skor": {
        baslik: "Skor (Giriş Skoru)",
        icerik: "Karar Motoru'nun ürettiği bileşik giriş skorudur (0-100 arası); piyasa rejimi, trend, hacim, smart money ve strateji uyumu gibi birçok alt kriterin ağırlıklı birleşiminden hesaplanır. Yüksek skor, sinyalin daha güçlü ve güvenilir olduğu anlamına gelir.",
    },
    "KM Sınıf": {
        baslik: "Sınıf",
        icerik: "Giriş Skoru'na göre belirlenen kalite kademesidir: A+ (en yüksek kalite), A, B, C gibi harflendirmelerle sinyalin genel gücünü hızlıca özetler. A+ ve A sınıfı sinyaller genellikle en güçlü teyit setine sahip olanlardır.",
    },
    "Karar": {
        baslik: "Karar",
        icerik: "Karar Motoru'nun tüm analiz bileşenlerini birleştirerek verdiği nihai öneridir (ör. 'GÜÇLÜ AL', 'AL', 'İZLE', 'SAT', 'GÜÇLÜ SAT'). Bu, sinyalin yönü ve gücü hakkında tek bakışta özet bir değerlendirme sağlar.",
    },
};

function BilgiIkonu({ alan }) {
    const [acik, setAcik] = useState(false);
    const bilgi = BILGI_ICERIK[alan];
    if (!bilgi) return null;
    return (
        <span style={{ position: "relative", display: "inline-flex", alignItems: "center", marginLeft: 4 }}>
            <span
                onMouseEnter={() => setAcik(true)}
                onMouseLeave={() => setAcik(false)}
                style={{ cursor: "help", color: "#94a3b8", fontSize: 11,
                    border: "1px solid #334155", borderRadius: "50%",
                    width: 14, height: 14, display: "inline-flex", alignItems: "center",
                    justifyContent: "center", fontWeight: 700, lineHeight: 1 }}>
                i
            </span>
            {acik && (
                <div style={{
                    position: "absolute", top: "calc(100% + 6px)", left: "50%",
                    transform: "translateX(-50%)", zIndex: 500,
                    background: "#1e293b", border: "1px solid #334155",
                    borderRadius: 10, padding: "12px 14px", width: 260,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.5)", pointerEvents: "none",
                }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color: "#3b82f6", marginBottom: 6 }}>{bilgi.baslik}</div>
                    <div style={{ fontSize: 11, color: "#94a3b8", lineHeight: 1.6, whiteSpace: "pre-line" }}>{bilgi.icerik}</div>
                </div>
            )}
        </span>
    );
}

// ─── Çoklu Tarama: Adım Kriter Formu (CokluTarama.jsx'teki ModulFiltresi ile birebir aynı) ──
const CK = { bg:"#0f172a", panel:"#1e293b", border:"#334155", text:"#e2e8f0", muted:"#94a3b8", accent:"#3b82f6", gold:"#eab308", teal:"#0d9488", bullish:"#16a34a" };
function AdimKriterFormu({ modulKey, filtre, onChange, piyasa }) {
    const dynPeriyotlar = COKLU_PERIYOT_OPTS_GLOBAL;
    const ck = (grup, key) => onChange({ ...filtre, [grup]: { ...filtre[grup], [key]: !filtre[grup][key] } });
    const set = (key, val) => onChange({ ...filtre, [key]: val });

    const CheckGrup = ({ alan, etiket }) => (
        <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
            <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>{etiket}</legend>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                {Object.keys(filtre[alan] || {}).map(k => {
                    const aktif = !!filtre[alan][k];
                    return (
                        <button key={k} type="button" onClick={() => ck(alan, k)} style={{
                            padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,
                            border:`2px solid ${aktif?CK.accent:CK.border}`,
                            background:aktif?CK.accent+"22":"transparent",
                            color:aktif?CK.accent:CK.muted,
                        }}>{k}</button>
                    );
                })}
            </div>
        </fieldset>
    );

    const Sel = ({ alan, etiket, opts, labelFn }) => (
        <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
            <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>{etiket.toUpperCase()}</legend>
            <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                {opts.map(o => {
                    const aktif = filtre[alan] === o || filtre[alan] === (isNaN(o) ? o : Number(o));
                    return (
                        <button key={o} type="button" onClick={() => set(alan, isNaN(o) ? o : Number(o))} style={{
                            padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,
                            border:`2px solid ${aktif?CK.accent:CK.border}`,
                            background:aktif?CK.accent+"22":"transparent",
                            color:aktif?CK.accent:CK.muted,
                        }}>{labelFn ? labelFn(o) : o}</button>
                    );
                })}
            </div>
        </fieldset>
    );

    switch (modulKey) {
        case "dip_tarama":
            return (<>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <div style={{display:"flex",gap:6}}>
                        {["Yıllık","6 Aylık","3 Aylık","1 Ay"].map(p=>(
                            <button key={p} type="button" onClick={()=>set("periyot",p)} style={{padding:"5px 12px",borderRadius:6,fontWeight:600,fontSize:12,cursor:"pointer",border:`2px solid ${filtre.periyot===p?CK.teal:CK.border}`,background:filtre.periyot===p?CK.teal+"22":"transparent",color:filtre.periyot===p?CK.teal:CK.muted}}>{p}</button>
                        ))}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>TOLERANS <BilgiIkonu alan="Tolerans"/></legend>
                    <div style={{display:"flex",gap:6}}>
                        {Object.keys(COKLU_TOLERANS_MAP_GLOBAL).map(t=>(
                            <button key={t} type="button" onClick={()=>set("tolerans",t)} style={{padding:"5px 12px",borderRadius:6,fontWeight:600,fontSize:12,cursor:"pointer",border:`2px solid ${filtre.tolerans===t?CK.gold:CK.border}`,background:filtre.tolerans===t?CK.gold+"22":"transparent",color:filtre.tolerans===t?CK.gold:CK.muted}}>{t}</button>
                        ))}
                    </div>
                </fieldset>
            </>);
        case "likidite":
            return (<>
                <CheckGrup alan="sweep_tipler" etiket="Sweep Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>LOOKBACK</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[50,60,75,100].map(v=>{const aktif=filtre.lookback===v;return(<button key={v} type="button" onClick={()=>set("lookback",v)} style={{padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MİN FİTİL</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[30,40,50,60,70].map(v=>{const aktif=filtre.wick_oran===v;return(<button key={v} type="button" onClick={()=>set("wick_oran",v)} style={{padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.gold:CK.border}`,background:aktif?CK.gold+"22":"transparent",color:aktif?CK.gold:CK.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "fvg": {
            const iFVGsecili = !!filtre.fvg_tipler?.["iFVG"];
            const bprAktif = iFVGsecili;
            const dipAktif = filtre.tarama_metodu === "Dip Altı Hisselerde";
            return (<>
                <CheckGrup alan="fvg_tipler" etiket="FVG Tipi" />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,opacity:bprAktif?1:0.4,pointerEvents:bprAktif?"auto":"none"}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>BPR KONTROL</legend>
                    <div style={{display:"flex",gap:6}}>
                        {["Evet","Hayır"].map(v=>{
                            const aktif = bprAktif && (v==="Evet")===!!(filtre.bpr_kontrol);
                            return(<button key={v} type="button" onClick={()=>set("bpr_kontrol",v==="Evet")} style={{padding:"4px 14px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <select value={filtre.tarama_periyot||"1 Ay"} onChange={e=>set("tarama_periyot",e.target.value)} style={{background:CK.bg,border:`1px solid ${CK.border}`,borderRadius:6,color:CK.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {dynPeriyotlar.map(p=><option key={p}>{p}</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>TARAMA METODU</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {["Dip Altı Hisselerde","Tüm Hisselerde"].map(v=>{const aktif=filtre.tarama_metodu===v;return(<button key={v} type="button" onClick={()=>set("tarama_metodu",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.teal:CK.border}`,background:aktif?CK.teal+"22":"transparent",color:aktif?CK.teal:CK.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0,opacity:dipAktif?1:0.4,pointerEvents:dipAktif?"auto":"none"}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>DİP PERİYODU</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {["Yıllık","6 Aylık","3 Aylık","1 Ay"].map(v=>{
                            const aktif = dipAktif && filtre.dip_periyodu===v;
                            return(<button key={v} type="button" onClick={()=>set("dip_periyodu",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.gold:CK.border}`,background:aktif?CK.gold+"22":"transparent",color:aktif?CK.gold:CK.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MUM SAYISI</legend>
                    <select value={filtre.mum_sayisi||100} onChange={e=>set("mum_sayisi",Number(e.target.value))} style={{background:CK.bg,border:`1px solid ${CK.border}`,borderRadius:6,color:CK.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {[25,50,100,150,200,250,300,350,400,500,600,700].map(v=><option key={v} value={v}>{v}</option>)}
                    </select>
                </fieldset>
            </>);
        }
        case "capa":
            return (<>
                <CheckGrup alan="fvg_tipler" etiket="FVG Tipi" />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>TOLERANS</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[30,50,70,80,90,100].map(v=>{const aktif=filtre.tolerans===v;return(<button key={v} type="button" onClick={()=>set("tolerans",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.gold:CK.border}`,background:aktif?CK.gold+"22":"transparent",color:aktif?CK.gold:CK.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "msb":
            return (<>
                <CheckGrup alan="msb_tipler" etiket="MSB Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>SWING PENCERESİ</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[2,3,4,5,6,7,8].map(v=>{const aktif=filtre.swing_pencere===v;return(<button key={v} type="button" onClick={()=>set("swing_pencere",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
            </>);
        case "ote":
            return (<>
                <CheckGrup alan="ote_tipler" etiket="OTE Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>SWING PENCERESİ</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[2,3,5,7].map(v=>{const aktif=filtre.swing_pencere===v;return(<button key={v} type="button" onClick={()=>set("swing_pencere",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MUM SAYISI</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[50,100,150,200,300].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "obbb":
            return (<>
                <CheckGrup alan="obbb_tipler" etiket="OB/BB Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MUM SAYISI</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300,500].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MİN GÖVDE ORANI</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[40,50,60,70].map(v=>{const aktif=filtre.govde_oran===v;return(<button key={v} type="button" onClick={()=>set("govde_oran",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.gold:CK.border}`,background:aktif?CK.gold+"22":"transparent",color:aktif?CK.gold:CK.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>SADECE TAZE</legend>
                    <button type="button" onClick={()=>set("sadece_taze",!filtre.sadece_taze)} style={{padding:"4px 14px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:filtre.sadece_taze?600:400,border:`2px solid ${filtre.sadece_taze?CK.accent:CK.border}`,background:filtre.sadece_taze?CK.accent+"22":"transparent",color:filtre.sadece_taze?CK.accent:CK.muted}}>{filtre.sadece_taze?"✅ Açık":"Kapalı"}</button>
                </fieldset>
            </>);
        case "idm":
            return (<>
                <CheckGrup alan="idm_tipler" etiket="IDM Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MUM SAYISI</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,150,200,300].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "pd":
            return (<>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>BÖLGE</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {Object.keys(filtre.bolge_filtre||{}).map(k=>{
                            const aktif=!!filtre.bolge_filtre[k];
                            return(<button key={k} type="button" onClick={()=>set("bolge_filtre",{...filtre.bolge_filtre,[k]:!filtre.bolge_filtre[k]})} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{k}</button>);
                        })}
                    </div>
                </fieldset>
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>RANGE PENCERESİ</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[10,20,50,100].map(v=>{const aktif=filtre.range_window===v;return(<button key={v} type="button" onClick={()=>set("range_window",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.teal:CK.border}`,background:aktif?CK.teal+"22":"transparent",color:aktif?CK.teal:CK.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MUM SAYISI</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300,500].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "smt":
            return (<>
                <CheckGrup alan="smt_tipler" etiket="SMT Tipi" />
                <Sel alan="tarama_periyot" etiket="Periyot" opts={dynPeriyotlar} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>SWING PENCERESİ</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[2,3,5].map(v=>{const aktif=filtre.swing_pencere===v;return(<button key={v} type="button" onClick={()=>set("swing_pencere",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v} Mum</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>REFERANS VARLIK</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {(piyasa === "BIST" ? ["XU100 (BIST100)","XU030 (BIST30)"] : ["BTC","ETH","BNB"]).map(v => {
                            const aktif = filtre.referans_varlik === v;
                            return(<button key={v} type="button" onClick={()=>set("referans_varlik",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MİN KORELASYON</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[50,60,70,80,90].map(v=>{const aktif=filtre.min_korelasyon===v;return(<button key={v} type="button" onClick={()=>set("min_korelasyon",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>%{v}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MUM SAYISI</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        case "killzone":
            return (<>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>KILLZONE</legend>
                    <select value={filtre.killzoneler ? Object.keys(filtre.killzoneler).find(k=>filtre.killzoneler[k])||"" : ""} onChange={e=>{const yeni={};COKLU_KZ_LISTESI_GLOBAL.forEach(k=>yeni[k]=false);if(e.target.value)yeni[e.target.value]=true;set("killzoneler",yeni);}} style={{background:CK.bg,border:`1px solid ${CK.border}`,borderRadius:6,color:CK.text,padding:"5px 10px",fontSize:12,cursor:"pointer",minWidth:220}}>
                        {COKLU_KZ_LISTESI_GLOBAL.map(k=><option key={k} value={k}>{k}</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>YAPI TİPİ</legend>
                    <div style={{display:"flex",gap:6}}>
                        {["FVG","MSB","Sweep"].map(v=>{
                            const aktif = filtre.yapi_tipi === v;
                            return(<button key={v} type="button" onClick={()=>set("yapi_tipi",v)} style={{padding:"4px 12px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>GERİYE BAKIŞ</legend>
                    <div style={{display:"flex",gap:6}}>
                        {[3,5,7,10].map(v=>{const aktif=filtre.geri_bak_gun===v;return(<button key={v} type="button" onClick={()=>set("geri_bak_gun",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.teal:CK.border}`,background:aktif?CK.teal+"22":"transparent",color:aktif?CK.teal:CK.muted}}>{v} Gün</button>);})}
                    </div>
                </fieldset>
            </>);
        case "topdown":
            return <div style={{fontSize:12,color:"#94a3b8"}}>{piyasa} — EMA200 + 4H Sweep taraması (ek kriter yok)</div>;
        case "hacim_profili": {
            const HP_SINYALLER = ["POC Yakını","Discount","Premium","HVN Yakın","LVN İçi"];
            return (<>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <select value={filtre.tarama_periyot||"1 Gün"} onChange={e=>set("tarama_periyot",e.target.value)} style={{background:CK.bg,border:`1px solid ${CK.border}`,borderRadius:6,color:CK.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {dynPeriyotlar.map(p=><option key={p}>{p}</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>SİNYAL FİLTRESİ</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {HP_SINYALLER.map(v=>{
                            const sf = filtre.sinyal_filtre || [];
                            const aktif = Array.isArray(sf) ? sf.includes(v) : !!sf[v];
                            return(<button key={v} type="button" onClick={()=>{const cur=Array.isArray(filtre.sinyal_filtre)?filtre.sinyal_filtre:[];set("sinyal_filtre",aktif?cur.filter(x=>x!==v):[...cur,v]);}} style={{padding:"4px 10px",borderRadius:20,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);
                        })}
                    </div>
                </fieldset>
                <Sel alan="min_skor" etiket="Min Skor" opts={[0,2,3,4,5,6,7]} labelFn={v=>v===0?"Tümü":`≥${v}`} />
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MUM SAYISI</legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {[100,200,300,500].map(v=>{const aktif=filtre.mum_sayisi===v;return(<button key={v} type="button" onClick={()=>set("mum_sayisi",v)} style={{padding:"4px 10px",borderRadius:20,fontSize:12,cursor:"pointer",fontWeight:aktif?600:400,border:`2px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":"transparent",color:aktif?CK.accent:CK.muted}}>{v}</button>);})}
                    </div>
                </fieldset>
            </>);
        }
        case "hacim_akisi": {
            const HA_SINYAL_RENK = {"📈 Güçlü Alım":"#16a34a","🔶 Orta Alım":"#84cc16","⬇️ Zayıf Alım":"#a3e635","📉 Güçlü Satım":"#dc2626","🔶 Orta Satım":"#f97316","⬆️ Zayıf Satım":"#fca5a5","⚖️ Belirsiz":"#9ca3af"};
            const haSinyalFiltre = filtre.sinyal_filtre || {};
            const toggleHA = sn => { const sf = typeof haSinyalFiltre === "object" && !Array.isArray(haSinyalFiltre) ? haSinyalFiltre : {}; set("sinyal_filtre", {...sf, [sn]:!sf[sn]}); };
            return (<>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>ORT. PENCERE (GÜN)</legend>
                    <select value={filtre.lookback||20} onChange={e=>set("lookback",Number(e.target.value))} style={{background:CK.bg,border:`1px solid ${CK.border}`,borderRadius:6,color:CK.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {[5,10,20,30,40,50].map(v=><option key={v} value={v}>{v} Gün</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>MİN. SPİKE (×ORT.)</legend>
                    <input type="number" value={filtre.min_spike||1.5} min={1.0} max={10} step={0.1} onChange={e=>set("min_spike",parseFloat(e.target.value))} style={{background:CK.bg,border:`1px solid ${CK.border}`,borderRadius:6,color:CK.text,padding:"5px 10px",fontSize:12,width:80}}/>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>SİNYAL TİPİ</legend>
                    <div style={{display:"flex",gap:8}}>
                        <div style={{background:CK.bg,border:"1px solid #16a34a55",borderRadius:6,padding:"6px 10px"}}>
                            <div style={{fontSize:10,fontWeight:700,color:"#16a34a",marginBottom:4}}>📈 ALIMLAR</div>
                            {["📈 Güçlü Alım","🔶 Orta Alım","⬇️ Zayıf Alım","⚖️ Belirsiz"].map(sn=>{
                                const aktif=!!(typeof haSinyalFiltre==="object"&&!Array.isArray(haSinyalFiltre)?haSinyalFiltre[sn]:Array.isArray(haSinyalFiltre)&&haSinyalFiltre.includes(sn));
                                return(<button key={sn} type="button" onClick={()=>toggleHA(sn)} style={{display:"block",width:"100%",textAlign:"left",padding:"3px 6px",borderRadius:6,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_SINYAL_RENK[sn]+"22":"transparent",border:`1px solid ${aktif?HA_SINYAL_RENK[sn]:CK.border}`,color:aktif?HA_SINYAL_RENK[sn]:CK.muted}}>{sn}</button>);
                            })}
                        </div>
                        <div style={{background:CK.bg,border:"1px solid #dc262655",borderRadius:6,padding:"6px 10px"}}>
                            <div style={{fontSize:10,fontWeight:700,color:"#dc2626",marginBottom:4}}>📉 SATIMLAR</div>
                            {["📉 Güçlü Satım","🔶 Orta Satım","⬆️ Zayıf Satım"].map(sn=>{
                                const aktif=!!(typeof haSinyalFiltre==="object"&&!Array.isArray(haSinyalFiltre)?haSinyalFiltre[sn]:Array.isArray(haSinyalFiltre)&&haSinyalFiltre.includes(sn));
                                return(<button key={sn} type="button" onClick={()=>toggleHA(sn)} style={{display:"block",width:"100%",textAlign:"left",padding:"3px 6px",borderRadius:6,marginBottom:2,cursor:"pointer",fontSize:11,fontWeight:aktif?700:400,background:aktif?HA_SINYAL_RENK[sn]+"22":"transparent",border:`1px solid ${aktif?HA_SINYAL_RENK[sn]:CK.border}`,color:aktif?HA_SINYAL_RENK[sn]:CK.muted}}>{sn}</button>);
                            })}
                        </div>
                    </div>
                </fieldset>
            </>);
        }
        case "divergence": {
            const DIV_OSC = ["RSI","MACD Histogram","Stokastik RSI","OBV"];
            const DIV_TIPLER = [
                {key:"Regular Bullish",ikon:"📈",renk:"#16a34a",label:"Regular Bullish"},
                {key:"Regular Bearish",ikon:"📉",renk:"#dc2626",label:"Regular Bearish"},
                {key:"Hidden Bullish",ikon:"🔼",renk:"#06b6d4",label:"Hidden Bullish"},
                {key:"Hidden Bearish",ikon:"🔽",renk:"#f59e0b",label:"Hidden Bearish"},
            ];
            const divOsc = filtre.osilatorler || {};
            const divTip = filtre.divergence_tipleri || {};
            const toggleOsc = o => set("osilatorler", {...divOsc, [o]:!divOsc[o]});
            const toggleTip = t => set("divergence_tipleri", {...divTip, [t]:!divTip[t]});
            return (<>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em"}}>PERİYOT</legend>
                    <select value={filtre.tarama_periyot||"1 Gün"} onChange={e=>set("tarama_periyot",e.target.value)} style={{background:CK.bg,border:`1px solid ${CK.border}`,borderRadius:6,color:CK.text,padding:"5px 10px",fontSize:12,cursor:"pointer"}}>
                        {dynPeriyotlar.map(p=><option key={p}>{p}</option>)}
                    </select>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>PİVOT MODU <BilgiIkonu alan="Pivot Modu"/></legend>
                    <div style={{display:"flex",gap:6}}>
                        {[["fractal","Fractal"],["zigzag","ZigZag"]].map(([v,l])=>{
                            const aktif=(filtre.pivot_modu||"fractal")===v;
                            return(<button key={v} type="button" onClick={()=>set("pivot_modu",v)} style={{padding:"5px 12px",borderRadius:8,fontSize:12,fontWeight:600,cursor:"pointer",border:`1px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"22":CK.bg,color:aktif?CK.accent:CK.muted}}>{l}</button>);
                        })}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>OSİLATÖRLER <BilgiIkonu alan="Osilatörler"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {DIV_OSC.map(o=>{const aktif=!!divOsc[o];return(<button key={o} type="button" onClick={()=>toggleOsc(o)} style={{padding:"5px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?CK.accent:CK.border}`,background:aktif?CK.accent+"18":CK.bg,color:aktif?CK.accent:CK.muted}}>{o}</button>);})}
                    </div>
                </fieldset>
                <fieldset style={{border:`1px solid ${CK.border}`,borderRadius:8,padding:"6px 12px 10px",margin:0}}>
                    <legend style={{fontSize:11,color:CK.muted,fontWeight:600,padding:"0 4px",letterSpacing:"0.05em",display:"flex",alignItems:"center",gap:4}}>DIVERGENCE TİPLERİ <BilgiIkonu alan="Divergence Tipleri"/></legend>
                    <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
                        {DIV_TIPLER.map(t=>{const aktif=!!divTip[t.key];return(<button key={t.key} type="button" onClick={()=>toggleTip(t.key)} style={{padding:"5px 10px",borderRadius:8,fontSize:11,cursor:"pointer",fontWeight:aktif?600:400,border:`1px solid ${aktif?t.renk:CK.border}`,background:aktif?t.renk+"18":CK.bg,color:aktif?t.renk:CK.muted}}>{t.ikon} {t.label}</button>);})}
                    </div>
                </fieldset>
            </>);
        }
        default:
            return null;
    }
}

// ─── Hareketli Yükleme Çubuğu ────────────────────────────────────────────────
function HareketliBar() {
    const [offset, setOffset] = useState(0);
    useEffect(() => {
        const id = setInterval(() => setOffset(o => (o+3)%200), 20);
        return () => clearInterval(id);
    }, []);
    const pos = offset<=100 ? offset-100 : 200-offset-100;
    return (
        <div style={{height:8,background:"#0f172a",borderRadius:4,overflow:"hidden",
            border:"1px solid #334155",marginBottom:16,position:"relative"}}>
            <div style={{position:"absolute",top:0,height:"100%",width:"40%",
                left:`${50+pos*0.5}%`,
                background:"linear-gradient(90deg,transparent,#3b82f6,#06b6d4,#3b82f6,transparent)",
                borderRadius:4}}/>
        </div>
    );
}

// ─── İlerleme Paneli ─────────────────────────────────────────────────────────
function TaramaIlerlemePaneli({ilerleme,tamamlanan,toplam,bulunan,gecen,tahminiSure,adimBilgi}) {
    const fmt = sn => {
        if(!sn||sn<=0) return "—";
        const m=Math.floor(sn/60),s=sn%60;
        return m===0?`${s}s`:`${String(m).padStart(2,"0")}:${String(s).padStart(2,"0")}`;
    };
    let kalan = tahminiSure||null;
    if(!kalan&&tamamlanan>0&&gecen>0&&toplam>0)
        kalan = Math.round((gecen/tamamlanan)*(toplam-tamamlanan));
    return (
        <div style={{marginBottom:16,background:"#1e293b",border:"2px solid #3b82f644",
            borderRadius:12,padding:20,boxShadow:"0 0 20px #3b82f618"}}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
                <span style={{fontSize:20}}>🔮</span>
                <span style={{fontSize:15,fontWeight:700,color:"#e2e8f0"}}>
                    Geçmiş Simülasyonu Çalışıyor{adimBilgi ? ` : ${adimBilgi.mevcut}/${adimBilgi.toplam}` : ""}
                </span>
                <span style={{marginLeft:"auto",fontSize:22,fontWeight:800,color:"#3b82f6"}}>%{ilerleme}</span>
            </div>
            <div style={{height:10,background:"#0f172a",borderRadius:6,overflow:"hidden",
                marginBottom:10,border:"1px solid #334155"}}>
                <div style={{height:"100%",width:`${ilerleme}%`,
                    background:"linear-gradient(90deg,#3b82f6,#06b6d4)",
                    borderRadius:6,transition:"width 0.5s ease"}}/>
            </div>
            <div style={{display:"flex",gap:24,flexWrap:"wrap"}}>
                <div>
                    <div style={{fontSize:10,color:"#94a3b8",marginBottom:2}}>TAMAMLANAN</div>
                    <div style={{fontSize:16,fontWeight:700,color:"#3b82f6"}}>
                        {toplam>0?`${tamamlanan.toLocaleString("tr-TR")} / ${toplam.toLocaleString("tr-TR")}`:"—"}
                    </div>
                </div>
                <div>
                    <div style={{fontSize:10,color:"#94a3b8",marginBottom:2}}>BULUNAN</div>
                    <div style={{fontSize:16,fontWeight:700,color:"#16a34a"}}>
                        {bulunan>0?bulunan.toLocaleString("tr-TR"):"—"}
                    </div>
                </div>
                <div>
                    <div style={{fontSize:10,color:"#94a3b8",marginBottom:2}}>GEÇEN SÜRE</div>
                    <div style={{fontSize:16,fontWeight:700,color:"#0d9488"}}>{fmt(gecen)}</div>
                </div>
                <div>
                    <div style={{fontSize:10,color:"#94a3b8",marginBottom:2}}>TAHMİNİ KALAN</div>
                    <div style={{fontSize:16,fontWeight:700,color:"#eab308"}}>
                        {kalan!=null?fmt(kalan):(tamamlanan===0?"Hesaplanıyor...":"—")}
                    </div>
                </div>
            </div>
        </div>
    );
}

// --- İndir Alt Menüsü ---
function IndirAltMenu({ onExcel, onCsv, onPdf, onSvg }) {
    const [acik, setAcik] = useState(false);
    return (
        <div style={{ position: "relative" }} onMouseEnter={() => setAcik(true)} onMouseLeave={() => setAcik(false)}>
            <button style={{ display: "flex", width: "100%", textAlign: "left", justifyContent: "space-between",
                padding: "10px 14px", border: "none", background: "none", cursor: "pointer",
                color: "#e2e8f0", fontSize: 13, borderBottom: "1px solid #334155" }}>
                📥 İndir <span style={{ color: "#94a3b8" }}>▶</span>
            </button>
            {acik && (
                <div style={{ position: "absolute", left: "100%", top: 0, background: "#1e293b",
                    border: "1px solid #334155", borderRadius: 8,
                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)", minWidth: 160, overflow: "hidden", zIndex: 101 }}>
                    {[
                        { l: "Excel (.xlsx)", fn: onExcel },
                        { l: "CSV (.csv)",    fn: onCsv   },
                        { l: "PDF (.pdf)",    fn: onPdf   },
                        { l: "SVG (.svg)",    fn: onSvg   },
                    ].map(b => (
                        <button key={b.l} onClick={b.fn}
                            style={{ display: "block", width: "100%", textAlign: "left", padding: "9px 14px",
                                border: "none", background: "none", cursor: "pointer", color: "#e2e8f0", fontSize: 13,
                                borderBottom: "1px solid #334155" }}>{b.l}</button>
                    ))}
                </div>
            )}
        </div>
    );
}

const COKLU_PERIYOT_OPTS_GLOBAL = ["1 Gün","1 Hafta","1 Ay","3 Aylık","6 Aylık","Yıllık"];
const COKLU_TOLERANS_MAP_GLOBAL = {"%1":0.01,"%3":0.03,"%5":0.05};
const COKLU_KZ_LISTESI_GLOBAL = ["Asya KZ (03:00-09:00)","Londra Açılış (10:00-12:00)","New York Açılış (15:00-17:00)","Londra Kapanış (18:00-20:00)","BIST Açılış (10:00-11:00)","BIST Öğle Dönüşü (13:00-14:00)","BIST Kapanış Öncesi (17:00-18:00)"];

const HA_SKOR_ARALIKLARI = [
    { label: "0-25",   min: 0,  max: 25 },
    { label: "26-50",  min: 26, max: 50 },
    { label: "51-74",  min: 51, max: 74 },
    { label: "75-100", min: 75, max: 100 },
];
const SUREKLILIK_ARALIKLARI = [
    { label: "0-1 Gün", min: 0, max: 1 },
    { label: "2-4 Gün", min: 2, max: 4 },
    { label: "5-7 Gün", min: 5, max: 7 },
    { label: "8+ Gün",  min: 8, max: Infinity },
];

export default function GecmisSimulasyon() {
    const location    = useLocation();
    const gelenParams = location.state || null;

    // ---- Modül seçimi (state — kullanıcı sayfada değiştirebilir) ----
    const [kaynak, setKaynak] = useState(gelenParams?.kaynak || "dip_tarama");

    // ---- Çoklu Tarama (kademeli zincir) — CokluTarama.jsx ile birebir aynı kriterler ----
    const COKLU_MODUL_OPTS = [
        { key: "dip_tarama",    etiket: "📊 Dip Tarama" },
        { key: "likidite",      etiket: "🌊 Likidite Tarama" },
        { key: "fvg",           etiket: "📈 FVG Tarama" },
        { key: "capa",          etiket: "⚓ Çapa Noktası Tarama" },
        { key: "msb",           etiket: "📐 MSB Tarama" },
        { key: "ote",           etiket: "🎯 OTE Tarama" },
        { key: "obbb",          etiket: "🧱 OB/BB Tarama" },
        { key: "idm",           etiket: "🎣 IDM Tarama" },
        { key: "pd",            etiket: "⚖️ P/D Zone Tarama" },
        { key: "smt",           etiket: "🔀 SMT Tarama" },
        { key: "killzone",      etiket: "⏰ Killzone Tarama" },
        { key: "topdown",       etiket: "🎯 Topdown Cascade" },
        { key: "hacim_profili", etiket: "📊 Hacim Profili" },
        { key: "hacim_akisi",   etiket: "🌊 Hacim Akışı" },
        { key: "divergence",    etiket: "📐 Divergence" },
    ];
    const COKLU_PERIYOT_MAP = {"1 Gün":"1d","1 Hafta":"1wk","1 Ay":"1mo","3 Aylık":"3mo","6 Aylık":"6mo","Yıllık":"1y"};
    const COKLU_DIP_PERIYOT_MAP = {"1 Ay":"ay","3 Aylık":"ceyrek","6 Aylık":"yari","Yıllık":"yil"};
    const COKLU_TOLERANS_MAP = {"%1":0.01,"%3":0.03,"%5":0.05};

    // CokluTarama.jsx'teki defaultFiltreler ile birebir aynı
    const cokluDefaultFiltreler = (modulKey, piyasaVal) => {
        switch (modulKey) {
            case "dip_tarama":    return { periyot: "Yıllık", tolerans: "%3" };
            case "likidite":      return { sweep_tipler: { "Boğa Sweep": true, "Ayı Sweep": false }, tarama_periyot: "1 Gün", lookback: 50, wick_oran: 50 };
            case "fvg":           return { fvg_tipler: { "Boğa FVG": true, "Ayı FVG": false, "iFVG": false }, bpr_kontrol: false, tarama_periyot: "1 Ay", tarama_metodu: "Dip Altı Hisselerde", dip_periyodu: "Yıllık", mum_sayisi: 100 };
            case "capa":          return { fvg_tipler: { "Boğa FVG": true, "Ayı FVG": false }, tolerans: 50 };
            case "msb":           return { msb_tipler: { "Boğa MSB": true, "Ayı MSB": false }, tarama_periyot: "1 Ay", swing_pencere: 3 };
            case "ote":           return { ote_tipler: { "Boğa OTE": true, "Ayı OTE": false }, tarama_periyot: "1 Ay", swing_pencere: 3, mum_sayisi: 100 };
            case "obbb":          return { obbb_tipler: { "Boğa OB": true, "Ayı OB": false, "Boğa BB": false, "Ayı BB": false }, tarama_periyot: "1 Gün", mum_sayisi: 200, govde_oran: 60, sadece_taze: true };
            case "idm":           return { idm_tipler: { "Boğa IDM": true, "Ayı IDM": false }, tarama_periyot: "1 Gün", mum_sayisi: 200 };
            case "pd":            return { bolge_filtre: { "Discount": true, "Equilibrium": false, "Premium": false }, tarama_periyot: "1 Gün", range_window: 20, mum_sayisi: 200 };
            case "smt":           return { smt_tipler: { "Boğa SMT": true, "Ayı SMT": false }, tarama_periyot: "1 Gün", referans_varlik: piyasaVal === "BIST" ? "XU100 (BIST100)" : "BTC", swing_pencere: 3, min_korelasyon: 70, mum_sayisi: 200 };
            case "killzone":      return { killzoneler: { "Londra Açılış (10:00-12:00)": true }, yapi_tipi: "FVG", geri_bak_gun: 5 };
            case "topdown":       return {};
            case "hacim_profili": return { tarama_periyot: "1 Gün", min_skor: 0, mum_sayisi: 300, sinyal_filtre: [] };
            case "hacim_akisi":   return { lookback: 20, min_spike: 1.5, sinyal_filtre: {"📈 Güçlü Alım":true,"🔶 Orta Alım":true,"⬇️ Zayıf Alım":false,"📉 Güçlü Satım":true,"🔶 Orta Satım":true,"⬆️ Zayıf Satım":false,"⚖️ Belirsiz":false} };
            case "divergence":    return { tarama_periyot: "1 Gün", pivot_modu: "fractal", osilatorler: {"RSI":true,"MACD Histogram":true,"Stokastik RSI":true,"OBV":false}, divergence_tipleri: {"Regular Bullish":true,"Regular Bearish":true,"Hidden Bullish":false,"Hidden Bearish":false}, swing_pencere:5, zigzag_esik:1, n_son_pivot:2, min_pivot_mesafe:3, min_hareket_atr:0, rsi_periyot:14, macd_fast:12, macd_slow:26, macd_signal:9, stoch_rsi_periyot:14, stoch_periyot:14, stoch_k:3, stoch_d:3, ayarlar_acik:false };
            default: return {};
        }
    };

    // Kriter formundaki (Türkçe etiketli) filtre objesini, backend run_gecmis_sim_* fonksiyonlarının
    // beklediği kwarg isimlerine çevirir (bu isimler GecmisSimulasyon'un kendi tek-modül akışlarında
    // zaten doğrulanmış/kullanılan isimlerle birebir aynı)
    const buildAdimParams = (modulKey, filtre) => {
        switch (modulKey) {
            case "dip_tarama":
                return { periyot: COKLU_DIP_PERIYOT_MAP[filtre.periyot] || "yil", tolerans: COKLU_TOLERANS_MAP[filtre.tolerans] ?? 0.03 };
            case "likidite":
                return {
                    tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1d",
                    sweep_tipler: Object.keys(filtre.sweep_tipler || {}).filter(k => filtre.sweep_tipler[k]),
                    lookback: filtre.lookback, wick_oran: filtre.wick_oran / 100,
                };
            case "fvg":
                return {
                    tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1mo",
                    fvg_tipler: Object.keys(filtre.fvg_tipler || {}).filter(k => filtre.fvg_tipler[k]),
                    mum_sayisi: filtre.mum_sayisi,
                    dip_periyot: filtre.tarama_metodu === "Dip Altı Hisselerde" ? (COKLU_DIP_PERIYOT_MAP[filtre.dip_periyodu] || "yil") : null,
                    tarama_metodu: filtre.tarama_metodu || "Tüm Hisselerde",
                    bpr_kontrol: filtre.bpr_kontrol === true || filtre.bpr_kontrol === "Evet",
                };
            case "capa":
                return { fvg_tipler: Object.keys(filtre.fvg_tipler || {}).filter(k => filtre.fvg_tipler[k]), tolerans: filtre.tolerans / 100 };
            case "msb":
                return { msb_tipler: Object.keys(filtre.msb_tipler || {}).filter(k => filtre.msb_tipler[k]), tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1mo", swing_pencere: filtre.swing_pencere };
            case "ote":
                return { ote_tipler: Object.keys(filtre.ote_tipler || {}).filter(k => filtre.ote_tipler[k]), tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1mo", swing_pencere: filtre.swing_pencere, mum_sayisi: filtre.mum_sayisi };
            case "obbb":
                return { obbb_tipler: Object.keys(filtre.obbb_tipler || {}).filter(k => filtre.obbb_tipler[k]), tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1d", mum_sayisi: filtre.mum_sayisi, govde_oran: filtre.govde_oran / 100, sadece_taze: filtre.sadece_taze };
            case "idm":
                return { idm_tipler: Object.keys(filtre.idm_tipler || {}).filter(k => filtre.idm_tipler[k]), tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1d", mum_sayisi: filtre.mum_sayisi };
            case "pd":
                return { bolge_filtre: Object.keys(filtre.bolge_filtre || {}).filter(k => filtre.bolge_filtre[k]), tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1d", range_window: filtre.range_window, mum_sayisi: filtre.mum_sayisi };
            case "smt":
                return { smt_tipler: Object.keys(filtre.smt_tipler || {}).filter(k => filtre.smt_tipler[k]), tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1d", referans_varlik: filtre.referans_varlik, swing_pencere: filtre.swing_pencere, min_korelasyon: filtre.min_korelasyon / 100, mum_sayisi: filtre.mum_sayisi };
            case "killzone":
                return { killzoneler: Object.keys(filtre.killzoneler || {}).filter(k => filtre.killzoneler[k]), yapi_tipleri: [filtre.yapi_tipi].filter(Boolean), geri_bak_gun: filtre.geri_bak_gun };
            case "topdown":
                return {};
            case "hacim_profili": {
                const sf = filtre.sinyal_filtre || [];
                return { tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1d", min_skor: filtre.min_skor || 0, mum_sayisi: filtre.mum_sayisi || 300, sinyal_filtre: Array.isArray(sf) ? sf : Object.keys(sf).filter(k => sf[k]) };
            }
            case "hacim_akisi": {
                const sf = filtre.sinyal_filtre || {};
                return { lookback: filtre.lookback || 20, min_spike: filtre.min_spike || 1.5, sinyal_filtre: Array.isArray(sf) ? sf : Object.keys(sf).filter(k => sf[k]) };
            }
            case "divergence": {
                const osc = filtre.osilatorler || {};
                const tip = filtre.divergence_tipleri || {};
                return {
                    tarama_periyot: COKLU_PERIYOT_MAP[filtre.tarama_periyot] || "1d",
                    pivot_modu: filtre.pivot_modu || "fractal",
                    osilatorler: Array.isArray(osc) ? osc : Object.keys(osc).filter(k => osc[k]),
                    divergence_tipleri: Array.isArray(tip) ? tip : Object.keys(tip).filter(k => tip[k]),
                    swing_pencere: filtre.swing_pencere || 5,
                    zigzag_esik: filtre.zigzag_esik || 1,
                    n_son_pivot: filtre.n_son_pivot || 2,
                    min_pivot_mesafe: filtre.min_pivot_mesafe || 3,
                    min_hareket_atr: filtre.min_hareket_atr || 0,
                    mum_sayisi: filtre.mum_sayisi || 300,
                };
            }
            default: return {};
        }
    };

    const [cokluAdimlar, setCokluAdimlar] = useState([{ modul_key: "dip_tarama", filtre: cokluDefaultFiltreler("dip_tarama", "BIST") }]);
    const cokluAdimEkle = () => {
        if (cokluAdimlar.length >= 15) { toast.error("En fazla 15 adım eklenebilir"); return; }
        const kullanilan = new Set(cokluAdimlar.map(a => a.modul_key));
        const sonraki = COKLU_MODUL_OPTS.find(m => !kullanilan.has(m.key)) || COKLU_MODUL_OPTS[0];
        setCokluAdimlar(prev => [...prev, { modul_key: sonraki.key, filtre: cokluDefaultFiltreler(sonraki.key, piyasa) }]);
    };
    const cokluAdimKaldir = (idx) => setCokluAdimlar(prev => prev.filter((_, i) => i !== idx));
    const cokluAdimGuncelle = (idx, modul_key) =>
        setCokluAdimlar(prev => prev.map((a, i) => i === idx ? { modul_key, filtre: cokluDefaultFiltreler(modul_key, piyasa) } : a));
    const cokluFiltreGuncelle = (idx, yeniFiltre) =>
        setCokluAdimlar(prev => prev.map((a, i) => i === idx ? { ...a, filtre: yeniFiltre } : a));


    // ---- Ortak filtre state'leri ----
    const [piyasa,     setPiyasa]     = useState(
        gelenParams?.mod === "Kripto" ? "Kripto" : (gelenParams?.mod || "BIST")
    );
    const [paraBirimi, setParaBirimi] = useState(gelenParams?.para_birimi || "USD");

    // Simülasyon tarihi — varsayılan: 1 yıl önce
    const _defaultSimTarih = (() => {
        const d = new Date();
        d.setFullYear(d.getFullYear() - 1);
        return d.toISOString().split("T")[0];
    })();
    const [simTarihi, setSimTarihi] = useState(
        gelenParams?.sim_tarihi || _defaultSimTarih
    );

    // ---- Dip Tarama'ya özgü filtreler ----
    // periyotLabel artık DB formatında geliyor ("1 Yıl", "6 Ay" vb.)
    // Eski format ("Yıllık" vb.) gönderilmişse normalize et
    const _initPeriyot = (() => {
        const p = gelenParams?.periyotLabel;
        if (!p) return "1 Yıl";
        const eskiYeni = { "Yıllık": "1 Yıl", "6 Aylık": "6 Ay", "3 Aylık": "3 Ay", "Aylık": "1 Ay" };
        return eskiYeni[p] || p;
    })();
    const [periyot,  setPeriyot]  = useState(_initPeriyot);
    const [tolerans, setTolerans] = useState(gelenParams?.toleransLabel || "%5");

    // ---- Likidite Tarama'ya özgü filtreler ----
    const LIKIDITE_PERIYOT_MAP = {
        "1 Gün": "1d", "1 Hafta": "1wk", "1 Ay": "1mo",
        "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const [likPeriyot,    setLikPeriyot]    = useState(gelenParams?.tarama_periyot_label || "1 Gün");
    const [likSweepBoga,  setLikSweepBoga]  = useState(
        gelenParams?.sweep_tipler ? gelenParams.sweep_tipler.includes("Boğa Sweep") : true
    );
    const [likSweepAyi,   setLikSweepAyi]   = useState(
        gelenParams?.sweep_tipler ? gelenParams.sweep_tipler.includes("Ayı Sweep") : false
    );
    const [likLookback,   setLikLookback]   = useState(gelenParams?.lookback  || 50);
    const [likWickOran,   setLikWickOran]   = useState(
        gelenParams?.wick_oran ? Math.round(gelenParams.wick_oran * 100) : 50
    );

    // ---- FVG Tarama'ya özgü filtreler ----
    const FVG_PERIYOT_MAP = {
        "15 Dakika": "15m", "1 Saat": "1h", "4 Saat": "4h",
        "1 Gün": "1d", "1 Hafta": "1wk", "1 Ay": "1mo",
        "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const [fvgPeriyot,    setFvgPeriyot]    = useState(gelenParams?.tarama_periyot_label || "1 Gün");
    const [fvgBoga,       setFvgBoga]       = useState(gelenParams?.fvg_tipler ? gelenParams.fvg_tipler.includes("Boğa FVG") : true);
    const [fvgAyi,        setFvgAyi]        = useState(gelenParams?.fvg_tipler ? gelenParams.fvg_tipler.includes("Ayı FVG")  : false);
    const [fvgIfvg,       setFvgIfvg]       = useState(gelenParams?.fvg_tipler ? gelenParams.fvg_tipler.includes("iFVG")     : false);
    const [fvgMumSayisi,  setFvgMumSayisi]  = useState(gelenParams?.mum_sayisi   || 400);
    const [fvgDipPeriyot, setFvgDipPeriyot] = useState(gelenParams?.dip_periyot  || "Yıllık");
    const [fvgMetodu,     setFvgMetodu]     = useState(gelenParams?.tarama_metodu || "Dip Altı Hisselerde");
    // Tarama Metodu'na göre Dip Periyodu'nu otomatik ayarla
    useEffect(() => {
        if (fvgMetodu === "Dip Altı Hisselerde") setFvgDipPeriyot("Yıllık");
    }, [fvgMetodu]);
    const [fvgBpr,        setFvgBpr]        = useState(gelenParams?.bpr_kontrol ?? true);

    // BPR Kontrol: FVG Tipi'nde iFVG, Boğa/Ayı FVG ile birlikte seçiliyse aktif olsun ve "Evet" gelsin
    const fvgBprAktif = fvgIfvg && (fvgBoga || fvgAyi);
    useEffect(() => {
        if (fvgBprAktif) setFvgBpr(true);
        else setFvgBpr(false);
    }, [fvgBprAktif]);

    // ---- MSB Tarama'ya özgü filtreler ----
    const [msbBoga,         setMsbBoga]         = useState(gelenParams?.msb_tipler ? gelenParams.msb_tipler.includes("Boğa MSB") : true);
    const [msbAyi,          setMsbAyi]          = useState(gelenParams?.msb_tipler ? gelenParams.msb_tipler.includes("Ayı MSB")  : false);
    const [msbSwingPencere, setMsbSwingPencere] = useState(gelenParams?.swing_pencere || 3);
    const MSB_PERIYOT_MAP = {
        "1 Hafta": "1wk", "1 Ay": "1mo", "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const [msbPeriyot,      setMsbPeriyot]      = useState(gelenParams?.tarama_periyot_label || "1 Ay");

    // ---- OTE Tarama'ya özgü filtreler ----
    const OTE_PERIYOT_MAP = {
        "1 Hafta": "1wk", "1 Ay": "1mo", "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const [oteBoga,         setOteBoga]         = useState(gelenParams?.ote_tipler ? gelenParams.ote_tipler.includes("Boğa OTE") : true);
    const [oteAyi,          setOteAyi]          = useState(gelenParams?.ote_tipler ? gelenParams.ote_tipler.includes("Ayı OTE")  : false);
    const [otePeriyot,      setOtePeriyot]      = useState(gelenParams?.tarama_periyot_label || "1 Ay");
    const [oteSwing,        setOteSwing]        = useState(gelenParams?.swing_pencere || 3);
    const [oteMumSayisi,    setOteMumSayisi]    = useState(gelenParams?.mum_sayisi   || 100);

    // ---- OB/BB Tarama'ya özgü filtreler ----
    const OBBB_PERIYOT_MAP = {
        "1 Gün": "1d", "1 Hafta": "1wk", "1 Ay": "1mo",
        "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const [obbbBogaOB,    setObbbBogaOB]    = useState(gelenParams?.obbb_tipler ? gelenParams.obbb_tipler.includes("Boğa OB") : true);
    const [obbbAyiOB,     setObbbAyiOB]     = useState(gelenParams?.obbb_tipler ? gelenParams.obbb_tipler.includes("Ayı OB")  : false);
    const [obbbBogaBB,    setObbbBogaBB]    = useState(gelenParams?.obbb_tipler ? gelenParams.obbb_tipler.includes("Boğa BB") : false);
    const [obbbAyiBB,     setObbbAyiBB]     = useState(gelenParams?.obbb_tipler ? gelenParams.obbb_tipler.includes("Ayı BB")  : false);
    const [obbbPeriyot,   setObbbPeriyot]   = useState(gelenParams?.tarama_periyot_label || "1 Gün");
    const [obbbMumSayisi, setObbbMumSayisi] = useState(gelenParams?.mum_sayisi  || 200);
    const [obbbGovdeOran, setObbbGovdeOran] = useState(
        gelenParams?.govde_oran ? Math.round(gelenParams.govde_oran * 100) : 60
    );
    const [obbbSadeceTaze, setObbbSadeceTaze] = useState(gelenParams?.sadece_taze ?? true);

    // ---- IDM Tarama'ya özgü filtreler ----
    const IDM_PERIYOT_MAP = {
        "1 Gün": "1d", "1 Hafta": "1wk", "1 Ay": "1mo",
        "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const [idmBoga,      setIdmBoga]      = useState(gelenParams?.idm_tipler ? gelenParams.idm_tipler.includes("Boğa IDM") : true);
    const [idmAyi,       setIdmAyi]       = useState(gelenParams?.idm_tipler ? gelenParams.idm_tipler.includes("Ayı IDM")  : false);
    const [idmPeriyot,   setIdmPeriyot]   = useState(gelenParams?.tarama_periyot_label || "1 Gün");
    const [idmMumSayisi, setIdmMumSayisi] = useState(gelenParams?.mum_sayisi || 200);

    // ---- P/D Zone Tarama'ya özgü filtreler ----
    const PD_PERIYOT_MAP = {
        "1 Gün": "1d", "1 Hafta": "1wk", "1 Ay": "1mo",
        "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const [pdDiscount,     setPdDiscount]     = useState(gelenParams?.bolge_filtre ? gelenParams.bolge_filtre.includes("Discount")     : true);
    const [pdEquilibrium,  setPdEquilibrium]  = useState(gelenParams?.bolge_filtre ? gelenParams.bolge_filtre.includes("Equilibrium")  : false);
    const [pdPremium,      setPdPremium]      = useState(gelenParams?.bolge_filtre ? gelenParams.bolge_filtre.includes("Premium")      : false);
    const [pdPeriyot,      setPdPeriyot]      = useState(gelenParams?.tarama_periyot_label || "1 Gün");
    const [pdRangeWindow,  setPdRangeWindow]  = useState(gelenParams?.range_window || 20);
    const [pdMumSayisi,    setPdMumSayisi]    = useState(gelenParams?.mum_sayisi   || 200);

    // ---- SMT Tarama'ya özgü filtreler ----
    const SMT_PERIYOT_MAP = {
        "1 Gün": "1d", "1 Hafta": "1wk", "1 Ay": "1mo",
        "3 Aylık": "3mo", "6 Aylık": "6mo", "Yıllık": "1y",
    };
    const SMT_REFERANS = {
        "BIST":   ["XU100 (BIST100)"],  // XU030 DB'de mevcut değil
        "Kripto": ["BTC", "ETH", "BNB"],
    };
    const [smtBoga,        setSmtBoga]        = useState(gelenParams?.smt_tipler ? gelenParams.smt_tipler.includes("Boğa SMT") : true);
    const [smtAyi,         setSmtAyi]         = useState(gelenParams?.smt_tipler ? gelenParams.smt_tipler.includes("Ayı SMT")  : false);
    const [smtPeriyot,     setSmtPeriyot]     = useState(gelenParams?.tarama_periyot_label || "1 Gün");
    const [smtRefVarlik,   setSmtRefVarlik]   = useState(gelenParams?.referans_varlik || "XU100 (BIST100)");
    const [smtSwing,       setSmtSwing]       = useState(gelenParams?.swing_pencere   || 3);
    const [smtMinKor,      setSmtMinKor]      = useState(
        gelenParams?.min_korelasyon ? Math.round(gelenParams.min_korelasyon * 100) : 70
    );
    const [smtMumSayisi,   setSmtMumSayisi]   = useState(gelenParams?.mum_sayisi || 200);

    // ---- Puanlama & Tahmin'e özgü filtreler ----
    const PUANLAMA_VADE_OPTS = ["Gün İçi", "Kısa Vade (1-10 gün)", "Orta Vade (11-60 gün)", "Uzun Vade (61+ gün)", "Kaldıraçlı İşlem"];
    const [pVade,       setPVade]       = useState(gelenParams?.vade         || "Kısa Vade (1-10 gün)");
    const [pYonLong,    setPYonLong]    = useState(gelenParams?.islem_yonu ? gelenParams.islem_yonu.includes("Long")  : true);
    const [pYonShort,   setPYonShort]   = useState(gelenParams?.islem_yonu ? gelenParams.islem_yonu.includes("Short") : false);
    const [pMinPuan,    setPMinPuan]    = useState(0);

    // Piyasa/Para Birimi'ne göre Vade/İşlem Yönü kısıtları
    // - BIST veya Kripto+USD: "Kaldıraçlı İşlem" pasif, diğer vadeler aktif, İşlem Yönü pasif
    // - Kripto + USD (Futures): sadece "Kaldıraçlı İşlem" aktif ve seçili, İşlem Yönü aktif
    const pKaldiracZorunlu = piyasa === "Kripto" && paraBirimi === "USD (Futures)";
    const pYonAktif        = pKaldiracZorunlu;
    const pVadeAktifMi     = v => pKaldiracZorunlu ? v === "Kaldıraçlı İşlem" : v !== "Kaldıraçlı İşlem";

    useEffect(() => {
        if (kaynak !== "puanlama") return;
        if (pKaldiracZorunlu) {
            if (pVade !== "Kaldıraçlı İşlem") setPVade("Kaldıraçlı İşlem");
        } else {
            if (pVade === "Kaldıraçlı İşlem") setPVade(PUANLAMA_VADE_OPTS.find(v => v !== "Kaldıraçlı İşlem"));
        }
    }, [kaynak, piyasa, paraBirimi]);

    // ---- Hacim Profili'ne özgü filtreler ----
    const HP_PERIYOT_MAP = { "1 Gün":"1d", "1 Hafta":"1wk", "1 Ay":"1mo", "3 Aylık":"3mo" };
    const HP_SINYAL_FILTRELER = ["POC Yakını","Discount","Premium","HVN Yakın","LVN İçi"];
    const [hpPeriyot,    setHpPeriyot]    = useState(gelenParams?.tarama_periyot ? Object.entries({"1d":"1 Gün","1wk":"1 Hafta","1mo":"1 Ay","3mo":"3 Aylık"}).find(([k])=>k===gelenParams.tarama_periyot)?.[1] || "1 Gün" : "1 Gün");
    const [hpSinyalFiltre, setHpSinyalFiltre] = useState(() => {
        const init = {};
        ["POC Yakını","Discount","Premium","HVN Yakın","LVN İçi"].forEach(f => {
            init[f] = (gelenParams?.sinyal_filtre || []).includes(f);
        });
        return init;
    });
    const [hpMinSkor,    setHpMinSkor]    = useState(gelenParams?.min_skor  || 2);
    const [hpMumSayisi,  setHpMumSayisi]  = useState(gelenParams?.mum_sayisi || 300);
    const hpSeciliFiltreler = Object.keys(hpSinyalFiltre).filter(f => hpSinyalFiltre[f]);

    // ---- Hacim Akışı'na özgü filtreler ----
    const HACISI_SINYAL_OPTS = ["📈 Güçlü Alım","🔶 Orta Alım","⬇️ Zayıf Alım","📉 Güçlü Satım","🔶 Orta Satım","⬆️ Zayıf Satım","⚖️ Belirsiz"];
    const [haLookback,    setHaLookback]    = useState(gelenParams?.lookback   || 20);
    const [haMinSpike,    setHaMinSpike]    = useState(gelenParams?.min_spike  || 1.5);
    const [haSinyalFiltre, setHaSinyalFiltre] = useState(() => {
        const init = {};
        HACISI_SINYAL_OPTS.forEach(s => { init[s] = (gelenParams?.sinyal_filtre || []).includes(s); });
        return init;
    });
    const haSeciliSinyaller = Object.keys(haSinyalFiltre).filter(s => haSinyalFiltre[s]);

    // ---- Divergence'a özgü filtreler ----
    const DV_PERIYOT_MAP = { "1 Gün":"1d", "1 Hafta":"1wk", "1 Ay":"1mo" };
    const DV_OSC_OPTS  = ["RSI","MACD Histogram","Stokastik RSI","OBV"];
    const DV_TIP_OPTS  = ["Regular Bullish","Regular Bearish","Hidden Bullish","Hidden Bearish"];
    const [dvPeriyot,    setDvPeriyot]    = useState(gelenParams?.tarama_periyot ?
        (Object.entries({"1d":"1 Gün","1wk":"1 Hafta","1mo":"1 Ay"}).find(([k])=>k===gelenParams.tarama_periyot)?.[1] || "1 Gün") : "1 Gün");
    const [dvOsilatorler, setDvOsilatorler] = useState(() => {
        const init = {};
        DV_OSC_OPTS.forEach(o => { init[o] = (gelenParams?.osilatorler || ["RSI","MACD Histogram"]).includes(o); });
        return init;
    });
    const [dvTipler, setDvTipler] = useState(() => {
        const init = {};
        DV_TIP_OPTS.forEach(t => { init[t] = (gelenParams?.divergence_tipleri || ["Regular Bullish","Regular Bearish"]).includes(t); });
        return init;
    });
    const [dvPivotModu,  setDvPivotModu]  = useState(gelenParams?.pivot_modu || "fractal");
    const dvSeciliOsc = Object.keys(dvOsilatorler).filter(o => dvOsilatorler[o]);
    const dvSeciliTip = Object.keys(dvTipler).filter(t => dvTipler[t]);

    // ---- Karar Motoru'ya özgü filtreler ----
    const KM_VADE_OPTS = ["Gün İçi","Kısa Vade (1-10 gün)","Orta Vade (11-60 gün)","Uzun Vade (61+ gün)","Kaldıraçlı İşlem"];
    const KM_MIN_SKOR_OPTS = [0, 50, 60, 65, 70, 75, 80];
    const [kmVade,      setKmVade]      = useState(gelenParams?.vade      || "Kısa Vade (1-10 gün)");
    const [kmMinSkor,   setKmMinSkor]   = useState(gelenParams?.min_puan  || 0);
    const [kmYonLong,   setKmYonLong]   = useState(gelenParams?.islem_yonu ? gelenParams.islem_yonu.includes("Long")  : true);
    const [kmYonShort,  setKmYonShort]  = useState(gelenParams?.islem_yonu ? gelenParams.islem_yonu.includes("Short") : false);

    // Piyasa/Para Birimi'ne göre Vade/İşlem Yönü kısıtları (Puanlama & Tahmin ile aynı desen)
    const kmKaldiracZorunlu = piyasa === "Kripto" && paraBirimi === "USD (Futures)";
    const kmYonAktif        = kmKaldiracZorunlu;
    const kmVadeAktifMi     = v => kmKaldiracZorunlu ? v === "Kaldıraçlı İşlem" : v !== "Kaldıraçlı İşlem";

    useEffect(() => {
        if (kaynak !== "karar_motoru") return;
        if (kmKaldiracZorunlu) {
            if (kmVade !== "Kaldıraçlı İşlem") setKmVade("Kaldıraçlı İşlem");
        } else {
            if (kmVade === "Kaldıraçlı İşlem") setKmVade(KM_VADE_OPTS.find(v => v !== "Kaldıraçlı İşlem"));
        }
    }, [kaynak, piyasa, paraBirimi]);
    // KM sonuç filtreleri
    const [kmFiltreYon,   setKmFiltreYon]   = useState("Tümü");
    const [kmFiltreSinif, setKmFiltreSinif] = useState("Tümü");
    const [kmFiltreKarar, setKmFiltreKarar] = useState("Tümü");
    const [kmFiltreHedef, setKmFiltreHedef] = useState("Tümü");

    // ---- İşlem Planlama'ya özgü filtreler ----
    const [ipIslemTipi,  setIpIslemTipi]  = useState(gelenParams?.islem_tipi  || "Kaldıraç");
    const [ipYonLong,    setIpYonLong]    = useState(gelenParams?.islem_yonu ? gelenParams.islem_yonu.includes("Long")  : true);
    const [ipYonShort,   setIpYonShort]   = useState(gelenParams?.islem_yonu ? gelenParams.islem_yonu.includes("Short") : false);

    // Piyasa/Para Birimi'ne göre İşlem Tipi/İşlem Yönü kısıtları
    // - BIST: Para Birimi varsayılan TL önerilir (kilitli değil, diğer seçenekler de seçilebilir), İşlem Tipi=Spot zorunlu (Kaldıraç pasif), İşlem Yönü pasif
    // - Kripto + Para Birimi=USD: İşlem Tipi=Spot zorunlu (Kaldıraç pasif), İşlem Yönü pasif
    // - Kripto + Para Birimi=Kripto veya USD (Futures): İşlem Tipi=Kaldıraç zorunlu (Spot pasif), İşlem Yönü aktif
    const ipSpotZorunlu     = piyasa === "BIST" || (piyasa === "Kripto" && paraBirimi === "USD");
    const ipKaldiracZorunlu = piyasa === "Kripto" && (paraBirimi === "Kripto" || paraBirimi === "USD (Futures)");
    const ipYonAktif        = ipKaldiracZorunlu;

    // Piyasa DEĞİŞTİĞİNDE bir kereliğine varsayılan Para Birimi öner — sonrasında
    // kullanıcı diğer seçenekleri de serbestçe seçebilsin diye paraBirimi'yi bağımlılığa eklemiyoruz
    const oncekiPiyasaRef = useRef(piyasa);
    useEffect(() => {
        if (kaynak !== "islem_planlama") return;
        if (oncekiPiyasaRef.current !== piyasa) {
            oncekiPiyasaRef.current = piyasa;
            if (piyasa === "BIST") setParaBirimi("TL");
        }
    }, [kaynak, piyasa]);

    useEffect(() => {
        if (kaynak !== "islem_planlama") return;
        if (ipSpotZorunlu && ipIslemTipi !== "Spot") setIpIslemTipi("Spot");
        else if (ipKaldiracZorunlu && ipIslemTipi !== "Kaldıraç") setIpIslemTipi("Kaldıraç");
    }, [kaynak, piyasa, paraBirimi]);

    // ---- Killzone Tarama'ya özgü filtreler ----
    const KILLZONE_TANIMLARI_SIM = {
        "BIST Açılış (10:00-11:00)":      "#059669",
        "BIST Öğle Dönüşü (13:00-14:00)": "#0891b2",
        "BIST Kapanış Öncesi (17:00-18:00)": "#be185d",
        "Londra Açılış (10:00-12:00)":    "#2563eb",
        "New York Açılış (15:00-17:00)":  "#dc2626",
        "Londra Kapanış (18:00-20:00)":   "#d97706",
        "Asya KZ (03:00-09:00)":          "#7c3aed",
    };
    const [kzSecilen, setKzSecilen] = useState(
        gelenParams?.killzoneler?.[0] || "BIST Açılış (10:00-11:00)"
    );
    const [ytSecilen, setYtSecilen] = useState(
        gelenParams?.yapi_tipleri?.[0] || "FVG"
    );
    const YT_RENK = { "FVG": "#2563eb", "MSB": "#dc2626", "Sweep": "#7c3aed" };
    const [kzGeriBak,  setKzGeriBak]   = useState(gelenParams?.geri_bak_gun || 5);
    const [kzComboAcik, setKzComboAcik] = useState(false);
    const [ytComboAcik, setYtComboAcik] = useState(false);

    // ---- Çapa Tarama'ya özgü filtreler ----
    const CAPA_TOLERANS_LIST = [30, 50, 70, 80, 90, 100];
    const [capaBoga,     setCapaBoga]     = useState(gelenParams?.fvg_tipler ? gelenParams.fvg_tipler.includes("Boğa FVG") : true);
    const [capaAyi,      setCapaAyi]      = useState(gelenParams?.fvg_tipler ? gelenParams.fvg_tipler.includes("Ayı FVG")  : false);
    const [capaTolerans, setCapaTolerans] = useState(
        gelenParams?.tolerans ? Math.round(gelenParams.tolerans * 100) : 30
    );

    // ---- Referans Fiyat seçimi ----
    // ref_fiyat parametresi: "Bugünkü" (tarama modülünden) veya "Bugünkü Fiyat" (doğrudan)
    const _initRefFiyat = () => {
        const p = gelenParams?.ref_fiyat;
        if (!p) return "Bugünkü Fiyat";
        if (p === "En Yüksek" || p === "En Yüksek Fiyat") return "En Yüksek Fiyat";
        return "Bugünkü Fiyat";
    };
    const [refFiyat, setRefFiyat] = useState(_initRefFiyat);

    // ---- Çalışma state'leri ----
    const [grafikHisse,    setGrafikHisse]    = useState(null);
    const [grafikVeri,     setGrafikVeri]     = useState(null);
    const [grafikYukleniyor, setGrafikYukleniyor] = useState(false);

    const [calisiyor,      setCalisiyor]      = useState(false);
    const [ilerleme,       setIlerleme]       = useState(0);
    const [tahminiSure,    setTahminiSure]    = useState(null);
    const [gecenSure,      setGecenSure]      = useState(0);
    const [bulunanSayisi,  setBulunanSayisi]  = useState(0);
    const [tamamlananSayisi, setTamamlananSayisi] = useState(0);
    const [toplamSayisi,     setToplamSayisi]     = useState(0);
    const [, setDurumMesaj]     = useState(null);
    const [cokluAdimBilgi, setCokluAdimBilgi] = useState(null); // { mevcut, toplam } | null
    const gecenSureRef = useRef(null);

    // Cleanup geçen süre timer
    useEffect(() => () => { clearInterval(gecenSureRef.current); }, []);

    // ---- DB'den lookup verileri ----
    const [piyasaSecenekleri,     setPiyasaSecenekleri]     = useState([]);
    const [paraBirimiSecenekleri, setParaBirimiSecenekleri] = useState([]);
    const [dipPeriyotSecenekleri, setDipPeriyotSecenekleri] = useState([]);
    const [periyotSecenekleri,    setPeriyotSecenekleri]    = useState([]);

    // kaynak (modül) → DB'deki periyotlar/para_birimleri tablosu modül anahtarı
    const KAYNAK_MODUL_KEY = {
        dip_tarama: "dip_tarama", likidite: "likidite_tarama", fvg: "fvg_tarama",
        capa: "capa_noktasi_tarama", msb: "msb_tarama", ote: "ote_tarama",
        obbb: "obbb_tarama", idm: "idm_tarama", pd: "pd_zone_tarama", smt: "smt_tarama",
        killzone: "killzone_tarama", topdown: "topdown_cascade",
        islem_planlama: "islem_planlama", puanlama: "puanlama_tahmin",
        karar_motoru: "karar_motoru", hacim_profili: "hacim_profili_tarama",
        hacim_akisi: "hacim_akisi_tarama", divergence: "divergence_tarama",
    };

    // Modül değişince o modülün periyot seçeneklerini DB'den yükle
    useEffect(() => {
        const modulKey = KAYNAK_MODUL_KEY[kaynak];
        if (!modulKey) { setPeriyotSecenekleri([]); return; }
        (async () => {
            try {
                const { data: { session } } = await supabase.auth.getSession();
                const token = session?.access_token;
                const r = await axios.get(`${API_URL}/scan/lookup/periyotlar`, {
                    params: { modul: modulKey },
                    headers: { Authorization: `Bearer ${token}` },
                });
                setPeriyotSecenekleri(r.data.map(p => p.periyot));
            } catch {
                setPeriyotSecenekleri([]);
            }
        })();
    }, [kaynak]);

    // Mount: piyasalar ve dip tarama periyotlarını yükle
    useEffect(() => {
        const yukle = async () => {
            try {
                const { data: { session } } = await supabase.auth.getSession();
                const token = session?.access_token;
                const headers = { Authorization: `Bearer ${token}` };
                const [r1, r3] = await Promise.all([
                    axios.get(`${API_URL}/scan/lookup/piyasalar`, { headers }),
                    axios.get(`${API_URL}/scan/lookup/periyotlar`, { params: { modul: "dip_tarama" }, headers }),
                ]);
                setPiyasaSecenekleri(r1.data.map(p => p.piyasa));
                const dipList = r3.data.map(p => p.periyot);
                setDipPeriyotSecenekleri(dipList);
                if (dipList.length > 0 && !dipList.includes(periyot)) {
                    setPeriyot(dipList[0]);
                }
            } catch {
                setPiyasaSecenekleri(["BIST", "Kripto"]);
                setDipPeriyotSecenekleri(["1 Yıl", "6 Ay", "3 Ay", "1 Ay"]);
            }
        };
        yukle();
    }, []);

    // Piyasa (veya modül) değişince para birimi seçeneklerini yenile
    useEffect(() => {
        const yukle = async () => {
            try {
                const { data: { session } } = await supabase.auth.getSession();
                const token = session?.access_token;
                const modulKey = KAYNAK_MODUL_KEY[kaynak];
                const r = await axios.get(`${API_URL}/scan/lookup/para-birimleri`, {
                    params: modulKey ? { piyasa, modul: modulKey } : { piyasa },
                    headers: { Authorization: `Bearer ${token}` },
                });
                const paraList = r.data.map(p => p.para_birimi);
                setParaBirimiSecenekleri(paraList);
                if (paraList.length > 0 && !paraList.includes(paraBirimi)) {
                    setParaBirimi(paraList[0]);
                }
            } catch {
                setParaBirimiSecenekleri(
                    piyasa === "Kripto" ? ["USD"] : ["USD", "TL", "BIST100 (TL)", "BIST100 (USD)"]
                );
            }
        };
        yukle();
    }, [piyasa, kaynak]);
    const [sonuc,       setSonuc]       = useState(null);

    const grafikAc = useCallback(async (r) => {
        if (!sonuc?.sim_tarihi) return;
        setGrafikHisse(r);
        setGrafikVeri(null);
        setGrafikYukleniyor(true);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            const token = session?.access_token || "";
            const res = await fetch(`${API_URL}/scan/gecmis-sim-grafik`, {
                method: "POST",
                headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
                body: JSON.stringify({
                    symbol:      r["Hisse"],
                    mod:         sonuc.mod,
                    para_birimi: sonuc.para_birimi,
                    sim_tarihi:  sonuc.sim_tarihi,
                }),
            });
            const data = await res.json();
            setGrafikVeri(data);
        } catch(e) { console.error(e); }
        finally { setGrafikYukleniyor(false); }
    }, [sonuc]);

    // ---- Tablo ----
    const [siralamaKol, setSiralamaKol] = useState("Getiri %");
    const [siralamaYon, setSiralamaYon] = useState("desc");
    const [filtre,      setFiltre]      = useState(new Set());
    const [guvenFiltre, setGuvenFiltre] = useState("Tümü"); // "Tümü" | "Yüksek" | "Orta" | "Düşük"
    const [durumFiltre, setDurumFiltre] = useState("Tümü");
    const [likFiltreSweep,  setLikFiltreSweep]  = useState(new Set());
    const [likFiltreEqh,    setLikFiltreEqh]    = useState(new Set());
    const [likFiltreKalite, setLikFiltreKalite] = useState(new Set());
    const toggleFiltreGetiri = v => setFiltre(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleLikFiltreSweep  = v => setLikFiltreSweep(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [fvgFiltreTip,   setFvgFiltreTip]   = useState(new Set());
    const [fvgFiltreDurum, setFvgFiltreDurum] = useState(new Set());
    const [fvgFiltreBpr,   setFvgFiltreBpr]   = useState(new Set());
    const toggleFvgFiltreTip   = v => setFvgFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleFvgFiltreDurum = v => setFvgFiltreDurum(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleFvgFiltreBpr   = v => setFvgFiltreBpr(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [capaFiltreTip,   setCapaFiltreTip]   = useState(new Set());
    const [capaFiltreDurum, setCapaFiltreDurum] = useState(new Set());
    const [capaFiltreTemas, setCapaFiltreTemas] = useState(new Set());
    const toggleCapaFiltreTip   = v => setCapaFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleCapaFiltreDurum = v => setCapaFiltreDurum(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleCapaFiltreTemas = v => setCapaFiltreTemas(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [msbFiltreTip,   setMsbFiltreTip]   = useState(new Set());
    const [msbFiltreGuclu, setMsbFiltreGuclu] = useState(new Set());
    const toggleMsbFiltreTip   = v => setMsbFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleMsbFiltreGuclu = v => setMsbFiltreGuclu(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [oteFiltreTip, setOteFiltreTip] = useState(new Set());
    const toggleOteFiltreTip = v => setOteFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [obbbFiltreTip,     setObbbFiltreTip]     = useState(new Set());
    const [obbbFiltreDisp,    setObbbFiltreDisp]    = useState(new Set());
    const [obbbFiltreFvgOnay, setObbbFiltreFvgOnay] = useState(new Set());
    const [obbbFiltreGuc,     setObbbFiltreGuc]     = useState(new Set());
    const toggleObbbFiltreTip     = v => setObbbFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleObbbFiltreDisp    = v => setObbbFiltreDisp(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleObbbFiltreFvgOnay = v => setObbbFiltreFvgOnay(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleObbbFiltreGuc     = v => setObbbFiltreGuc(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [idmFiltreTip,   setIdmFiltreTip]   = useState(new Set());
    const [idmFiltreSweep, setIdmFiltreSweep] = useState(new Set());
    const toggleIdmFiltreTip   = v => setIdmFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleIdmFiltreSweep = v => setIdmFiltreSweep(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [pdFiltreBolge, setPdFiltreBolge] = useState(new Set());
    const [pdFiltreYon,   setPdFiltreYon]   = useState(new Set());
    const togglePdFiltreBolge = v => setPdFiltreBolge(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const togglePdFiltreYon   = v => setPdFiltreYon(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [smtFiltreTip, setSmtFiltreTip] = useState(new Set());
    const [smtFiltreGuc, setSmtFiltreGuc] = useState(new Set());
    const toggleSmtFiltreTip = v => setSmtFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleSmtFiltreGuc = v => setSmtFiltreGuc(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [kzFiltreHacim, setKzFiltreHacim] = useState(new Set());
    const [kzFiltreSinif, setKzFiltreSinif] = useState(new Set());
    const toggleKzFiltreHacim = v => setKzFiltreHacim(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleKzFiltreSinif = v => setKzFiltreSinif(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [topdownFiltreTrend, setTopdownFiltreTrend] = useState(new Set());
    const toggleTopdownFiltreTrend = v => setTopdownFiltreTrend(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [hpFiltreSkor,    setHpFiltreSkor]    = useState(new Set());
    const [hpFiltreVaDurum, setHpFiltreVaDurum] = useState(new Set());
    const [hpFiltreHvn,     setHpFiltreHvn]     = useState(new Set());
    const [hpFiltreLvn,     setHpFiltreLvn]     = useState(new Set());
    const toggleHpFiltreSkor    = v => setHpFiltreSkor(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleHpFiltreVaDurum = v => setHpFiltreVaDurum(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleHpFiltreHvn     = v => setHpFiltreHvn(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleHpFiltreLvn     = v => setHpFiltreLvn(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [haFiltreSinyal, setHaFiltreSinyal] = useState(new Set());
    const [haFiltreSkor,   setHaFiltreSkor]   = useState(new Set());
    const [haFiltreSurek,  setHaFiltreSurek]  = useState(new Set());
    const toggleHaFiltreSinyal = v => setHaFiltreSinyal(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleHaFiltreSkor   = v => setHaFiltreSkor(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleHaFiltreSurek  = v => setHaFiltreSurek(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const [dvFiltreTip,  setDvFiltreTip]  = useState(new Set());
    const [dvFiltreKonf, setDvFiltreKonf] = useState(new Set());
    const [dvFiltreOnay, setDvFiltreOnay] = useState(new Set());
    const [dvFiltreGuc,  setDvFiltreGuc]  = useState(new Set());
    const [ipFiltreYon, setIpFiltreYon] = useState(new Set());
    const [pFiltreYon, setPFiltreYon] = useState(new Set());
    const togglePFiltreYon = v => setPFiltreYon(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleIpFiltreYon = v => setIpFiltreYon(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleDvFiltreTip  = v => setDvFiltreTip(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleDvFiltreKonf = v => setDvFiltreKonf(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleDvFiltreOnay = v => setDvFiltreOnay(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleDvFiltreGuc  = v => setDvFiltreGuc(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleLikFiltreEqh    = v => setLikFiltreEqh(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });
    const toggleLikFiltreKalite = v => setLikFiltreKalite(p => { const s = new Set(p); s.has(v) ? s.delete(v) : s.add(v); return s; });

    // ── Satır seçimi (checkbox) ──────────────────────────────────────────────
    const [secilenler,    setSecilenler]    = useState(new Set());
    const [islemMenuAcik, setIslemMenuAcik] = useState(false);

    // ── Doğruluk Analizine Gönder ────────────────────────────────────────────
    const [dogrulukGonderiliyor, setDogrulukGonderiliyor] = useState(false);
    const [dogrulukPopup,        setDogrulukPopup]        = useState(null); // null | "yukleniyor" | "tamam"
    const [dogrulukSonuc,        setDogrulukSonuc]        = useState(null);
    const [egitimYukleniyor,     setEgitimYukleniyor]     = useState(false);
    const [egitimPopup,          setEgitimPopup]          = useState(null); // null | "yukleniyor" | "tamam"
    const [egitimPopupSonuc,     setEgitimPopupSonuc]     = useState(null);

    // ── Alarm popup ───────────────────────────────────────────────────────
    const [alarmPopup,        setAlarmPopup]        = useState(false);
    const [alarmHisseler,     setAlarmHisseler]     = useState([]);
    const [hedefFiyatlar,     setHedefFiyatlar]     = useState({});
    const [alarmMail,         setAlarmMail]         = useState(false);
    const [alarmBildirim,     setAlarmBildirim]     = useState(true);
    const [alarmKaydediliyor, setAlarmKaydediliyor] = useState(false);

    // ---- "Hiç işlem yok" popup ----
    const [hicIslemPopup, setHicIslemPopup] = useState(null);

    const aktifHisselerRef = useRef(gelenParams?.hisse_listesi || null);
    const intervalRef      = useRef(null);

    // ---- API çağrısı — kaynağa göre doğru endpoint'i kullanır ----
    const _apiBaslat = async (params) => {
        setSonuc(null);
        setCalisiyor(true);
        setIlerleme(0);
        setGecenSure(0);
        setDurumMesaj(null);
        setCokluAdimBilgi(null);
        clearInterval(gecenSureRef.current);
        const simdiRef = Date.now();
        gecenSureRef.current = setInterval(() => {
            setGecenSure(Math.floor((Date.now() - simdiRef) / 1000));
        }, 1000);
        setGuvenFiltre("Tümü");
        setFiltre(new Set());
        setDurumFiltre("Tümü");
        setLikFiltreSweep(new Set());
        setLikFiltreEqh(new Set());
        setLikFiltreKalite(new Set());
        setFvgFiltreTip(new Set());
        setFvgFiltreDurum(new Set());
        setFvgFiltreBpr(new Set());
        setCapaFiltreTip(new Set());
        setCapaFiltreDurum(new Set());
        setCapaFiltreTemas(new Set());
        setMsbFiltreTip(new Set());
        setMsbFiltreGuclu(new Set());
        setOteFiltreTip(new Set());
        setObbbFiltreTip(new Set());
        setObbbFiltreDisp(new Set());
        setObbbFiltreFvgOnay(new Set());
        setObbbFiltreGuc(new Set());
        setIdmFiltreTip(new Set());
        setIdmFiltreSweep(new Set());
        setPdFiltreBolge(new Set());
        setPdFiltreYon(new Set());
        setSmtFiltreTip(new Set());
        setSmtFiltreGuc(new Set());
        setKzFiltreHacim(new Set());
        setKzFiltreSinif(new Set());
        setTopdownFiltreTrend(new Set());
        setHpFiltreSkor(new Set());
        setHpFiltreVaDurum(new Set());
        setHpFiltreHvn(new Set());
        setHpFiltreLvn(new Set());
        setHaFiltreSinyal(new Set());
        setHaFiltreSkor(new Set());
        setHaFiltreSurek(new Set());
        setDvFiltreTip(new Set());
        setDvFiltreKonf(new Set());
        setDvFiltreOnay(new Set());
        setDvFiltreGuc(new Set());
        setIpFiltreYon(new Set());
        setPFiltreYon(new Set());
        setSecilenler(new Set());
        setDurumMesaj(null);
        setKmFiltreYon("Tümü"); setKmFiltreSinif("Tümü"); setKmFiltreKarar("Tümü"); setKmFiltreHedef("Tümü");
        setBulunanSayisi(0);
        setTamamlananSayisi(0);
        setToplamSayisi(0);
        setTahminiSure(null);
        setDurumMesaj("Başlatılıyor...");
        setHicIslemPopup(null);

        // Kaynağa göre endpoint seç
        const endpoint = params.kaynak === "likidite" ? `${API_URL}/scan/gecmis-sim-likidite`
                       : params.kaynak === "fvg"      ? `${API_URL}/scan/gecmis-sim-fvg`
                       : params.kaynak === "capa"     ? `${API_URL}/scan/gecmis-sim-capa`
                       : params.kaynak === "msb"      ? `${API_URL}/scan/gecmis-sim-msb`
                       : params.kaynak === "ote"      ? `${API_URL}/scan/gecmis-sim-ote`
                       : params.kaynak === "obbb"     ? `${API_URL}/scan/gecmis-sim-obbb`
                       : params.kaynak === "idm"      ? `${API_URL}/scan/gecmis-sim-idm`
                       : params.kaynak === "pd"       ? `${API_URL}/scan/gecmis-sim-pd`
                       : params.kaynak === "smt"      ? `${API_URL}/scan/gecmis-sim-smt`
                       : params.kaynak === "killzone" ? `${API_URL}/scan/gecmis-sim-killzone`
                       : params.kaynak === "topdown"  ? `${API_URL}/scan/gecmis-sim-topdown`
                       : params.kaynak === "islem_planlama" ? `${API_URL}/scan/gecmis-sim-islem-planlama`
                       : params.kaynak === "puanlama"      ? `${API_URL}/scan/gecmis-sim-puanlama`
                       : params.kaynak === "karar_motoru"  ? `${API_URL}/scan/gecmis-sim-karar-motoru`
                       : params.kaynak === "hacim_profili" ? `${API_URL}/scan/gecmis-sim-hacim-profili`
                       : params.kaynak === "hacim_akisi"   ? `${API_URL}/scan/gecmis-sim-hacim-akisi`
                       : params.kaynak === "divergence"    ? `${API_URL}/scan/gecmis-sim-divergence`
                       : params.kaynak === "coklu"         ? `${API_URL}/scan/gecmis-sim-coklu`
                       : `${API_URL}/scan/gecmis-sim`;

        try {
            const { data: { session } } = await supabase.auth.getSession();
            await axios.post(endpoint, params,
                { headers: { Authorization: `Bearer ${session.access_token}` } });

            toast.success("Simülasyon başlatıldı!");
            clearInterval(intervalRef.current);
            intervalRef.current = setInterval(_durumSorgula, 3000);
        } catch (e) {
            toast.error(e.response?.data?.detail || "Hata oluştu");
            setCalisiyor(false);
        }
    };

    const _durumSorgula = async () => {
        try {
            const { data: { session } } = await supabase.auth.getSession();
            if (!session) { clearInterval(intervalRef.current); return; }

            const res = await axios.get(`${API_URL}/scan/gecmis-sim/durum`, {
                headers: { Authorization: `Bearer ${session.access_token}` }
            });
            const d = res.data;
            setIlerleme(d.ilerleme || 0);
            setTahminiSure(d.tahmini_sure);
            // Backend doğrudan tamamlanan/toplam alanlarını dönüyorsa öncelik onlarda
            if (d.tamamlanan != null) setTamamlananSayisi(d.tamamlanan);
            if (d.toplam != null) setToplamSayisi(d.toplam);
            if (d.bulunan != null) setBulunanSayisi(d.bulunan);
            // Mesaj formatı: "N|i/toplam|sembol" — N = bulunan sayısı (görüntü metni + yedek ayrıştırma)
            const rawMesaj = d.mesaj || "";
            // Çoklu Tarama: mesaj içinde "Adım x/y (...)" bilgisi varsa yakala
            const adimEslesme = rawMesaj.match(/Adım (\d+)\/(\d+)/);
            if (adimEslesme) {
                setCokluAdimBilgi({ mevcut: parseInt(adimEslesme[1], 10), toplam: parseInt(adimEslesme[2], 10) });
            }
            if (rawMesaj.includes("|")) {
                const parcalar = rawMesaj.split("|");
                // Format 1: "N|i/toplam|sembol" — N sayısal (puanlama vb.)
                // Format 2: "ModulAdi|i/toplam|sembol" — modül adı (hacim profili vb.)
                const ilk = parcalar[0];
                const bulunan = parseInt(ilk, 10);
                if (d.bulunan == null && !isNaN(bulunan)) setBulunanSayisi(bulunan);
                // "i/toplam" formatını yedek olarak ayrıştır (ör. "45/120")
                if (parcalar[1] && parcalar[1].includes("/")) {
                    const [iStr, toplamStr] = parcalar[1].split("/");
                    const iNum = parseInt(iStr, 10);
                    const toplamNum = parseInt(toplamStr, 10);
                    if (d.tamamlanan == null && !isNaN(iNum)) setTamamlananSayisi(iNum);
                    if (d.toplam == null && !isNaN(toplamNum)) setToplamSayisi(toplamNum);
                }
                // Format 2'de bulunan d.sonuc'tan gelince güncellenir
                const gorunen = parcalar[2]
                    ? `${parcalar[1]} Taranıyor: ${parcalar[2]}`
                    : (parcalar[1] || rawMesaj);
                setDurumMesaj(gorunen);
            } else {
                setDurumMesaj(rawMesaj);
            }
            // Tamamlandıysa sonuç sayısını güncelle
            if (!d.calisiyor && d.sonuc?.toplam != null) {
                setBulunanSayisi(d.sonuc.toplam);
            }
            // Çalışırken de ara sonuç sayısı varsa güncelle
            if (d.calisiyor && d.sonuc?.sonuclar?.length) {
                setBulunanSayisi(d.sonuc.sonuclar.length);
            }

            if (!d.calisiyor) {
                clearInterval(intervalRef.current);
                clearInterval(gecenSureRef.current);
                setCalisiyor(false);

                if (d.hata) {
                    toast.error("Simülasyon başarısız: " + d.hata);
                    return;
                }
                if (d.sonuc) {
                    const s = d.sonuc;
                    // Seçili hisseler varsa ve hiç sonuç yoksa → popup
                    if (aktifHisselerRef.current?.length > 0 && s.toplam === 0) {
                        setHicIslemPopup({ simTarih: s.sim_tarihi });
                        return;
                    }
                    setSonuc(s);
                    toast.success(`Simülasyon tamamlandı — ${s.toplam} sinyal bulundu`);
                }
            }
        } catch (e) {
            console.error("Durum sorgu hatası:", e);
        }
    };

    useEffect(() => () => clearInterval(intervalRef.current), []);

    // ---- Oto-başlatma: herhangi bir modülden yönlendirme geldiyse ----
    useEffect(() => {
        if (gelenParams?.oto_baslat) {
            aktifHisselerRef.current = gelenParams.hisse_listesi || null;
            _apiBaslat({ ...gelenParams, sim_tarihi: gelenParams.sim_tarihi || simTarihi });
        }
    }, []);

    // ---- Manuel başlatma butonu ----
    const simBaslat = () => {
        aktifHisselerRef.current = null;
        if (kaynak === "likidite") {
            const sweepTipler = [
                ...(likSweepBoga ? ["Boğa Sweep"] : []),
                ...(likSweepAyi  ? ["Ayı Sweep"]  : []),
            ];
            if (sweepTipler.length === 0) { toast.error("En az bir sweep tipi seçin"); return; }
            _apiBaslat({
                kaynak: "likidite", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, tarama_periyot: LIKIDITE_PERIYOT_MAP[likPeriyot] || "1d",
                sweep_tipler: sweepTipler, lookback: likLookback, wick_oran: likWickOran / 100,
            });
        } else if (kaynak === "fvg") {
            const fvgTipler = [
                ...(fvgBoga  ? ["Boğa FVG"] : []),
                ...(fvgAyi   ? ["Ayı FVG"]  : []),
                ...(fvgIfvg  ? ["iFVG"]     : []),
            ];
            if (fvgTipler.length === 0) { toast.error("En az bir FVG tipi seçin"); return; }
            _apiBaslat({
                kaynak: "fvg", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, tarama_periyot: FVG_PERIYOT_MAP[fvgPeriyot] || "1d",
                fvg_tipler: fvgTipler, mum_sayisi: fvgMumSayisi,
                dip_periyot: fvgDipPeriyot, tarama_metodu: fvgMetodu, bpr_kontrol: fvgBpr,
            });
        } else if (kaynak === "ote") {
            const oteTipler = [
                ...(oteBoga ? ["Boğa OTE"] : []),
                ...(oteAyi  ? ["Ayı OTE"]  : []),
            ];
            if (oteTipler.length === 0) { toast.error("En az bir OTE tipi seçin"); return; }
            _apiBaslat({
                kaynak: "ote", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, ote_tipler: oteTipler,
                tarama_periyot: OTE_PERIYOT_MAP[otePeriyot] || "1mo",
                swing_pencere: oteSwing, mum_sayisi: oteMumSayisi,
            });
        } else if (kaynak === "obbb") {
            const obbbTipler = [
                ...(obbbBogaOB ? ["Boğa OB"] : []),
                ...(obbbAyiOB  ? ["Ayı OB"]  : []),
                ...(obbbBogaBB ? ["Boğa BB"] : []),
                ...(obbbAyiBB  ? ["Ayı BB"]  : []),
            ];
            if (obbbTipler.length === 0) { toast.error("En az bir OB/BB tipi seçin"); return; }
            _apiBaslat({
                kaynak: "obbb", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, obbb_tipler: obbbTipler,
                tarama_periyot: OBBB_PERIYOT_MAP[obbbPeriyot] || "1d",
                mum_sayisi: obbbMumSayisi, govde_oran: obbbGovdeOran / 100,
                sadece_taze: obbbSadeceTaze,
            });
        } else if (kaynak === "idm") {
            const idmTipler = [
                ...(idmBoga ? ["Boğa IDM"] : []),
                ...(idmAyi  ? ["Ayı IDM"]  : []),
            ];
            if (idmTipler.length === 0) { toast.error("En az bir IDM tipi seçin"); return; }
            _apiBaslat({
                kaynak: "idm", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, idm_tipler: idmTipler,
                tarama_periyot: IDM_PERIYOT_MAP[idmPeriyot] || "1d",
                mum_sayisi: idmMumSayisi,
            });
        } else if (kaynak === "pd") {
            const bolgeFil = [
                ...(pdDiscount    ? ["Discount"]    : []),
                ...(pdEquilibrium ? ["Equilibrium"] : []),
                ...(pdPremium     ? ["Premium"]     : []),
            ];
            if (bolgeFil.length === 0) { toast.error("En az bir bölge seçin"); return; }
            _apiBaslat({
                kaynak: "pd", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, bolge_filtre: bolgeFil,
                tarama_periyot: PD_PERIYOT_MAP[pdPeriyot] || "1d",
                range_window: pdRangeWindow, mum_sayisi: pdMumSayisi,
            });
        } else if (kaynak === "smt") {
            const smtTipler = [
                ...(smtBoga ? ["Boğa SMT"] : []),
                ...(smtAyi  ? ["Ayı SMT"]  : []),
            ];
            if (smtTipler.length === 0) { toast.error("En az bir SMT tipi seçin"); return; }
            _apiBaslat({
                kaynak: "smt", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, smt_tipler: smtTipler,
                tarama_periyot: SMT_PERIYOT_MAP[smtPeriyot] || "1d",
                referans_varlik: smtRefVarlik, swing_pencere: smtSwing,
                min_korelasyon: smtMinKor / 100, mum_sayisi: smtMumSayisi,
            });
        } else if (kaynak === "puanlama") {
            const pYonListesi = [...(pYonLong ? ["Long"] : []), ...(pYonShort ? ["Short"] : [])];
            if (pYonAktif && pYonListesi.length === 0) { toast.error("En az bir İşlem Yönü seçin"); return; }
            _apiBaslat({
                kaynak: "puanlama", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: paraBirimi,
                sim_tarihi: simTarihi, hisse_listesi: null,
                vade: pVade, min_puan: pMinPuan,
                islem_yonu: pYonAktif ? pYonListesi.join(",") : "Long,Short",
            });
        } else if (kaynak === "divergence") {
            _apiBaslat({
                kaynak: "divergence",
                mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD",
                sim_tarihi: simTarihi, hisse_listesi: null,
                tarama_periyot: DV_PERIYOT_MAP[dvPeriyot] || "1d",
                osilatorler: dvSeciliOsc,
                divergence_tipleri: dvSeciliTip,
                pivot_modu: dvPivotModu,
            });
        } else if (kaynak === "coklu") {
            if (cokluAdimlar.length === 0) { toast.error("En az bir adım ekleyin"); return; }
            _apiBaslat({
                kaynak: "coklu",
                mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD",
                sim_tarihi: simTarihi, hisse_listesi: null,
                adimlar: cokluAdimlar.map(a => ({ modul_key: a.modul_key, params: buildAdimParams(a.modul_key, a.filtre) })),
            });
        } else if (kaynak === "hacim_akisi") {
            _apiBaslat({
                kaynak: "hacim_akisi",
                mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD",
                sim_tarihi: simTarihi, hisse_listesi: null,
                lookback: haLookback,
                min_spike: haMinSpike,
                sinyal_filtre: haSeciliSinyaller,
            });
        } else if (kaynak === "hacim_profili") {
            _apiBaslat({
                kaynak: "hacim_profili",
                mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD",
                sim_tarihi: simTarihi, hisse_listesi: null,
                tarama_periyot: HP_PERIYOT_MAP[hpPeriyot] || "1d",
                sinyal_filtre: hpSeciliFiltreler,
                min_skor: hpMinSkor,
                mum_sayisi: hpMumSayisi,
            });
        } else if (kaynak === "karar_motoru") {
            const kmYonListesi = [...(kmYonLong ? ["Long"] : []), ...(kmYonShort ? ["Short"] : [])];
            if (kmYonAktif && kmYonListesi.length === 0) { toast.error("En az bir İşlem Yönü seçin"); return; }
            _apiBaslat({
                kaynak: "karar_motoru",
                mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: paraBirimi,
                sim_tarihi: simTarihi, hisse_listesi: null,
                vade: kmVade,
                islem_yonu: kmYonAktif ? kmYonListesi.join(",") : "Long,Short",
                min_puan: kmMinSkor,
            });
        } else if (kaynak === "islem_planlama") {
            const ipYonListesi = [...(ipYonLong ? ["Long"] : []), ...(ipYonShort ? ["Short"] : [])];
            if (ipYonAktif && ipYonListesi.length === 0) { toast.error("En az bir İşlem Yönü seçin"); return; }
            _apiBaslat({
                kaynak: "islem_planlama", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? "TL" : paraBirimi,
                sim_tarihi: simTarihi, hisse_listesi: null,
                islem_tipi: ipIslemTipi,
                islem_yonu: ipYonAktif ? ipYonListesi.join(",") : "Long,Short",
            });
        } else if (kaynak === "topdown") {
            _apiBaslat({
                kaynak: "topdown", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD",
                sim_tarihi: simTarihi, hisse_listesi: null,
            });
        } else if (kaynak === "killzone") {
            if (!kzSecilen) { toast.error("Bir Killzone seçin"); return; }
            if (!ytSecilen) { toast.error("Bir yapı tipi seçin"); return; }
            _apiBaslat({
                kaynak: "killzone", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: "USD", sim_tarihi: simTarihi,
                hisse_listesi: null,
                killzoneler:  [kzSecilen],
                yapi_tipleri: [ytSecilen],
                geri_bak_gun: kzGeriBak,
            });
        } else if (kaynak === "capa") {
            const capaFvgTipler = [
                ...(capaBoga ? ["Boğa FVG"] : []),
                ...(capaAyi  ? ["Ayı FVG"]  : []),
            ];
            if (capaFvgTipler.length === 0) { toast.error("En az bir FVG tipi seçin"); return; }
            _apiBaslat({
                kaynak: "capa", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null,
                fvg_tipler: capaFvgTipler,
                tolerans:   capaTolerans / 100,
            });
        } else if (kaynak === "msb") {
            const msbTipler = [
                ...(msbBoga ? ["Boğa MSB"] : []),
                ...(msbAyi  ? ["Ayı MSB"]  : []),
            ];
            if (msbTipler.length === 0) { toast.error("En az bir MSB tipi seçin"); return; }
            _apiBaslat({
                kaynak: "msb", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null, msb_tipler: msbTipler,
                tarama_periyot: MSB_PERIYOT_MAP[msbPeriyot] || "1mo",
                swing_pencere:  msbSwingPencere,
            });
        } else {
            _apiBaslat({
                kaynak: "dip_tarama", mod: piyasa === "Kripto" ? "Kripto" : "BIST",
                periyot: DIP_PERIYOT_BRIDGE[periyot] || "yil", tolerans: TOLERANS_MAP[tolerans],
                para_birimi: piyasa === "BIST" ? paraBirimi : "USD", sim_tarihi: simTarihi,
                hisse_listesi: null,
            });
        }
    };

    // ---- Tüm hisseler için yeniden başlat ----
    const tumHisselerIcinBaslat = () => {
        aktifHisselerRef.current = null;
        setHicIslemPopup(null);
        _apiBaslat({ ...gelenParams, sim_tarihi: simTarihi, hisse_listesi: null });
    };

    // ---- Tablo ----
    const siralaKol = (kol) => {
        if (siralamaKol === kol) setSiralamaYon(y => y === "asc" ? "desc" : "asc");
        else { setSiralamaKol(kol); setSiralamaYon("desc"); }
    };

    const satirlar = (() => {
        if (!sonuc?.sonuclar) return [];
        let liste = [...sonuc.sonuclar];
        // Referans fiyata göre getiri kolonu
        const getiriKol = refFiyat === "En Yüksek Fiyat" ? "En Yüksek Getiri %" : "Getiri %";
        if (filtre.size > 0) {
            liste = liste.filter(r => {
                const kazandi = (r[getiriKol] || 0) >= 0;
                return (kazandi && filtre.has("Kazanan")) || (!kazandi && filtre.has("Kaybeden"));
            });
        }
        if (durumFiltre !== "Tümü") liste = liste.filter(r => (r["Durum"] ?? r["durum"]) === durumFiltre);
        if (kaynak === "likidite") {
            if (likFiltreSweep.size > 0) liste = liste.filter(r => likFiltreSweep.has(r["Sweep Tipi"]));
            if (likFiltreEqh.size > 0) liste = liste.filter(r => likFiltreEqh.has(r["EQH/EQL"]));
            if (likFiltreKalite.size > 0) liste = liste.filter(r => likFiltreKalite.has(r["Kalite"]));
        }
        if (kaynak === "fvg") {
            if (fvgFiltreTip.size > 0) liste = liste.filter(r => fvgFiltreTip.has(r["Tip"]));
            if (fvgFiltreDurum.size > 0) liste = liste.filter(r => fvgFiltreDurum.has(r["FVG Durumu"]));
            if (fvgFiltreBpr.size > 0) liste = liste.filter(r => fvgFiltreBpr.has(r["BPR"]));
        }
        if (kaynak === "capa") {
            if (capaFiltreTip.size > 0) liste = liste.filter(r => capaFiltreTip.has(r["Tip"]));
            if (capaFiltreDurum.size > 0) liste = liste.filter(r => capaFiltreDurum.has(r["Çapa Durum"]));
            if (capaFiltreTemas.size > 0) liste = liste.filter(r => capaFiltreTemas.has(r["Temas Sayısı"]));
        }
        if (kaynak === "msb") {
            if (msbFiltreTip.size > 0) liste = liste.filter(r => msbFiltreTip.has(r["MSB Tipi"]));
            if (msbFiltreGuclu.size > 0) liste = liste.filter(r => msbFiltreGuclu.has(r["Güçlü Kırılım"]));
        }
        if (kaynak === "ote") {
            if (oteFiltreTip.size > 0) liste = liste.filter(r => oteFiltreTip.has(r["OTE Tipi"]));
        }
        if (kaynak === "obbb") {
            if (obbbFiltreTip.size > 0) liste = liste.filter(r => obbbFiltreTip.has(r["Tip"]));
            if (obbbFiltreDisp.size > 0) liste = liste.filter(r => obbbFiltreDisp.has(r["Displacement"]));
            if (obbbFiltreFvgOnay.size > 0) liste = liste.filter(r => obbbFiltreFvgOnay.has(r["FVG Onayı"]));
            if (obbbFiltreGuc.size > 0) liste = liste.filter(r => obbbFiltreGuc.has(r["Güç"]));
        }
        if (kaynak === "idm") {
            if (idmFiltreTip.size > 0) liste = liste.filter(r => idmFiltreTip.has(r["IDM Tipi"]));
            if (idmFiltreSweep.size > 0) liste = liste.filter(r => idmFiltreSweep.has(r["Sweep Durumu"]));
        }
        if (kaynak === "pd") {
            if (pdFiltreBolge.size > 0) liste = liste.filter(r => pdFiltreBolge.has(r["Bölge"]));
            if (pdFiltreYon.size > 0) liste = liste.filter(r => pdFiltreYon.has(r["Yön Önerisi"]));
        }
        if (kaynak === "smt") {
            if (smtFiltreTip.size > 0) liste = liste.filter(r => smtFiltreTip.has(r["SMT Tipi"]));
            if (smtFiltreGuc.size > 0) liste = liste.filter(r => smtFiltreGuc.has(r["Güç"]));
        }
        if (kaynak === "killzone") {
            if (kzFiltreHacim.size > 0) liste = liste.filter(r => kzFiltreHacim.has(r["Hacim Onayı"]));
            if (kzFiltreSinif.size > 0) liste = liste.filter(r => kzFiltreSinif.has(r["Sınıf"]));
        }
        if (kaynak === "topdown") {
            if (topdownFiltreTrend.size > 0) liste = liste.filter(r => topdownFiltreTrend.has(r["Trend"]));
        }
        if (kaynak === "hacim_profili") {
            if (hpFiltreSkor.size > 0) liste = liste.filter(r => hpFiltreSkor.has(r["Hacim Yoğunluk Skoru"]));
            if (hpFiltreVaDurum.size > 0) liste = liste.filter(r => hpFiltreVaDurum.has(r["VA Durumu"]));
            if (hpFiltreHvn.size > 0) liste = liste.filter(r => hpFiltreHvn.has(r["HVN Yakın"]));
            if (hpFiltreLvn.size > 0) liste = liste.filter(r => hpFiltreLvn.has(r["LVN İçi"]));
        }
        if (kaynak === "hacim_akisi") {
            if (haFiltreSinyal.size > 0) liste = liste.filter(r => haFiltreSinyal.has(r["Sinyal"]));
            if (haFiltreSkor.size > 0) liste = liste.filter(r => {
                const v = r["HA Skoru"];
                if (v == null) return false;
                return HA_SKOR_ARALIKLARI.some(a => haFiltreSkor.has(a.label) && v >= a.min && v <= a.max);
            });
            if (haFiltreSurek.size > 0) liste = liste.filter(r => {
                const v = r["Süreklilik (Gün)"];
                if (v == null) return false;
                return SUREKLILIK_ARALIKLARI.some(a => haFiltreSurek.has(a.label) && v >= a.min && v <= a.max);
            });
        }
        if (kaynak === "divergence") {
            if (dvFiltreTip.size > 0) liste = liste.filter(r => dvFiltreTip.has(r["Tip"]));
            if (dvFiltreKonf.size > 0) liste = liste.filter(r => dvFiltreKonf.has(r["Konfluence Skoru"]));
            if (dvFiltreOnay.size > 0) liste = liste.filter(r => dvFiltreOnay.has(r["Onay Durumu"]));
            if (dvFiltreGuc.size > 0) liste = liste.filter(r => dvFiltreGuc.has(r["Güç"]));
        }
        if (kaynak === "islem_planlama") {
            if (ipFiltreYon.size > 0) liste = liste.filter(r => ipFiltreYon.has(r["yon"] ?? r["Yön"]));
        }
        if (kaynak === "puanlama") {
            if (pFiltreYon.size > 0) liste = liste.filter(r => pFiltreYon.has(r["yon"] ?? r["Yön"]));
        }
        // KM filtreleri
        if (kaynak === "karar_motoru") {
            if (kmFiltreYon   !== "Tümü") liste = liste.filter(r => (r["yon"]   || "").toLowerCase().includes(kmFiltreYon.toLowerCase()));
            if (kmFiltreSinif !== "Tümü") liste = liste.filter(r => (r["sinif"] || "").startsWith(kmFiltreSinif));
            if (kmFiltreKarar !== "Tümü") liste = liste.filter(r => (r["karar"] || "").includes(kmFiltreKarar));
            if (kmFiltreHedef === "Hedef 1 Geçti") liste = liste.filter(r => {
                const f = parseFloat(String(r["Bugünkü Fiyat"] || r["En Yüksek Fiyat"] || "0").replace(",",""));
                const h = parseFloat(String(r["hedef1"] || "0").replace(",",""));
                return f > 0 && h > 0 && f >= h;
            });
            if (kmFiltreHedef === "Hedef 2 Geçti") liste = liste.filter(r => {
                const f = parseFloat(String(r["Bugünkü Fiyat"] || r["En Yüksek Fiyat"] || "0").replace(",",""));
                const h = parseFloat(String(r["hedef2"] || "0").replace(",",""));
                return f > 0 && h > 0 && f >= h;
            });
        }
        // Güven skoru filtresi — SADECE puanlama modülünde
        if (kaynak === "puanlama" && guvenFiltre === "Yüksek") liste = liste.filter(r => (r["guven_skoru"] ?? 0) >= 75);
        if (kaynak === "puanlama" && guvenFiltre === "Orta")   liste = liste.filter(r => { const g = r["guven_skoru"] ?? 0; return g >= 50 && g < 75; });
        if (kaynak === "puanlama" && guvenFiltre === "Düşük")  liste = liste.filter(r => (r["guven_skoru"] ?? 0) < 50);
        liste.sort((a, b) => {
            const kol = siralamaKol === "Getiri %" ? getiriKol : siralamaKol;
            const av = a[kol] ?? -9999;
            const bv = b[kol] ?? -9999;
            return siralamaYon === "asc" ? av - bv : bv - av;
        });
        return liste;
    })();

    // ── İndirme ───────────────────────────────────────────────────────────
    const indirVerisi = () => satirlar;

    const excelIndir = () => {
        if (!satirlar.length) return;
        const ws = XLSX.utils.json_to_sheet(indirVerisi());
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Simulasyon");
        XLSX.writeFile(wb, `gecmis_sim_${simTarihi}_${new Date()
            .toLocaleDateString("tr-TR").replace(/\./g, "-")}.xlsx`);
    };

    const csvIndir = () => {
        if (!satirlar.length) return;
        const veri = indirVerisi();
        const basliklar = Object.keys(veri[0]);
        const satirlarCsv = veri.map(row =>
            basliklar.map(h => {
                const v = row[h];
                if (v === null || v === undefined || v === "") return "";
                const str = String(v);
                return str.includes(",") || str.includes('"') ? `"${str.replace(/"/g,'""')}"` : str;
            }).join(",")
        );
        const csv = [basliklar.join(","), ...satirlarCsv].join("\n");
        const blob = new Blob(["\uFEFF" + csv], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url; a.download = `gecmis_sim_${simTarihi}.csv`;
        a.click(); URL.revokeObjectURL(url);
    };

    const pdfIndir = async () => {
        if (!satirlar.length) return;
        try {
            const { default: jsPDF } = await import("jspdf");
            const { default: autoTable } = await import("jspdf-autotable");
            const veri = indirVerisi();
            const basliklar = Object.keys(veri[0]);
            const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });
            doc.setFontSize(14); doc.text(`Geçmiş Simülasyonu — ${kaynakLabel}`, 20, 30);
            doc.setFontSize(9); doc.setTextColor(100);
            doc.text(`${satirlar.length} kayıt · ${simTarihi} · ${new Date().toLocaleDateString("tr-TR")}`, 20, 48);
            autoTable(doc, {
                head: [basliklar],
                body: veri.map(r => basliklar.map(h => String(r[h] ?? ""))),
                startY: 58,
                styles: { fontSize: 7, cellPadding: 3 },
                headStyles: { fillColor: [29, 78, 216], textColor: 255, fontStyle: "bold" },
                alternateRowStyles: { fillColor: [245, 247, 250] },
            });
            doc.save(`gecmis_sim_${simTarihi}.pdf`);
        } catch { toast.error("PDF oluşturulamadı"); }
    };

    const svgIndir = () => {
        if (!satirlar.length) return;
        const veri = indirVerisi();
        const h = Object.keys(veri[0] || {});
        const cw = Math.max(60, Math.floor(740 / h.length)), rh = 18, hh = 24, tw = cw * h.length;
        const pw = Math.max(tw + 40, 800), ph = 80 + hh + veri.length * rh;
        const esc = s => String(s).slice(0, 18).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        const rows = veri.map((r, i) => `<g transform="translate(20,${60+hh+i*rh})"><rect width="${tw}" height="${rh}" fill="${i%2===0?"#1e293b":"#0f172a"}" stroke="#334155" stroke-width="0.5"/>${h.map((k,j) => `<text x="${j*cw+4}" y="13" font-size="9" fill="#e2e8f0" font-family="Arial">${esc(r[k])}</text>`).join("")}</g>`).join("");
        const heads = h.map((k,j) => `<text x="${20+j*cw+4}" y="48" font-size="9" font-weight="bold" fill="white" font-family="Arial">${esc(k)}</text>`).join("");
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${pw}" height="${ph}"><rect width="${pw}" height="${ph}" fill="#0f172a"/><text x="20" y="22" font-size="14" font-weight="bold" fill="#e2e8f0" font-family="Arial">Geçmiş Simülasyonu — ${kaynakLabel}</text><text x="20" y="38" font-size="10" fill="#94a3b8" font-family="Arial">${veri.length} kayıt · ${new Date().toLocaleDateString("tr-TR")}</text><rect x="20" y="52" width="${tw}" height="${hh}" fill="#1d4ed8"/>${heads}${rows}</svg>`;
        const blob = new Blob([svg], { type: "image/svg+xml" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href = url;
        a.download = `gecmis_sim_${simTarihi}.svg`;
        a.click(); URL.revokeObjectURL(url);
    };

    // ── Doğruluk Analizine Gönder: kaynak → DoğrulukAnalizi endpoint eşlemesi ──
    const KAYNAK_DOGRULUK_ENDPOINT = {
        dip_tarama:      "dip-tarama-analiz",
        likidite:        "likidite-tarama-analiz",
        fvg:             "fvg-tarama-analiz",
        capa:            "capa-tarama-analiz",
        msb:             "msb-tarama-analiz",
        ote:             "ote-tarama-analiz",
        obbb:            "obbb-tarama-analiz",
        idm:             "inducement-tarama-analiz",
        pd:              "pd-tarama-analiz",
        smt:             "smt-tarama-analiz",
        killzone:        "killzone-tarama-analiz",
        topdown:         "topdown-tarama-analiz",
        islem_planlama:  "islem-planlama-analiz",
        puanlama:        "puanlama-tarama-analiz",
        karar_motoru:    "karar-motoru-analiz",
        hacim_profili:   "hacim-profili-tarama-analiz",
        hacim_akisi:     "hacim-akisi-tarama-analiz",
        divergence:      "divergence-tarama-analiz",
        coklu:           "coklu-tarama-analiz",
    };

    // ── Satır seçimi (checkbox) ──────────────────────────────────────────────
    const rowKey = r => r["Hisse"] ?? r["symbol"];
    const toggleSec = (key) => {
        setSecilenler(prev => {
            const s = new Set(prev);
            s.has(key) ? s.delete(key) : s.add(key);
            return s;
        });
    };
    const tumSecili = satirlar.length > 0 && satirlar.every(r => secilenler.has(rowKey(r)));
    const toggleTum = () => {
        tumSecili ? setSecilenler(new Set()) : setSecilenler(new Set([...secilenler, ...satirlar.map(rowKey)]));
    };
    // ── Modüle göre satır alan adı eşlemesi (frontend gösterim adı → backend DB kolonu) ──
    const ROW_ALAN_ESLEME = {
        dip_tarama: { "Alış Fiyatı": "baz_fiyat", "Dip Seviyesi": "dip_fiyat" },
        fvg: { "Alış Fiyatı": "Fiyat", "BPR": "BPR Durumu" },
        capa: { "Alış Fiyatı": "Fiyat" },
    };
    const seciliSatirlar = () => {
        const esleme = ROW_ALAN_ESLEME[kaynak] || {};
        return satirlar
            .filter(r => secilenler.has(rowKey(r)))
            .map(r => {
                const satir = { ...r, symbol: r["symbol"] ?? r["Hisse"] }; // backend "symbol" alanını bekliyor
                for (const [kaynakAlan, hedefAlan] of Object.entries(esleme)) {
                    if (r[kaynakAlan] !== undefined) satir[hedefAlan] = r[kaynakAlan];
                }
                return satir;
            });
    };
    // Çoklu Tarama: zincirde çalışan adımların modül isimlerini backend'in
    // döndürdüğü adim_sonuclari listesinden tek bir metne çevirir (toplu/batch seviyesinde
    // gönderilir — coklu_tarama_dogruluk.kaydet() bunu "moduller" adında tek bir parametre olarak alır)
    const cokluModulListesi = () => Array.isArray(sonuc?.adim_sonuclari)
        ? sonuc.adim_sonuclari.map(a => a.modul).filter(Boolean).join(" → ")
        : null;

    const dogrulukGonder = async () => {
        if (secilenler.size === 0) { toast.error("Önce en az bir hisse seçin"); return; }
        const secili = seciliSatirlar();
        if (secili.length === 0) {
            toast.error("Seçili hisseler mevcut filtrede görünmüyor. Lütfen filtreyi temizleyip tekrar seçin.");
            return;
        }
        const endpoint = KAYNAK_DOGRULUK_ENDPOINT[kaynak];
        if (!endpoint) { toast.error("Bu modül için Doğruluk Analizi henüz desteklenmiyor"); return; }
        setIslemMenuAcik(false);
        setDogrulukGonderiliyor(true);
        setDogrulukPopup("yukleniyor");
        setDogrulukSonuc(null);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            const token = session?.access_token;
            const modParam = piyasa === "Kripto" ? "Kripto" : "BIST";
            const kayitTarihi = sonuc?.sim_tarihi || simTarihi; // simülasyon tarihi — bugünün tarihi DEĞİL
            const res = await axios.post(`${API_URL}/scan/${endpoint}/kaydet`, {
                mod: modParam,
                para_birimi: paraBirimi,
                periyot: sonuc?.periyot ?? periyot,
                tolerans: sonuc?.tolerans ?? tolerans,
                tarama_periyot: sonuc?.tarama_periyot,
                hisseler: secili,
                kayit_tarihi: kayitTarihi,
                ...(kaynak === "coklu" ? { moduller: cokluModulListesi() } : {}),
            }, { headers: { Authorization: `Bearer ${token}` } });
            setDogrulukSonuc(res.data);
            setDogrulukPopup("tamam");
        } catch (e) {
            toast.error("Kaydedilemedi: " + (e.response?.data?.detail || e.message));
            setDogrulukPopup(null);
        } finally {
            setDogrulukGonderiliyor(false);
        }
    };

    // ── Eğitime Ekle (Birleşik Skor ML modeli) — Çoklu Tarama hariç tüm modüllerde ──
    const egitimeEkleGonder = async () => {
        if (kaynak === "coklu") {
            toast.error("Çoklu Tarama sonuçları Eğitime Ekle'yi desteklemiyor (modüle özgü sinyal alanları içermiyor)");
            return;
        }
        if (!sonuc?.sonuclar?.length) { toast.error("Önce simülasyon çalıştırın."); return; }
        setIslemMenuAcik(false);
        setEgitimYukleniyor(true);
        setEgitimPopup("yukleniyor");
        setEgitimPopupSonuc(null);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            const token = session?.access_token;
            const simTarihiParam = sonuc.sim_tarihi || simTarihi;
            const modParam = piyasa === "Kripto" ? "Kripto" : "BIST";
            const res = await axios.post(
                `${API_URL}/scan/birlesik-skor/sim-egitim-kaydet`,
                { kaynak, mod: modParam, sim_tarihi: simTarihiParam, sonuclar: sonuc.sonuclar },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            const d = res.data;
            if (d.basari) {
                setEgitimPopupSonuc(d);
                setEgitimPopup("tamam");
            } else {
                toast.error("Hata: " + d.mesaj);
                setEgitimPopup(null);
            }
        } catch (e) {
            toast.error("Eğitime eklenemedi: " + (e.response?.data?.detail || e.message));
            setEgitimPopup(null);
        } finally {
            setEgitimYukleniyor(false);
        }
    };

    // ── Alarm ─────────────────────────────────────────────────────────────
    const alarmAc = () => {
        if (secilenler.size === 0) { toast.error("Önce en az bir hisse seçin"); return; }
        const secililer = seciliSatirlar().map(r => ({ hisse: rowKey(r), fiyat: r["Bugünkü Fiyat"] ?? r["Alış Fiyatı"] ?? null }));
        setAlarmHisseler(secililer);
        setHedefFiyatlar({}); setAlarmMail(false); setAlarmBildirim(true);
        setAlarmPopup(true); setIslemMenuAcik(false);
    };

    const alarmKaydet = async () => {
        const eksik = alarmHisseler.find(h => !hedefFiyatlar[h.hisse] || isNaN(parseFloat(hedefFiyatlar[h.hisse])));
        if (eksik) { toast.error(`${eksik.hisse} için hedef fiyat girin`); return; }
        setAlarmKaydediliyor(true);
        try {
            const { data: { session } } = await supabase.auth.getSession();
            for (const h of alarmHisseler) {
                const fiyat = parseFloat(h.fiyat);
                const hedef = parseFloat(hedefFiyatlar[h.hisse]);
                const potansiyel = fiyat > 0 ? ((hedef - fiyat) / fiyat * 100).toFixed(2) : null;
                const { error } = await supabase.from("alerts").insert({
                    piyasa, sembol: h.hisse, para_birimi: paraBirimi,
                    fiyat, hedef_fiyat: hedef,
                    potansiyel: potansiyel ? parseFloat(potansiyel) : null,
                    bildirim_mail: alarmMail, bildirim_popup: alarmBildirim,
                    user_id: session.user.id,
                });
                if (error) throw error;
            }
            toast.success(`${alarmHisseler.length} hisse için alarm eklendi!`);
            setAlarmPopup(false); setAlarmHisseler([]);
        } catch (e) { toast.error("Alarm kaydedilemedi: " + e.message); }
        finally { setAlarmKaydediliyor(false); }
    };

    const simTarihGoster = sonuc?.sim_tarihi
        ? new Date(sonuc.sim_tarihi).toLocaleDateString("tr-TR",
            { day:"2-digit", month:"long", year:"numeric" })
        : null;

    const getiriKolRef = refFiyat === "En Yüksek Fiyat" ? "En Yüksek Getiri %" : "Getiri %";
    const round2 = v => Math.round(v * 100) / 100;

    // Referans fiyata göre özet hesaplar — aktif filtreler uygulanmış satirlar üzerinden
    const refOzet = (() => {
        if (!sonuc?.sonuclar) return null;
        const liste   = satirlar;  // filtreler uygulanmış liste
        const gecerli = liste.filter(r => r[getiriKolRef] != null);
        const kaz     = gecerli.filter(r => r[getiriKolRef] > 0).length;
        const kay     = gecerli.filter(r => r[getiriKolRef] < 0).length;
        const n   = gecerli.length;
        const ort = n ? round2(gecerli.reduce((s, r) => s + r[getiriKolRef], 0) / n) : 0;
        const enIyi = [...gecerli].sort((a, b) =>
            (b[getiriKolRef] ?? -9999) - (a[getiriKolRef] ?? -9999)
        )[0];
        return { kaz, kay, ort, enIyi, n };
    })();
    const bannerHisseler = gelenParams?.hisse_listesi;
    const kaynakLabel    = kaynak === "likidite" ? "Likidite Tarama"
                         : kaynak === "fvg"      ? "FVG Tarama"
                         : kaynak === "capa"     ? "Çapa Noktası Tarama"
                         : kaynak === "msb"      ? "MSB Tarama"
                         : kaynak === "ote"      ? "OTE Tarama"
                         : kaynak === "obbb"     ? "OB/BB Tarama"
                         : kaynak === "idm"      ? "IDM Tarama"
                         : kaynak === "pd"       ? "P/D Zone Tarama"
                         : kaynak === "smt"      ? "SMT Tarama"
                         : kaynak === "killzone" ? "Killzone Tarama"
                         : kaynak === "topdown"  ? "Topdown Cascade"
                         : kaynak === "islem_planlama" ? "İşlem Planlama"
                         : kaynak === "puanlama"     ? "Puanlama & Tahmin"
                         : kaynak === "karar_motoru" ? "Karar Motoru"
                         : kaynak === "hacim_profili" ? "Hacim Profili Tarama"
                         : kaynak === "hacim_akisi"   ? "Hacim Akışı Tarama"
                         : kaynak === "divergence"    ? "Divergence Tarama"
                         : kaynak === "coklu"         ? "Çoklu Tarama"
                         : "Dip Tarama";
    const kaynakIkon     = kaynak === "likidite" ? "🌊"
                         : kaynak === "fvg"      ? "📈"
                         : kaynak === "capa"     ? "⚓"
                         : kaynak === "msb"      ? "📐"
                         : kaynak === "ote"      ? "🎯"
                         : kaynak === "obbb"     ? "🧱"
                         : kaynak === "idm"      ? "🎣"
                         : kaynak === "pd"       ? "⚖️"
                         : kaynak === "smt"      ? "🔀"
                         : kaynak === "killzone" ? "⏰"
                         : kaynak === "topdown"  ? "🎯"
                         : kaynak === "islem_planlama" ? "📋"
                         : kaynak === "puanlama"     ? "⭐"
                         : kaynak === "karar_motoru" ? "🧭"
                         : kaynak === "hacim_profili" ? "📈"
                         : kaynak === "hacim_akisi"   ? "🌊"
                         : kaynak === "divergence"    ? "📐"
                         : kaynak === "coklu"         ? "🔗"
                         : "📊";

    const bannerDetay = kaynak === "likidite"
        ? [gelenParams?.tarama_periyot_label, gelenParams?.sweep_tipler?.join(", "), gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "fvg"
        ? [gelenParams?.tarama_periyot_label, gelenParams?.fvg_tipler?.join(", "), `${gelenParams?.mum_sayisi} mum`, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "capa"
        ? [gelenParams?.fvg_tipler?.join(", "), `%${Math.round((gelenParams?.tolerans||0)*100)} tolerans`, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "msb"
        ? [gelenParams?.msb_tipler?.join(", "), gelenParams?.tarama_periyot_label, `swing:${gelenParams?.swing_pencere}`, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "ote"
        ? [gelenParams?.ote_tipler?.join(", "), gelenParams?.tarama_periyot_label, `swing:${gelenParams?.swing_pencere}`, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "obbb"
        ? [gelenParams?.obbb_tipler?.join(", "), gelenParams?.tarama_periyot_label, `${gelenParams?.mum_sayisi} mum`, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "idm"
        ? [gelenParams?.idm_tipler?.join(", "), gelenParams?.tarama_periyot_label, `${gelenParams?.mum_sayisi} mum`, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "pd"
        ? [gelenParams?.bolge_filtre?.join(", "), gelenParams?.tarama_periyot_label, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "smt"
        ? [gelenParams?.smt_tipler?.join(", "), gelenParams?.referans_varlik, gelenParams?.tarama_periyot_label, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "killzone"
        ? [gelenParams?.killzoneler?.join(", "), gelenParams?.yapi_tipleri?.join(", "), gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "topdown"
        ? [gelenParams?.mod, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "islem_planlama"
        ? [gelenParams?.islem_tipi, gelenParams?.islem_yonu, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "puanlama"
        ? [gelenParams?.vade, gelenParams?.islem_yonu, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : kaynak === "karar_motoru"
        ? [gelenParams?.vade, gelenParams?.islem_yonu, gelenParams?.sim_tarihi].filter(Boolean).join(" · ")
        : [gelenParams?.periyotLabel, gelenParams?.toleransLabel, gelenParams?.sim_tarihi].filter(Boolean).join(" · ");

    return (
        <div style={s.sayfa}>
            <h2 style={s.baslik}>🔮 Geçmiş Simülasyon — {kaynakLabel}</h2>
            <p style={s.aciklama}>
                Seçilen yıl önce {kaynakLabel.toLowerCase()} çalıştırılmış olsaydı ve o günkü fiyatla yatırım
                yapılsaydı, bugün portföyünüz ne durumda olurdu?
            </p>

            {/* Banner */}
            {bannerHisseler?.length > 0 && (
                <div style={s.banner}>
                    <span>{kaynakIkon} {kaynakLabel}'dan aktarıldı —</span>
                    <strong>{bannerHisseler.length} hisse</strong>
                    <span>·</span>
                    <span>{bannerDetay}</span>
                    <span style={{ marginLeft: "6px", color: "#94a3b8", fontSize: "12px" }}>
                        ({bannerHisseler.slice(0, 8).join(", ")}{bannerHisseler.length > 8 ? ` +${bannerHisseler.length - 8}` : ""})
                    </span>
                </div>
            )}

            {/* Filtreler */}
            <div style={{ ...s.filtreSatiri, ...(calisiyor ? { opacity:0.5, pointerEvents:"none" } : {}) }}>

                {/* MODÜL SEÇİCİ — her zaman ilk sırada */}
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Modül</label>
                    <select style={{ ...s.select, fontWeight: "600", color: "#93c5fd" }}
                        value={kaynak}
                        onChange={e => { setKaynak(e.target.value); setSonuc(null); aktifHisselerRef.current = null; }}>
                        <option value="dip_tarama">📊 Dip Tarama</option>
                        <option value="likidite">🌊 Likidite Tarama</option>
                        <option value="fvg">📈 FVG Tarama</option>
                        <option value="capa">⚓ Çapa Noktası Tarama</option>
                        <option value="msb">📐 MSB Tarama</option>
                        <option value="ote">🎯 OTE Tarama</option>
                        <option value="obbb">🧱 OB/BB Tarama</option>
                        <option value="idm">🎣 IDM Tarama</option>
                        <option value="pd">⚖️ P/D Zone Tarama</option>
                        <option value="smt">🔀 SMT Tarama</option>
                        <option value="killzone">⏰ Killzone Tarama</option>
                        <option value="topdown">🎯 Topdown Cascade</option>
                        <option value="hacim_profili">📊 Hacim Profili Tarama</option>
                        <option value="hacim_akisi">🌊 Hacim Akışı Tarama</option>
                        <option value="divergence">📐 Divergence Tarama</option>
                        <option value="coklu">🔗 Çoklu Tarama</option>
                        <option value="islem_planlama">📋 İşlem Planlama</option>
                        <option value="puanlama">⭐ Puanlama & Tahmin</option>
                        <option value="karar_motoru">🧭 Karar Motoru</option>
                    </select>
                </div>

                {/* ORTAK: Piyasa */}
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Piyasa</label>
                    <select style={s.select} value={piyasa}
                        onChange={e => { setPiyasa(e.target.value); setSonuc(null); aktifHisselerRef.current = null; }}>
                        {piyasaSecenekleri.length === 0
                            ? <option>Yükleniyor...</option>
                            : piyasaSecenekleri.map(p => <option key={p}>{p}</option>)
                        }
                    </select>
                </div>

                {/* ORTAK: Para Birimi — Piyasa'dan hemen sonra, her piyasada görünür */}
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Para Birimi</label>
                    <select style={s.select} value={paraBirimi} onChange={e => setParaBirimi(e.target.value)}>
                        {paraBirimiSecenekleri.length === 0
                            ? <option>Yükleniyor...</option>
                            : paraBirimiSecenekleri.map(p => <option key={p} value={p}>{p}</option>)
                        }
                    </select>
                </div>

                {/* ÇOKLU TARAMA: Simülasyon Tarihi + Referans Fiyat + Başlat — Para Birimi'nden hemen sonra */}
                {kaynak === "coklu" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Simülasyon Tarihi</label>
                        <TurkceAySecici value={simTarihi} onChange={setSimTarihi} />
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Referans Fiyat</label>
                        <div style={{ display: "flex", gap: "6px", padding: "6px 10px",
                            border: "1px solid #475569", borderRadius: "8px", background: "#0f172a" }}>
                            {["Bugünkü Fiyat", "En Yüksek Fiyat"].map(opt => (
                                <button key={opt} onClick={() => setRefFiyat(opt)} style={{
                                    padding: "6px 12px", borderRadius: "8px", cursor: "pointer",
                                    fontSize: "12px", fontWeight: "500", whiteSpace: "nowrap",
                                    background: refFiyat === opt ? "#7c3aed" : "#0f172a",
                                    color:      "#e2e8f0",
                                    border:     refFiyat === opt ? "1px solid #7c3aed" : "1px solid #475569",
                                }}>
                                    {opt === "Bugünkü Fiyat" ? "📅 Bugünkü" : "🏆 En Yüksek"}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div style={{display:"flex", flexDirection:"column", alignSelf:"flex-end", gap:"4px"}}>
                        <button
                            style={{ ...s.buton, background: calisiyor ? "#94a3b8" : "#2563eb" }}
                            onClick={simBaslat}
                            disabled={calisiyor}
                        >
                            {calisiyor ? "⏳ Taranıyor..." : "▶ Simülasyonu Başlat"}
                        </button>
                    </div>
                </>)}

                {/* DİP TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "dip_tarama" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Periyot</label>
                        <select style={s.select} value={periyot} onChange={e => setPeriyot(e.target.value)}>
                            {dipPeriyotSecenekleri.length === 0
                                ? <option>Yükleniyor...</option>
                                : dipPeriyotSecenekleri.map(p => <option key={p}>{p}</option>)
                            }
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Tolerans<BilgiIkonu alan="Tolerans"/></label>
                        <select style={s.select} value={tolerans} onChange={e => setTolerans(e.target.value)}>
                            {Object.keys(TOLERANS_MAP).map(t => <option key={t}>{t}</option>)}
                        </select>
                    </div>
                </>)}

                {/* MSB TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "msb" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>MSB Tipi</label>
                        <div style={{ display:"flex", flexDirection:"column", gap:"4px",
                                      padding:"6px 10px", border:"1px solid #475569",
                                      borderRadius:"8px", background:"#1e293b" }}>
                            <label style={{ display:"flex", alignItems:"center", gap:"6px",
                                           cursor:"pointer", fontSize:"13px", color:"#16a34a",
                                           fontWeight:"500", whiteSpace:"nowrap" }}>
                                <input type="checkbox" checked={msbBoga}
                                    onChange={e => setMsbBoga(e.target.checked)} />
                                Boğa MSB
                            </label>
                            <label style={{ display:"flex", alignItems:"center", gap:"6px",
                                           cursor:"pointer", fontSize:"13px", color:"#dc2626",
                                           fontWeight:"500", whiteSpace:"nowrap" }}>
                                <input type="checkbox" checked={msbAyi}
                                    onChange={e => setMsbAyi(e.target.checked)} />
                                Ayı MSB
                            </label>
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={msbPeriyot} onChange={e => setMsbPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(MSB_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Swing Penceresi<BilgiIkonu alan="Swing Penceresi"/></label>
                        <select style={s.select} value={msbSwingPencere}
                            onChange={e => setMsbSwingPencere(Number(e.target.value))}>
                            {[2,3,4,5,6,7,8].map(v => <option key={v} value={v}>{v} mum</option>)}
                        </select>
                    </div>
                </>)}

                {/* OTE TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "ote" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>OTE Tipi</label>
                        <div style={{display:"flex",flexDirection:"column",gap:"4px",padding:"6px 10px",
                                     border:"1px solid #475569",borderRadius:"8px",background:"#1e293b"}}>
                            {[["Boğa OTE","#16a34a",oteBoga,setOteBoga],
                              ["Ayı OTE", "#dc2626",oteAyi, setOteAyi]].map(([label,renk,val,setter]) => (
                                <label key={label} style={{display:"flex",alignItems:"center",gap:"6px",
                                    cursor:"pointer",fontSize:"13px",color:renk,fontWeight:"500",whiteSpace:"nowrap"}}>
                                    <input type="checkbox" checked={val} onChange={e=>setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={otePeriyot} onChange={e=>setOtePeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(OTE_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Swing Penceresi<BilgiIkonu alan="Swing Penceresi"/></label>
                        <select style={s.select} value={oteSwing} onChange={e=>setOteSwing(Number(e.target.value))}>
                            {[2,3,5].map(v => <option key={v} value={v}>{v} Mum</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Mum Sayısı<BilgiIkonu alan="Mum Sayısı"/></label>
                        <select style={s.select} value={oteMumSayisi} onChange={e=>setOteMumSayisi(Number(e.target.value))}>
                            {[50,100,150,200,300].map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                </>)}

                {/* OB/BB TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "obbb" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>OB/BB Tipi</label>
                        <div style={{display:"flex",flexDirection:"column",gap:"4px",padding:"6px 10px",
                                     border:"1px solid #475569",borderRadius:"8px",background:"#1e293b"}}>
                            {[["Boğa OB","#16a34a",obbbBogaOB,setObbbBogaOB],
                              ["Ayı OB", "#dc2626",obbbAyiOB, setObbbAyiOB],
                              ["Boğa BB","#059669",obbbBogaBB,setObbbBogaBB],
                              ["Ayı BB", "#f87171",obbbAyiBB, setObbbAyiBB]].map(([label,renk,val,setter]) => (
                                <label key={label} style={{display:"flex",alignItems:"center",gap:"6px",
                                    cursor:"pointer",fontSize:"13px",color:renk,fontWeight:"500",whiteSpace:"nowrap"}}>
                                    <input type="checkbox" checked={val} onChange={e=>setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={obbbPeriyot} onChange={e=>setObbbPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(OBBB_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Mum Sayısı<BilgiIkonu alan="Mum Sayısı"/></label>
                        <select style={s.select} value={obbbMumSayisi} onChange={e=>setObbbMumSayisi(Number(e.target.value))}>
                            {[100,200,300,500].map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Min Gövde Oranı<BilgiIkonu alan="Min Gövde Oranı"/></label>
                        <select style={s.select} value={obbbGovdeOran} onChange={e=>setObbbGovdeOran(Number(e.target.value))}>
                            {[40,50,60,70].map(v => <option key={v} value={v}>%{v}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Sadece Taze<BilgiIkonu alan="Sadece Taze"/></label>
                        <label style={{display:"flex",alignItems:"center",gap:"6px",cursor:"pointer",
                                       fontSize:"13px",padding:"8px 10px",border:"1px solid #475569",
                                       borderRadius:"8px",background:"#1e293b"}}>
                            <input type="checkbox" checked={obbbSadeceTaze} onChange={e=>setObbbSadeceTaze(e.target.checked)} />
                            Sadece Taze OB/BB
                        </label>
                    </div>
                </>)}

                {/* PUANLAMA & TAHMİN'E ÖZGÜ FİLTRELER */}
                

                {/* PUANLAMA & TAHMİN'E ÖZGÜ FİLTRELER */}
                {kaynak === "puanlama" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Vade</label>
                        <select style={s.select} value={pVade} onChange={e=>setPVade(e.target.value)}>
                            {PUANLAMA_VADE_OPTS.map(v => <option key={v} value={v} disabled={!pVadeAktifMi(v)}>{v}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>İşlem Yönü<BilgiIkonu alan="İşlem Yönü"/></label>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px", padding: "6px 10px",
                                      border: "1px solid #475569", borderRadius: "8px",
                                      background: pYonAktif ? "#1e293b" : "#0f172a", opacity: pYonAktif ? 1 : 0.5 }}>
                            {[["Long", "#16a34a", pYonLong, setPYonLong],
                              ["Short", "#dc2626", pYonShort, setPYonShort]].map(([label, renk, val, setter]) => (
                                <label key={label} style={{ display: "flex", alignItems: "center", gap: "6px",
                                    cursor: pYonAktif ? "pointer" : "not-allowed", fontSize: "13px",
                                    color: renk, fontWeight: "500", whiteSpace: "nowrap" }}>
                                    <input type="checkbox" checked={val} disabled={!pYonAktif}
                                        onChange={e => setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Min Puan<BilgiIkonu alan="Min. Puan"/></label>
                        <select style={s.select} value={pMinPuan} onChange={e=>setPMinPuan(Number(e.target.value))}>
                            {[0,25,50,60,75].map(v => <option key={v} value={v}>{v}+</option>)}
                        </select>
                    </div>
                </>)}

                {/* DIVERGENCE'A ÖZGÜ FİLTRELER */}
                {kaynak === "divergence" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Periyot</label>
                        <select style={s.select} value={dvPeriyot} onChange={e=>setDvPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(DV_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Pivot Modu<BilgiIkonu alan="Pivot Modu"/></label>
                        <select style={s.select} value={dvPivotModu} onChange={e=>setDvPivotModu(e.target.value)}>
                            <option value="fractal">Fractal</option>
                            <option value="zigzag">ZigZag</option>
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Osilatörler<BilgiIkonu alan="Osilatörler"/></label>
                        <div style={{border:"1px solid #334155", borderRadius:"8px", padding:"10px",
                                     display:"flex", flexDirection:"column", gap:"8px", marginTop:"4px",
                                     background:"#0f172a"}}>
                            {DV_OSC_OPTS.map(o => (
                                <label key={o} style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontSize:"13px",color:"#e2e8f0"}}>
                                    <input type="checkbox" checked={!!dvOsilatorler[o]}
                                        onChange={e => setDvOsilatorler(prev => ({...prev, [o]: e.target.checked}))}
                                        style={{cursor:"pointer",width:"14px",height:"14px"}} />
                                    {o}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Divergence Tipleri<BilgiIkonu alan="Divergence Tipleri"/></label>
                        <div style={{border:"1px solid #334155", borderRadius:"8px", padding:"10px",
                                     display:"flex", flexDirection:"column", gap:"8px", marginTop:"4px",
                                     background:"#0f172a"}}>
                            {DV_TIP_OPTS.map(t => (
                                <label key={t} style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontSize:"13px",color:"#e2e8f0"}}>
                                    <input type="checkbox" checked={!!dvTipler[t]}
                                        onChange={e => setDvTipler(prev => ({...prev, [t]: e.target.checked}))}
                                        style={{cursor:"pointer",width:"14px",height:"14px"}} />
                                    {t}
                                </label>
                            ))}
                        </div>
                    </div>
                </>)}

                {/* HACİM AKIŞI'NA ÖZGÜ FİLTRELER */}
                {kaynak === "hacim_akisi" && (<>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Ort. Pencere (Gün)<BilgiIkonu alan="Ort. Pencere (Gün)"/></label>
                        <select style={s.select} value={haLookback} onChange={e=>setHaLookback(Number(e.target.value))}>
                            {[5,10,20,30,40,50].map(v => <option key={v} value={v}>{v} Gün</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Min Spike (xOrt.)<BilgiIkonu alan="Min Spike (xOrt.)"/></label>
                        <select style={s.select} value={haMinSpike} onChange={e=>setHaMinSpike(Number(e.target.value))}>
                            {[1.0,1.2,1.5,2.0,2.5,3.0].map(v => <option key={v} value={v}>{v}x</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Sinyal Filtresi<BilgiIkonu alan="Sinyal Tipi"/></label>
                        <div style={{border:"1px solid #334155", borderRadius:"8px", padding:"10px",
                                     display:"flex", flexDirection:"column", gap:"8px", marginTop:"4px",
                                     background:"#0f172a"}}>
                            {HACISI_SINYAL_OPTS.map(s => (
                                <label key={s} style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontSize:"13px",color:"#e2e8f0"}}>
                                    <input type="checkbox" checked={!!haSinyalFiltre[s]}
                                        onChange={e => setHaSinyalFiltre(prev => ({...prev, [s]: e.target.checked}))}
                                        style={{cursor:"pointer",width:"14px",height:"14px"}} />
                                    {s}
                                </label>
                            ))}
                        </div>
                    </div>
                </>)}

                {/* HACİM PROFİLİ'NE ÖZGÜ FİLTRELER */}
                {kaynak === "hacim_profili" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={hpPeriyot} onChange={e=>setHpPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(HP_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Sinyal Filtresi<BilgiIkonu alan="Sinyal Filtresi"/></label>
                        <div style={{border:"1px solid #334155", borderRadius:"8px", padding:"10px",
                                     display:"flex", flexDirection:"column", gap:"8px", marginTop:"4px",
                                     background:"#0f172a"}}>
                            {HP_SINYAL_FILTRELER.map(f => (
                                <label key={f} style={{display:"flex",alignItems:"center",gap:"8px",cursor:"pointer",fontSize:"13px",color:"#e2e8f0"}}>
                                    <input type="checkbox" checked={!!hpSinyalFiltre[f]}
                                        onChange={e => setHpSinyalFiltre(prev => ({...prev, [f]: e.target.checked}))}
                                        style={{cursor:"pointer",width:"14px",height:"14px"}} />
                                    {f}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Min Hacim Skoru<BilgiIkonu alan="Min Hacim Skoru"/></label>
                        <select style={s.select} value={hpMinSkor} onChange={e=>setHpMinSkor(Number(e.target.value))}>
                            {[0,2,3,4,5,6,7].map(v => <option key={v} value={v}>{v === 0 ? "Tümü" : `${v}+`}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Mum Sayısı<BilgiIkonu alan="Mum Sayısı"/></label>
                        <select style={s.select} value={hpMumSayisi} onChange={e=>setHpMumSayisi(Number(e.target.value))}>
                            {[100,200,300,500].map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                </>)}

                {/* KARAR MOTORU'YA ÖZGÜ FİLTRELER */}
                {kaynak === "karar_motoru" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Vade</label>
                        <select style={s.select} value={kmVade} onChange={e=>setKmVade(e.target.value)}>
                            {KM_VADE_OPTS.map(v => <option key={v} value={v} disabled={!kmVadeAktifMi(v)}>{v}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>İşlem Yönü<BilgiIkonu alan="İşlem Yönü"/></label>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px", padding: "6px 10px",
                                      border: "1px solid #475569", borderRadius: "8px",
                                      background: kmYonAktif ? "#1e293b" : "#0f172a", opacity: kmYonAktif ? 1 : 0.5 }}>
                            {[["Long", "#16a34a", kmYonLong, setKmYonLong],
                              ["Short", "#dc2626", kmYonShort, setKmYonShort]].map(([label, renk, val, setter]) => (
                                <label key={label} style={{ display: "flex", alignItems: "center", gap: "6px",
                                    cursor: kmYonAktif ? "pointer" : "not-allowed", fontSize: "13px",
                                    color: renk, fontWeight: "500", whiteSpace: "nowrap" }}>
                                    <input type="checkbox" checked={val} disabled={!kmYonAktif}
                                        onChange={e => setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Min. Skor<BilgiIkonu alan="Min. Skor"/></label>
                        <select style={s.select} value={kmMinSkor} onChange={e=>setKmMinSkor(Number(e.target.value))}>
                            {KM_MIN_SKOR_OPTS.map(v => <option key={v} value={v}>{v === 0 ? "Tümü" : `${v}+`}</option>)}
                        </select>
                    </div>
                </>)}

                {/* İŞLEM PLANLAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "islem_planlama" && (<>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>İşlem Tipi<BilgiIkonu alan="İşlem Tipi"/></label>
                        <div style={{ display: "flex", gap: "6px" }}>
                            {[["Kaldıraç", !ipSpotZorunlu], ["Spot", !ipKaldiracZorunlu]].map(([v, aktif]) => (
                                <button key={v} type="button" disabled={!aktif}
                                    onClick={() => aktif && setIpIslemTipi(v)}
                                    style={{ padding: "6px 14px", borderRadius: "8px", fontSize: "13px", fontWeight: 600,
                                        cursor: aktif ? "pointer" : "not-allowed",
                                        border: `2px solid ${ipIslemTipi === v ? "#3b82f6" : "#334155"}`,
                                        background: ipIslemTipi === v ? "#3b82f622" : "transparent",
                                        color: !aktif ? "#475569" : (ipIslemTipi === v ? "#3b82f6" : "#94a3b8"),
                                        opacity: aktif ? 1 : 0.5 }}>
                                    {v}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>İşlem Yönü<BilgiIkonu alan="İşlem Yönü"/></label>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px", padding: "6px 10px",
                                      border: "1px solid #475569", borderRadius: "8px",
                                      background: ipYonAktif ? "#1e293b" : "#0f172a", opacity: ipYonAktif ? 1 : 0.5 }}>
                            {[["Long", "#16a34a", ipYonLong, setIpYonLong],
                              ["Short", "#dc2626", ipYonShort, setIpYonShort]].map(([label, renk, val, setter]) => (
                                <label key={label} style={{ display: "flex", alignItems: "center", gap: "6px",
                                    cursor: ipYonAktif ? "pointer" : "not-allowed", fontSize: "13px",
                                    color: renk, fontWeight: "500", whiteSpace: "nowrap" }}>
                                    <input type="checkbox" checked={val} disabled={!ipYonAktif}
                                        onChange={e => setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                </>)}

                {/* KİLLZONE TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "killzone" && (<>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Killzone Seçimi<BilgiIkonu alan="Killzone Seçimi"/></label>
                        <div style={{ position: "relative" }}>
                            <button type="button" onClick={() => setKzComboAcik(v => !v)} style={{
                                ...s.select, cursor: "pointer", display: "flex", alignItems: "center",
                                justifyContent: "space-between", minWidth: "160px", textAlign: "left" }}>
                                <span>{kzSecilen}</span>
                                <span style={{ marginLeft: 8, color: "#94a3b8" }}>▾</span>
                            </button>
                            {kzComboAcik && (
                                <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 50,
                                    display: "flex", flexDirection: "column", gap: "3px", padding: "8px 10px",
                                    border: "1px solid #475569", borderRadius: "8px", background: "#1e293b",
                                    maxHeight: "220px", overflowY: "auto", minWidth: "220px",
                                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)" }}>
                                    {Object.entries(KILLZONE_TANIMLARI_SIM).map(([k, renk]) => {
                                        const secili = kzSecilen === k;
                                        return (
                                            <div key={k}
                                                onClick={() => { setKzSecilen(k); setKzComboAcik(false); }}
                                                style={{display:"flex",alignItems:"center",cursor:"pointer",
                                                    fontSize:"12px",color: secili ? renk : "#94a3b8",
                                                    fontWeight: secili ? "700" : "500",whiteSpace:"nowrap",
                                                    padding:"4px 8px",borderRadius:"6px",
                                                    background: secili ? renk + "22" : "transparent"}}>
                                                {k}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Yapı Tipi<BilgiIkonu alan="Yapı Tipi"/></label>
                        <div style={{ position: "relative" }}>
                            <button type="button" onClick={() => setYtComboAcik(v => !v)} style={{
                                ...s.select, cursor: "pointer", display: "flex", alignItems: "center",
                                justifyContent: "space-between", minWidth: "140px", textAlign: "left" }}>
                                <span>{ytSecilen}</span>
                                <span style={{ marginLeft: 8, color: "#94a3b8" }}>▾</span>
                            </button>
                            {ytComboAcik && (
                                <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0, zIndex: 50,
                                    display: "flex", flexDirection: "column", gap: "4px", padding: "8px 10px",
                                    border: "1px solid #475569", borderRadius: "8px", background: "#1e293b",
                                    minWidth: "140px", boxShadow: "0 8px 24px rgba(0,0,0,0.4)" }}>
                                    {["FVG","MSB","Sweep"].map(label => {
                                        const secili = ytSecilen === label;
                                        const renk = YT_RENK[label];
                                        return (
                                            <div key={label}
                                                onClick={() => { setYtSecilen(label); setYtComboAcik(false); }}
                                                style={{display:"flex",alignItems:"center",cursor:"pointer",
                                                    fontSize:"13px",color: secili ? renk : "#94a3b8",
                                                    fontWeight: secili ? "700" : "500",
                                                    padding:"4px 8px",borderRadius:"6px",
                                                    background: secili ? renk + "22" : "transparent"}}>
                                                {label}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Geriye Bakış (Gün)<BilgiIkonu alan="Geriye Bakış (Gün)"/></label>
                        <select style={s.select} value={kzGeriBak} onChange={e=>setKzGeriBak(Number(e.target.value))}>
                            {[3,5,7,10].map(v => <option key={v} value={v}>{v} gün</option>)}
                        </select>
                    </div>
                </>)}

                {/* SMT TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "smt" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Referans Varlık</label>
                        <select style={s.select} value={smtRefVarlik} onChange={e=>setSmtRefVarlik(e.target.value)}>
                            {(SMT_REFERANS[piyasa === "Kripto" ? "Kripto" : "BIST"] || []).map(v => (
                                <option key={v}>{v}</option>
                            ))}
                            {piyasa !== "Kripto" && (
                                <option value="XU030 (BIST30)" disabled style={{color:"#94a3b8"}}>
                                    XU030 (BIST30) — Yakında
                                </option>
                            )}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>SMT Tipi</label>
                        <div style={{display:"flex",flexDirection:"column",gap:"4px",padding:"6px 10px",
                                     border:"1px solid #475569",borderRadius:"8px",background:"#1e293b"}}>
                            {[["Boğa SMT","#16a34a",smtBoga,setSmtBoga],
                              ["Ayı SMT", "#dc2626",smtAyi, setSmtAyi]].map(([label,renk,val,setter]) => (
                                <label key={label} style={{display:"flex",alignItems:"center",gap:"6px",
                                    cursor:"pointer",fontSize:"13px",color:renk,fontWeight:"500",whiteSpace:"nowrap"}}>
                                    <input type="checkbox" checked={val} onChange={e=>setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={smtPeriyot} onChange={e=>setSmtPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(SMT_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Swing Penceresi<BilgiIkonu alan="Swing Penceresi"/></label>
                        <select style={s.select} value={smtSwing} onChange={e=>setSmtSwing(Number(e.target.value))}>
                            {[2,3,4,5].map(v => <option key={v} value={v}>{v} mum</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Min. Korelasyon<BilgiIkonu alan="Min. Korelasyon"/></label>
                        <select style={s.select} value={smtMinKor} onChange={e=>setSmtMinKor(Number(e.target.value))}>
                            {[50,60,70,80,90].map(v => <option key={v} value={v}>%{v}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Mum Sayısı<BilgiIkonu alan="Mum Sayısı"/></label>
                        <select style={s.select} value={smtMumSayisi} onChange={e=>setSmtMumSayisi(Number(e.target.value))}>
                            {[100,200,300].map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                </>)}

                {/* P/D ZONE TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "pd" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Bölge Filtresi</label>
                        <div style={{display:"flex",flexDirection:"column",gap:"4px",padding:"6px 10px",
                                     border:"1px solid #475569",borderRadius:"8px",background:"#1e293b"}}>
                            {[["Discount","#16a34a",pdDiscount,setPdDiscount],
                              ["Equilibrium","#eab308",pdEquilibrium,setPdEquilibrium],
                              ["Premium","#dc2626",pdPremium,setPdPremium]].map(([label,renk,val,setter]) => (
                                <label key={label} style={{display:"flex",alignItems:"center",gap:"6px",
                                    cursor:"pointer",fontSize:"13px",color:renk,fontWeight:"500",whiteSpace:"nowrap"}}>
                                    <input type="checkbox" checked={val} onChange={e=>setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={pdPeriyot} onChange={e=>setPdPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(PD_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Range Penceresi<BilgiIkonu alan="Range Penceresi"/></label>
                        <select style={s.select} value={pdRangeWindow} onChange={e=>setPdRangeWindow(Number(e.target.value))}>
                            {[10,20,50,100].map(v => <option key={v} value={v}>{v} Mum</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Mum Sayısı<BilgiIkonu alan="Mum Sayısı"/></label>
                        <select style={s.select} value={pdMumSayisi} onChange={e=>setPdMumSayisi(Number(e.target.value))}>
                            {[100,200,300,500].map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                </>)}

                {/* IDM TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "idm" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>IDM Tipi</label>
                        <div style={{display:"flex",flexDirection:"column",gap:"4px",padding:"6px 10px",
                                     border:"1px solid #475569",borderRadius:"8px",background:"#1e293b"}}>
                            {[["Boğa IDM","#16a34a",idmBoga,setIdmBoga],
                              ["Ayı IDM", "#dc2626",idmAyi, setIdmAyi]].map(([label,renk,val,setter]) => (
                                <label key={label} style={{display:"flex",alignItems:"center",gap:"6px",
                                    cursor:"pointer",fontSize:"13px",color:renk,fontWeight:"500",whiteSpace:"nowrap"}}>
                                    <input type="checkbox" checked={val} onChange={e=>setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={idmPeriyot} onChange={e=>setIdmPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(IDM_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Mum Sayısı<BilgiIkonu alan="Mum Sayısı"/></label>
                        <select style={s.select} value={idmMumSayisi} onChange={e=>setIdmMumSayisi(Number(e.target.value))}>
                            {[100,200,300,500].map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                    </div>
                </>)}

                {/* ÇAPA NOKTASI TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "capa" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>FVG Tipi</label>
                        <div style={{ display:"flex", flexDirection:"column", gap:"4px",
                                      padding:"6px 10px", border:"1px solid #475569",
                                      borderRadius:"8px", background:"#1e293b" }}>
                            <label style={{ display:"flex", alignItems:"center", gap:"6px",
                                           cursor:"pointer", fontSize:"13px", color:"#16a34a",
                                           fontWeight:"500", whiteSpace:"nowrap" }}>
                                <input type="checkbox" checked={capaBoga}
                                    onChange={e => setCapaBoga(e.target.checked)} />
                                Boğa FVG
                            </label>
                            <label style={{ display:"flex", alignItems:"center", gap:"6px",
                                           cursor:"pointer", fontSize:"13px", color:"#dc2626",
                                           fontWeight:"500", whiteSpace:"nowrap" }}>
                                <input type="checkbox" checked={capaAyi}
                                    onChange={e => setCapaAyi(e.target.checked)} />
                                Ayı FVG
                            </label>
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Tolerans<BilgiIkonu alan="Çapa Tolerans"/></label>
                        <select style={s.select} value={capaTolerans}
                            onChange={e => setCapaTolerans(Number(e.target.value))}>
                            {CAPA_TOLERANS_LIST.map(v => (
                                <option key={v} value={v}>%{v}</option>
                            ))}
                        </select>
                    </div>
                </>)}

                {/* FVG TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "fvg" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>FVG Tipi</label>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px",
                                      padding: "6px 10px", border: "1px solid #475569",
                                      borderRadius: "8px", background: "#1e293b" }}>
                            {[["Boğa FVG","#16a34a",fvgBoga,setFvgBoga],
                              ["Ayı FVG", "#dc2626",fvgAyi, setFvgAyi],
                              ["iFVG",    "#d97706",fvgIfvg,setFvgIfvg]
                            ].map(([label, renk, val, setter]) => (
                                <label key={label} style={{ display:"flex", alignItems:"center", gap:"6px",
                                    cursor:"pointer", fontSize:"13px", color: renk, fontWeight:"500", whiteSpace:"nowrap" }}>
                                    <input type="checkbox" checked={val} onChange={e => setter(e.target.checked)} />
                                    {label}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>BPR Kontrol<BilgiIkonu alan="BPR Kontrol"/></label>
                        <div style={{ display: "flex", gap: "10px", padding: "8px 10px",
                                      border: "1px solid #475569", borderRadius: "8px",
                                      background: fvgBprAktif ? "#1e293b" : "#0f172a",
                                      opacity: fvgBprAktif ? 1 : 0.5 }}>
                            {["Evet","Hayır"].map(v => (
                                <label key={v} style={{ display:"flex", alignItems:"center", gap:"6px",
                                    cursor: fvgBprAktif ? "pointer" : "not-allowed", fontSize:"13px",
                                    color:"#e2e8f0", fontWeight:"500", whiteSpace:"nowrap" }}>
                                    <input type="radio" name="fvgBprRadio" disabled={!fvgBprAktif}
                                        checked={fvgBpr === (v === "Evet")}
                                        onChange={() => setFvgBpr(v === "Evet")} />
                                    {v}
                                </label>
                            ))}
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={fvgPeriyot} onChange={e => setFvgPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(FVG_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Tarama Metodu<BilgiIkonu alan="Tarama Metodu"/></label>
                        <select style={s.select} value={fvgMetodu} onChange={e => setFvgMetodu(e.target.value)}>
                            <option>Dip Altı Hisselerde</option>
                            <option>Tüm Hisselerde</option>
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Dip Periyodu<BilgiIkonu alan="Dip Periyodu"/></label>
                        <select style={{ ...s.select, opacity: fvgMetodu === "Dip Altı Hisselerde" ? 1 : 0.5 }}
                            value={fvgDipPeriyot} disabled={fvgMetodu !== "Dip Altı Hisselerde"}
                            onChange={e => setFvgDipPeriyot(e.target.value)}>
                            {["Yıllık","6 Aylık","3 Aylık","Aylık"].map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Mum Sayısı<BilgiIkonu alan="Mum Sayısı"/></label>
                        <select style={s.select} value={fvgMumSayisi} onChange={e => setFvgMumSayisi(Number(e.target.value))}>
                            {[25,50,100,150,200,250,300,350,400,500,600,700].map(v => <option key={v} value={v}>{v} mum</option>)}
                        </select>
                    </div>
                </>)}

                {/* LİKİDİTE TARAMA'YA ÖZGÜ FİLTRELER */}
                {kaynak === "likidite" && (<>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Tarama Periyodu</label>
                        <select style={s.select} value={likPeriyot} onChange={e => setLikPeriyot(e.target.value)}>
                            {(periyotSecenekleri.length > 0 ? periyotSecenekleri : Object.keys(LIKIDITE_PERIYOT_MAP)).map(p => <option key={p}>{p}</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={s.etiket}>Sweep Tipi</label>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px",
                                      padding: "6px 10px", border: "1px solid #475569",
                                      borderRadius: "8px", background: "#1e293b" }}>
                            <label style={{ display: "flex", alignItems: "center", gap: "6px",
                                           cursor: "pointer", fontSize: "13px", color: "#16a34a",
                                           fontWeight: "500", whiteSpace: "nowrap" }}>
                                <input type="checkbox" checked={likSweepBoga}
                                    onChange={e => setLikSweepBoga(e.target.checked)} />
                                Boğa Sweep
                            </label>
                            <label style={{ display: "flex", alignItems: "center", gap: "6px",
                                           cursor: "pointer", fontSize: "13px", color: "#dc2626",
                                           fontWeight: "500", whiteSpace: "nowrap" }}>
                                <input type="checkbox" checked={likSweepAyi}
                                    onChange={e => setLikSweepAyi(e.target.checked)} />
                                Ayı Sweep
                            </label>
                        </div>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Lookback (Mum)<BilgiIkonu alan="Lookback (Mum)"/></label>
                        <select style={s.select} value={likLookback}
                            onChange={e => setLikLookback(Number(e.target.value))}>
                            {[50, 60, 75, 100].map(v => <option key={v} value={v}>{v} Mum</option>)}
                        </select>
                    </div>
                    <div style={s.filtreGrup}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>Min Fitil Oranı<BilgiIkonu alan="Min Fitil Oranı"/></label>
                        <select style={s.select} value={likWickOran}
                            onChange={e => setLikWickOran(Number(e.target.value))}>
                            {[30, 40, 50, 60, 70].map(v => <option key={v} value={v}>%{v}</option>)}
                        </select>
                    </div>
                </>)}

                {/* ÇOKLU TARAMA'YA ÖZGÜ: Adım Zinciri */}
                {kaynak === "coklu" && (
                    <div style={{ ...s.filtreGrup, minWidth: "100%", flexBasis: "100%" }}>
                        <label style={{ ...s.etiket, display: "flex", alignItems: "center" }}>
                            Adım Zinciri (kademeli — her adım bir öncekinin sonucunu daraltır)
                        </label>
                        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                            {cokluAdimlar.map((adim, idx) => (
                                <div key={idx} style={{ border: "1px solid #334155", borderRadius: 10,
                                    background: "#1e293b", padding: "12px 14px",
                                    borderLeft: `4px solid ${["#3b82f6","#16a34a","#eab308","#dc2626","#7c3aed","#0d9488"][idx % 6]}` }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "10px" }}>
                                        <span style={{ fontSize: "12px", fontWeight: 700, color: "#e2e8f0", minWidth: "56px" }}>Adım {idx + 1}</span>
                                        <select style={s.select} value={adim.modul_key}
                                            onChange={e => cokluAdimGuncelle(idx, e.target.value)}>
                                            {COKLU_MODUL_OPTS.map(m => <option key={m.key} value={m.key}>{m.etiket}</option>)}
                                        </select>
                                        {idx > 0 && (
                                            <span style={{ fontSize: "11px", color: "#94a3b8" }}>
                                                ← Adım {idx} sonucundaki hisselerde çalışır
                                            </span>
                                        )}
                                        <button type="button" onClick={() => cokluAdimKaldir(idx)}
                                            disabled={cokluAdimlar.length === 1}
                                            style={{ marginLeft: "auto", padding: "4px 10px", borderRadius: "6px",
                                                border: "1px solid #dc262666", background: "#dc262611",
                                                color: cokluAdimlar.length === 1 ? "#475569" : "#dc2626",
                                                cursor: cokluAdimlar.length === 1 ? "not-allowed" : "pointer", fontSize: "12px" }}>
                                            ✕ Kaldır
                                        </button>
                                    </div>
                                    <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                                        <AdimKriterFormu
                                            modulKey={adim.modul_key}
                                            filtre={adim.filtre}
                                            onChange={f => cokluFiltreGuncelle(idx, f)}
                                            piyasa={piyasa}
                                        />
                                    </div>
                                </div>
                            ))}
                            <button type="button" onClick={cokluAdimEkle}
                                disabled={cokluAdimlar.length >= 15}
                                style={{ alignSelf: "flex-start", padding: "6px 14px", borderRadius: "8px",
                                    border: "1px dashed #3b82f6", background: "#3b82f622", color: "#3b82f6",
                                    cursor: cokluAdimlar.length >= 15 ? "not-allowed" : "pointer", fontSize: "13px" }}>
                                + Adım Ekle
                            </button>
                            <div style={{ fontSize: "11px", color: "#94a3b8", marginTop: "2px" }}>
                                ℹ️ Her adımın kriterleri, ilgili modülün tam kriter setiyle ayrı ayrı özelleştirilebilir. Bir adımın bulduğu hisse sayısı 0 ise zincir orada durur (kalan adımlar çalıştırılmaz).
                            </div>
                        </div>
                    </div>
                )}

                {/* ORTAK: Simülasyon Tarihi — Türkçe custom picker (coklu için yukarıda ayrıca gösteriliyor) */}
                {kaynak !== "coklu" && (
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Simülasyon Tarihi</label>
                    <TurkceAySecici value={simTarihi} onChange={setSimTarihi} />
                </div>
                )}

                {/* ORTAK: Referans Fiyat */}
                {kaynak !== "coklu" && (
                <div style={s.filtreGrup}>
                    <label style={s.etiket}>Referans Fiyat</label>
                    <div style={{ display: "flex", gap: "6px", padding: "6px 10px",
                        border: "1px solid #475569", borderRadius: "8px", background: "#0f172a" }}>
                        {["Bugünkü Fiyat", "En Yüksek Fiyat"].map(opt => (
                            <button key={opt} onClick={() => setRefFiyat(opt)} style={{
                                padding: "6px 12px", borderRadius: "8px", cursor: "pointer",
                                fontSize: "12px", fontWeight: "500", whiteSpace: "nowrap",
                                background: refFiyat === opt ? "#7c3aed" : "#0f172a",
                                color:      "#e2e8f0",
                                border:     refFiyat === opt ? "1px solid #7c3aed" : "1px solid #475569",
                            }}>
                                {opt === "Bugünkü Fiyat" ? "📅 Bugünkü" : "🏆 En Yüksek"}
                            </button>
                        ))}
                    </div>
                </div>
                )}

                {kaynak !== "coklu" && (
                <div style={{display:"flex", flexDirection:"column", alignSelf:"flex-end", gap:"4px"}}>
                    <button
                        style={{ ...s.buton, background: calisiyor ? "#94a3b8" : "#2563eb" }}
                        onClick={simBaslat}
                        disabled={calisiyor}
                    >
                        {calisiyor ? "⏳ Taranıyor..." : "▶ Simülasyonu Başlat"}
                    </button>
                </div>
                )}
            </div>


            {/* ── Doğruluk Analizi Popup ── */}
            {dogrulukPopup && (
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",
                    display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000}}>
                    <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:14,
                        padding:"2rem",width:420,maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)"}}>
                        {dogrulukPopup==="yukleniyor"?(
                            <>
                                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                                    <span style={{fontSize:24}}>✅</span>
                                    <div>
                                        <div style={{fontSize:16,fontWeight:700,color:"#e2e8f0"}}>Doğruluk Analizi</div>
                                        <div style={{fontSize:12,color:"#94a3b8",marginTop:2}}>Veriler kaydediliyor...</div>
                                    </div>
                                </div>
                                <HareketliBar/>
                                <div style={{fontSize:13,color:"#94a3b8",textAlign:"center"}}>Kaydediliyor...</div>
                            </>
                        ):(
                            <>
                                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                                    <span style={{fontSize:28}}>✅</span>
                                    <div style={{fontSize:16,fontWeight:700,color:"#e2e8f0"}}>Kayıt Tamamlandı</div>
                                </div>
                                <div style={{background:"#16a34a22",border:"1px solid #16a34a44",
                                    borderRadius:8,padding:"14px 16px",marginBottom:20,fontSize:14,color:"#16a34a",lineHeight:1.6}}>
                                    Seçilen hisseler <strong>"Doğruluk Analizi"</strong> veri tabanına, simülasyon tarihi
                                    ({simTarihGoster}) kayıt tarihi olarak kaydedildi.
                                    {dogrulukSonuc && (dogrulukSonuc.eklenen != null || dogrulukSonuc.toplam != null || dogrulukSonuc.mesaj) && (
                                        <div style={{marginTop:8,fontSize:12,color:"#94a3b8"}}>
                                            {dogrulukSonuc.eklenen != null
                                                ? `✔ ${dogrulukSonuc.eklenen} yeni · ${dogrulukSonuc.atlanan ?? 0} mevcut`
                                                : dogrulukSonuc.mesaj || `✔ ${dogrulukSonuc.toplam} kayıt işleme alındı`}
                                        </div>
                                    )}
                                </div>
                                <div style={{display:"flex",justifyContent:"flex-end"}}>
                                    <button onClick={()=>{setDogrulukPopup(null);setDogrulukSonuc(null);}}
                                        style={{padding:"8px 28px",borderRadius:8,border:"none",
                                            background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",
                                            color:"white",cursor:"pointer",fontSize:14,fontWeight:600}}>
                                        Tamam
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* ── Eğitime Ekle Popup ── */}
            {egitimPopup && (
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",
                    display:"flex",alignItems:"center",justifyContent:"center",zIndex:2000}}>
                    <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:14,
                        padding:"2rem",width:420,maxWidth:"95vw",boxShadow:"0 12px 48px rgba(0,0,0,0.5)"}}>
                        {egitimPopup==="yukleniyor"?(
                            <>
                                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                                    <span style={{fontSize:24}}>🧠</span>
                                    <div>
                                        <div style={{fontSize:16,fontWeight:700,color:"#e2e8f0"}}>Eğitime Ekle</div>
                                        <div style={{fontSize:12,color:"#94a3b8",marginTop:2}}>Veriler eğitim veri tabanına ekleniyor</div>
                                    </div>
                                </div>
                                <HareketliBar/>
                                <div style={{fontSize:13,color:"#94a3b8",textAlign:"center"}}>Kaydediliyor...</div>
                            </>
                        ):(
                            <>
                                <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                                    <span style={{fontSize:28}}>✅</span>
                                    <div style={{fontSize:16,fontWeight:700,color:"#e2e8f0"}}>Kayıt Tamamlandı</div>
                                </div>
                                <div style={{background:"#7c3aed22",border:"1px solid #7c3aed44",
                                    borderRadius:8,padding:"14px 16px",marginBottom:20,fontSize:14,color:"#a78bfa",lineHeight:1.6}}>
                                    <strong>{egitimPopupSonuc?.kaydedilen ?? 0}</strong> kayıt eğitim veri tabanına eklendi
                                    {egitimPopupSonuc?.atlanan > 0 && (
                                        <div style={{marginTop:8,fontSize:12,color:"#94a3b8"}}>
                                            ({egitimPopupSonuc.atlanan} atlandı — zaten mevcut)
                                        </div>
                                    )}
                                </div>
                                <div style={{display:"flex",justifyContent:"flex-end"}}>
                                    <button onClick={()=>{setEgitimPopup(null);setEgitimPopupSonuc(null);}}
                                        style={{padding:"8px 28px",borderRadius:8,border:"none",
                                            background:"linear-gradient(135deg,#1d4ed8,#3b82f6)",
                                            color:"white",cursor:"pointer",fontSize:14,fontWeight:600}}>
                                        Tamam
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}

            {/* ── Alarm Popup ── */}
            {alarmPopup && (
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",
                    alignItems:"center",justifyContent:"center",zIndex:2000}}
                    onClick={() => setAlarmPopup(false)}>
                    <div style={{background:"#1e293b",border:"1px solid #334155",borderRadius:14,padding:"1.5rem",
                        width:480,maxWidth:"95vw",maxHeight:"85vh",overflowY:"auto",boxShadow:"0 12px 48px rgba(0,0,0,0.5)"}}
                        onClick={e => e.stopPropagation()}>
                        <div style={{fontSize:17,fontWeight:700,color:"#e2e8f0",marginBottom:14}}>⏰ Alarm Ekle</div>
                        <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:16,maxHeight:280,overflowY:"auto"}}>
                            {alarmHisseler.map(h => (
                                <div key={h.hisse} style={{display:"flex",alignItems:"center",gap:10,
                                    background:"#0f172a",border:"1px solid #334155",borderRadius:8,padding:"8px 12px"}}>
                                    <span style={{fontSize:13,fontWeight:700,color:"#e2e8f0",minWidth:80}}>{h.hisse}</span>
                                    <span style={{fontSize:12,color:"#94a3b8"}}>Şimdiki: {h.fiyat ?? "—"}</span>
                                    <input type="number" placeholder="Hedef fiyat" value={hedefFiyatlar[h.hisse] || ""}
                                        onChange={e => setHedefFiyatlar(prev => ({...prev, [h.hisse]: e.target.value}))}
                                        style={{marginLeft:"auto",width:110,padding:"5px 8px",borderRadius:6,
                                            border:"1px solid #334155",background:"#1e293b",color:"#e2e8f0",fontSize:13}} />
                                </div>
                            ))}
                        </div>
                        <div style={{display:"flex",gap:16,marginBottom:16}}>
                            <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:"#e2e8f0",cursor:"pointer"}}>
                                <input type="checkbox" checked={alarmBildirim} onChange={e=>setAlarmBildirim(e.target.checked)} /> Popup bildirim
                            </label>
                            <label style={{display:"flex",alignItems:"center",gap:6,fontSize:13,color:"#e2e8f0",cursor:"pointer"}}>
                                <input type="checkbox" checked={alarmMail} onChange={e=>setAlarmMail(e.target.checked)} /> E-posta bildirim
                            </label>
                        </div>
                        <div style={{display:"flex",gap:8,justifyContent:"flex-end"}}>
                            <button onClick={() => setAlarmPopup(false)}
                                style={{padding:"8px 18px",borderRadius:8,border:"1px solid #334155",background:"transparent",cursor:"pointer",fontSize:13,color:"#94a3b8"}}>İptal</button>
                            <button onClick={alarmKaydet} disabled={alarmKaydediliyor}
                                style={{padding:"8px 20px",borderRadius:8,border:"none",
                                    background:alarmKaydediliyor?"#475569":"linear-gradient(135deg,#1d4ed8,#3b82f6)",
                                    color:"white",cursor:alarmKaydediliyor?"default":"pointer",fontSize:13,fontWeight:600}}>
                                {alarmKaydediliyor ? "⏳ Kaydediliyor..." : "Alarmları Kaydet"}
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* ── Grafik Modal (tüm modüller) ── */}
            {grafikHisse && (
                <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.6)",display:"flex",
                             alignItems:"center",justifyContent:"center",zIndex:2000}}
                     onClick={() => { setGrafikHisse(null); setGrafikVeri(null); }}>
                    <div style={{background:"#1e293b",borderRadius:"16px",padding:"1.5rem",
                                 width:"min(820px, 95vw)",maxHeight:"90vh",overflowY:"auto",
                                 boxShadow:"0 20px 60px rgba(0,0,0,0.3)"}}
                         onClick={e => e.stopPropagation()}>
                        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"1.25rem"}}>
                            <div>
                                <div style={{fontSize:"20px",fontWeight:"700",color:"#93c5fd"}}>
                                    📈 {grafikHisse["Hisse"]} — Geçmiş Fiyat Grafiği
                                </div>
                                <div style={{fontSize:"13px",color:"#94a3b8",marginTop:"4px"}}>
                                    Simülasyon tarihi: <strong>{simTarihGoster}</strong> → Bugün
                                </div>
                            </div>
                            <button onClick={() => { setGrafikHisse(null); setGrafikVeri(null); }}
                                style={{background:"none",border:"none",cursor:"pointer",fontSize:"22px",color:"#94a3b8",lineHeight:1}}>✕</button>
                        </div>
                        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))",
                                     gap:"8px",marginBottom:"1.25rem"}}>
                            {[
                                ["Alış Fiyatı",     grafikHisse["Alış Fiyatı"],      "#2563eb"],
                                ["Bugünkü Fiyat",   grafikHisse["Bugünkü Fiyat"],     "#e2e8f0"],
                                ["En Yüksek",       grafikVeri?.max_fiyat != null
                                    ? String(Math.round(grafikVeri.max_fiyat*1000)/1000) : "—",  "#7c3aed"],
                                ["En Yüksek Tarih", grafikVeri?.max_tarih
                                    ? (() => { const d=new Date(grafikVeri.max_tarih+"T00:00:00");
                                        return d.toLocaleDateString("tr-TR",{day:"2-digit",month:"short",year:"numeric"}); })()
                                    : "—", "#7c3aed"],
                                ["Getiri %", grafikHisse["Getiri %"] != null
                                    ? `${grafikHisse["Getiri %"]>=0?"+":""}${grafikHisse["Getiri %"]}%` : "—",
                                    (grafikHisse["Getiri %"]||0) >= 0 ? "#16a34a" : "#dc2626"],
                            ].map(([k,v,renk]) => (
                                <div key={k} style={{background:"#182234",borderRadius:"8px",padding:"8px 12px"}}>
                                    <div style={{fontSize:"11px",color:"#94a3b8",marginBottom:"2px"}}>{k}</div>
                                    <div style={{fontSize:"14px",fontWeight:"700",color:renk}}>{v ?? "—"}</div>
                                </div>
                            ))}
                        </div>
                        {grafikYukleniyor ? (
                            <div style={{height:"280px",display:"flex",alignItems:"center",
                                         justifyContent:"center",color:"#94a3b8",fontSize:"14px"}}>
                                ⏳ Grafik yükleniyor...
                            </div>
                        ) : grafikVeri?.data?.length > 0 ? (
                            <SvgLineChart
                                data={grafikVeri.data}
                                alisFiyat={grafikVeri.alis_fiyat}
                                maxFiyat={grafikVeri.max_fiyat}
                                formatTarih={t => {
                                    if (!t) return "";
                                    const d = new Date(t+"T00:00:00");
                                    return d.toLocaleDateString("tr-TR",{day:"2-digit",month:"short",year:"numeric"});
                                }}
                            />
                        ) : (
                            <div style={{height:"200px",display:"flex",alignItems:"center",
                                         justifyContent:"center",color:"#94a3b8",fontSize:"14px"}}>
                                Grafik verisi bulunamadı
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/* İlerleme */}
            {calisiyor && (
                <>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10,
                        padding:"10px 16px",borderRadius:8,background:"#422006",border:"1px solid #92400e"}}>
                        <span style={{fontSize:16}}>⚠️</span>
                        <span style={{fontSize:13,color:"#fde68a",fontWeight:600}}>
                            Tarama tamamlanıncaya kadar sayfayı kapatmayın
                        </span>
                    </div>
                    <TaramaIlerlemePaneli
                        ilerleme={ilerleme}
                        tamamlanan={tamamlananSayisi}
                        toplam={toplamSayisi}
                        bulunan={bulunanSayisi}
                        gecen={gecenSure}
                        tahminiSure={tahminiSure}
                        adimBilgi={kaynak === "coklu" ? cokluAdimBilgi : null}
                    />
                </>
            )}

            {/* Boşta bilgi */}
            {!calisiyor && !sonuc && (
                <div style={{ background: "#1e293b", borderRadius: "12px", padding: "3rem",
                               textAlign: "center", color: "#94a3b8",
                               boxShadow: "0 1px 4px rgba(0,0,0,0.08)" }}>
                    <div style={{ fontSize: "48px", marginBottom: "1rem" }}>🔮</div>
                    <div style={{ fontSize: "16px", fontWeight: "600", color: "#e2e8f0", marginBottom: "0.5rem" }}>
                        Simülasyon Bekleniyor
                    </div>
                    <div style={{ fontSize: "13px" }}>
                        {bannerHisseler?.length > 0
                            ? `${kaynakLabel}'dan ${bannerHisseler.length} hisse aktarıldı. Simülasyonu başlatın.`
                            : "Filtreleri seçin ve simülasyonu başlatın."}
                    </div>
                </div>
            )}

            {/* Özet + Tablo */}
            {sonuc && (
                <>
                    <div style={s.bilgi}>
                        <div style={{ position: "relative" }}>
                            <button onClick={() => setIslemMenuAcik(v => !v)} style={{
                                padding: "6px 16px", borderRadius: 8, border: "1px solid #334155",
                                background: "#1e293b", cursor: "pointer", fontSize: 13, fontWeight: 500,
                                color: "#e2e8f0", display: "flex", alignItems: "center", gap: 5 }}>
                                İşlemler ▾ {secilenler.size > 0 && `(${secilenler.size})`}
                            </button>
                            {islemMenuAcik && (
                                <div style={{ position: "absolute", top: "calc(100% + 4px)", left: 0,
                                    background: "#1e293b", border: "1px solid #334155", borderRadius: 10,
                                    boxShadow: "0 8px 24px rgba(0,0,0,0.4)", zIndex: 100, minWidth: 240, overflow: "visible" }}>
                                    {[
                                        { label: dogrulukGonderiliyor ? "⏳ Gönderiliyor..." : "✅ Doğruluk Analizine Gönder",
                                          aktif: !dogrulukGonderiliyor, fn: dogrulukGonder },
                                        ...(kaynak !== "coklu" ? [{
                                            label: egitimYukleniyor ? "⏳ Ekleniyor..." : "🧠 Eğitime Ekle",
                                            aktif: !egitimYukleniyor, fn: egitimeEkleGonder,
                                        }] : []),
                                        { label: "⏰ Alarm Ekle", aktif: true, fn: alarmAc },
                                        { label: "🔎 İzleme Listesine Ekle", aktif: false, fn: () => {} },
                                    ].map(item => (
                                        <button key={item.label} onClick={item.aktif ? item.fn : undefined} disabled={!item.aktif}
                                            style={{ display: "block", width: "100%", textAlign: "left", padding: "10px 14px",
                                                border: "none", background: "none", fontSize: 13, borderBottom: "1px solid #334155",
                                                cursor: item.aktif ? "pointer" : "default", color: !item.aktif ? "#94a3b8" : "#e2e8f0" }}>
                                            {item.label}
                                        </button>
                                    ))}
                                    <IndirAltMenu onExcel={excelIndir} onCsv={csvIndir} onPdf={pdfIndir} onSvg={svgIndir} />
                                </div>
                            )}
                        </div>
                        <span>🕰️ <strong>{simTarihGoster}</strong></span>
                        <span>📋 <strong>{sonuc.periyot}</strong></span>
                        <span>🎯 <strong>{sonuc.tolerans}</strong></span>
                        <span>💱 <strong>{sonuc.para_birimi}</strong></span>
                        <span>📊 <strong>{sonuc.toplam}</strong> sinyal</span>
                        {aktifHisselerRef.current && (
                            <span style={{color:"#7c3aed"}}>🔗 <strong>{aktifHisselerRef.current.length}</strong> hisse filtresi</span>
                        )}
                    </div>

                    {/* Kartlar */}
                    <div style={s.kartSatiri}>
                        {[
                            { ikon:"📊", deger:satirlar.length, ad:"Toplam Sinyal", alt:"Taramada çıkan hisse", renk:"#2563eb" },
                            { ikon:"✅", deger:refOzet?.kaz ?? 0, ad:"Kazanan", alt:`${refFiyat === "En Yüksek Fiyat" ? "En yüksekte" : "Bugün"} artıda`, renk:"#16a34a" },
                            { ikon:"❌", deger:refOzet?.kay ?? 0, ad:"Kaybeden", alt:`${refFiyat === "En Yüksek Fiyat" ? "En yüksekte" : "Bugün"} ekside`, renk:"#dc2626" },
                            {   // Başarı Oranı
                                ikon:"🎯",
                                deger: refOzet?.n ? `%${round2(refOzet.kaz / refOzet.n * 100)}` : "—",
                                ad:"Başarı Oranı", alt:"Kazanan hisse yüzdesi",
                                renk: (() => {
                                    if (!refOzet?.n) return "#94a3b8";
                                    const oran = refOzet.kaz / refOzet.n;
                                    return oran >= 0.6 ? "#16a34a" : oran >= 0.4 ? "#d97706" : "#dc2626";
                                })()
                            },
                            ...(kaynak === "puanlama" ? [{
                                // Hedef Başarı Oranı — sadece puanlama modülünde
                                ikon:"🏹",
                                deger: (() => {
                                    const gecerli = satirlar.filter(r => r["hedef_alt"] != null);
                                    if (!gecerli.length) return "—";
                                    const fiyatKol = refFiyat === "En Yüksek Fiyat" ? "En Yüksek Fiyat" : "Bugünkü Fiyat";
                                    const hedefUlasan = gecerli.filter(r => {
                                        try {
                                            const f = parseFloat(String(r[fiyatKol] ?? "0").replace(",",""));
                                            const h = parseFloat(String(r["hedef_alt"] ?? "0").replace(",",""));
                                            return f > 0 && h > 0 && f >= h;
                                        } catch { return false; }
                                    }).length;
                                    return `%${round2(hedefUlasan / gecerli.length * 100)}`;
                                })(),
                                ad:"Hedef Başarı Oranı", alt:"Hedef fiyata ulaşan hisse %",
                                renk: (() => {
                                    const gecerli = satirlar.filter(r => r["hedef_alt"] != null);
                                    if (!gecerli.length) return "#94a3b8";
                                    const fiyatKol = refFiyat === "En Yüksek Fiyat" ? "En Yüksek Fiyat" : "Bugünkü Fiyat";
                                    const hedefUlasan = gecerli.filter(r => {
                                        try {
                                            const f = parseFloat(String(r[fiyatKol] ?? "0").replace(",",""));
                                            const h = parseFloat(String(r["hedef_alt"] ?? "0").replace(",",""));
                                            return f > 0 && h > 0 && f >= h;
                                        } catch { return false; }
                                    }).length;
                                    const oran = hedefUlasan / gecerli.length;
                                    return oran >= 0.6 ? "#16a34a" : oran >= 0.4 ? "#d97706" : "#dc2626";
                                })(),
                            }] : []),
                            ...(kaynak === "karar_motoru" ? (() => {
                                const fiyatKol = refFiyat === "En Yüksek Fiyat" ? "En Yüksek Fiyat" : "Bugünkü Fiyat";
                                const hedefBasari = (hedefKol) => {
                                    const gecerli = satirlar.filter(r => r[hedefKol] != null);
                                    if (!gecerli.length) return { deger:"—", renk:"#94a3b8" };
                                    const ulasan = gecerli.filter(r => {
                                        try {
                                            const f = parseFloat(String(r[fiyatKol] ?? "0").replace(",",""));
                                            const h = parseFloat(String(r[hedefKol]  ?? "0").replace(",",""));
                                            return f > 0 && h > 0 && f >= h;
                                        } catch { return false; }
                                    }).length;
                                    const oran = ulasan / gecerli.length;
                                    return {
                                        deger: `%${round2(oran * 100)}`,
                                        renk: oran >= 0.6 ? "#16a34a" : oran >= 0.4 ? "#d97706" : "#dc2626"
                                    };
                                };
                                const h1 = hedefBasari("hedef1");
                                const h2 = hedefBasari("hedef2");
                                return [
                                    { ikon:"🎯", deger: h1.deger, ad:"H1 Başarı Oranı", alt:"Hedef 1'e ulaşan hisse %", renk: h1.renk },
                                    { ikon:"🎯", deger: h2.deger, ad:"H2 Başarı Oranı", alt:"Hedef 2'ye ulaşan hisse %", renk: h2.renk },
                                ];
                            })() : []),
                            {   // Toplam Kazanç
                                ikon:"💰",
                                deger: `${(refOzet?.ort ?? 0) >= 0 ? "+" : ""}${refOzet?.ort ?? 0}%`,
                                ad:"Toplam Kazanç", alt:"Eşit ağırlıklı portföy getirisi",
                                renk: (refOzet?.ort ?? 0) >= 0 ? "#16a34a" : "#dc2626"
                            },
                            { ikon:"🏆", deger: refOzet?.enIyi?.Hisse || "—",
                              alt: refOzet?.enIyi?.[getiriKolRef] != null ? `+${refOzet.enIyi[getiriKolRef]}%` : "—",
                              ad:"En İyi Getiri", renk:"#7c3aed", kucuk:true },
                        ].map((k, i) => (
                            <div key={i} style={{...s.ozKart, borderTop:`4px solid ${k.renk}`}}>
                                <div style={s.kartIkon}>{k.ikon}</div>
                                <div style={{...s.kartDeger, color:k.renk, fontSize:k.kucuk?"15px":"22px"}}>
                                    {k.deger}
                                </div>
                                <div style={s.kartAd}>{k.ad}</div>
                                <div style={s.kartAlt}>{k.alt}</div>
                            </div>
                        ))}
                    </div>

                    {/* Sonuç Filtre Kartı: Tümü/Kazanan/Kaybeden + Durum */}
                    {(() => {
                        const durumSecenekleri = [...new Set(
                            (sonuc?.sonuclar || []).map(r => r["Durum"] ?? r["durum"]).filter(Boolean)
                        )];
                        return (
                            <div style={{ background: "#1e293b", border: "1px solid #334155", borderRadius: 12,
                                padding: "12px 20px", marginBottom: 12, display: "flex", gap: 20, flexWrap: "wrap", alignItems: "center" }}>

                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>GETİRİ</span>
                                    {["Kazanan","Kaybeden"].map(f => (
                                        <button key={f} onClick={() => toggleFiltreGetiri(f)} style={{
                                            padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                            fontWeight: filtre.has(f) ? 700 : 400,
                                            border: `2px solid ${filtre.has(f) ? "#3b82f6" : "#334155"}`,
                                            background: filtre.has(f) ? "#3b82f622" : "transparent",
                                            color: filtre.has(f) ? "#3b82f6" : "#94a3b8",
                                        }}>
                                            {f === "Kazanan"  ? `✅ Kazanan (${refOzet?.kaz ?? 0})` :
                                                               `❌ Kaybeden (${refOzet?.kay ?? 0})`}
                                        </button>
                                    ))}
                                </div>

                                {durumSecenekleri.length > 0 && (
                                    <>
                                        <div style={{ width: 1, height: 20, background: "#334155" }} />
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                DURUM<BilgiIkonu alan="Durum"/>
                                            </span>
                                            <button onClick={() => setDurumFiltre("Tümü")} style={{
                                                padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                fontWeight: durumFiltre === "Tümü" ? 700 : 400,
                                                border: `2px solid ${durumFiltre === "Tümü" ? "#eab308" : "#334155"}`,
                                                background: durumFiltre === "Tümü" ? "#eab30822" : "transparent",
                                                color: durumFiltre === "Tümü" ? "#eab308" : "#94a3b8",
                                            }}>Tümü</button>
                                            {durumSecenekleri.map(v => (
                                                <button key={v} onClick={() => setDurumFiltre(v)} style={{
                                                    padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                    fontWeight: durumFiltre === v ? 700 : 400,
                                                    border: `2px solid ${durumFiltre === v ? "#eab308" : "#334155"}`,
                                                    background: durumFiltre === v ? "#eab30822" : "transparent",
                                                    color: durumFiltre === v ? "#eab308" : "#94a3b8",
                                                }}>{v}</button>
                                            ))}
                                        </div>
                                    </>
                                )}

                                {kaynak === "likidite" && (() => {
                                    const sweepSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Sweep Tipi"]).filter(Boolean))];
                                    const eqhSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["EQH/EQL"]).filter(Boolean))];
                                    const kaliteSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Kalite"]).filter(Boolean))];
                                    return (<>
                                        {sweepSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>SWEEP TİPİ</span>
                                                {sweepSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleLikFiltreSweep(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: likFiltreSweep.has(v) ? 700 : 400,
                                                        border: `2px solid ${likFiltreSweep.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: likFiltreSweep.has(v) ? "#3b82f622" : "transparent",
                                                        color: likFiltreSweep.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {eqhSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    EQH/EQL<BilgiIkonu alan="EQH/EQL"/>
                                                </span>
                                                {eqhSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleLikFiltreEqh(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: likFiltreEqh.has(v) ? 700 : 400,
                                                        border: `2px solid ${likFiltreEqh.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: likFiltreEqh.has(v) ? "#16a34a22" : "transparent",
                                                        color: likFiltreEqh.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {kaliteSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    KALİTE<BilgiIkonu alan="Kalite"/>
                                                </span>
                                                {kaliteSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleLikFiltreKalite(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: likFiltreKalite.has(v) ? 700 : 400,
                                                        border: `2px solid ${likFiltreKalite.has(v) ? "#eab308" : "#334155"}`,
                                                        background: likFiltreKalite.has(v) ? "#eab30822" : "transparent",
                                                        color: likFiltreKalite.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "fvg" && (() => {
                                    const tipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Tip"]).filter(Boolean))];
                                    const fvgDurumSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["FVG Durumu"]).filter(Boolean))];
                                    const bprSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["BPR"]).filter(Boolean))];
                                    return (<>
                                        {tipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>TİP</span>
                                                {tipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleFvgFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: fvgFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${fvgFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: fvgFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: fvgFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {fvgDurumSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    FVG DURUMU<BilgiIkonu alan="FVG Durumu"/>
                                                </span>
                                                {fvgDurumSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleFvgFiltreDurum(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: fvgFiltreDurum.has(v) ? 700 : 400,
                                                        border: `2px solid ${fvgFiltreDurum.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: fvgFiltreDurum.has(v) ? "#16a34a22" : "transparent",
                                                        color: fvgFiltreDurum.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {bprSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    BPR<BilgiIkonu alan="BPR"/>
                                                </span>
                                                {bprSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleFvgFiltreBpr(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: fvgFiltreBpr.has(v) ? 700 : 400,
                                                        border: `2px solid ${fvgFiltreBpr.has(v) ? "#eab308" : "#334155"}`,
                                                        background: fvgFiltreBpr.has(v) ? "#eab30822" : "transparent",
                                                        color: fvgFiltreBpr.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "capa" && (() => {
                                    const tipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Tip"]).filter(Boolean))];
                                    const capaDurumSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Çapa Durum"]).filter(Boolean))];
                                    const temasSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Temas Sayısı"]).filter(v => v != null))].sort((a,b)=>a-b);
                                    return (<>
                                        {tipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>TİP</span>
                                                {tipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleCapaFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: capaFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${capaFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: capaFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: capaFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {capaDurumSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    ÇAPA DURUMU<BilgiIkonu alan="Çapa Durumu"/>
                                                </span>
                                                {capaDurumSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleCapaFiltreDurum(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: capaFiltreDurum.has(v) ? 700 : 400,
                                                        border: `2px solid ${capaFiltreDurum.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: capaFiltreDurum.has(v) ? "#16a34a22" : "transparent",
                                                        color: capaFiltreDurum.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {temasSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    TEMAS SAYISI<BilgiIkonu alan="Temas Sayısı"/>
                                                </span>
                                                {temasSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleCapaFiltreTemas(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: capaFiltreTemas.has(v) ? 700 : 400,
                                                        border: `2px solid ${capaFiltreTemas.has(v) ? "#eab308" : "#334155"}`,
                                                        background: capaFiltreTemas.has(v) ? "#eab30822" : "transparent",
                                                        color: capaFiltreTemas.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "msb" && (() => {
                                    const msbTipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["MSB Tipi"]).filter(Boolean))];
                                    const guclubSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Güçlü Kırılım"]).filter(Boolean))];
                                    return (<>
                                        {msbTipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>MSB TİPİ</span>
                                                {msbTipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleMsbFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: msbFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${msbFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: msbFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: msbFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {guclubSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    GÜÇLÜ KIRILIM<BilgiIkonu alan="Güçlü Kırılım"/>
                                                </span>
                                                {guclubSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleMsbFiltreGuclu(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: msbFiltreGuclu.has(v) ? 700 : 400,
                                                        border: `2px solid ${msbFiltreGuclu.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: msbFiltreGuclu.has(v) ? "#16a34a22" : "transparent",
                                                        color: msbFiltreGuclu.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "ote" && (() => {
                                    const oteTipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["OTE Tipi"]).filter(Boolean))];
                                    return (<>
                                        {oteTipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>OTE TİPİ</span>
                                                {oteTipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleOteFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: oteFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${oteFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: oteFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: oteFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "obbb" && (() => {
                                    const tipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Tip"]).filter(Boolean))];
                                    const dispSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Displacement"]).filter(Boolean))];
                                    const fvgOnaySecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["FVG Onayı"]).filter(Boolean))];
                                    const gucSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Güç"]).filter(Boolean))];
                                    return (<>
                                        {tipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>TİP</span>
                                                {tipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleObbbFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: obbbFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${obbbFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: obbbFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: obbbFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {dispSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    DISPLACEMENT<BilgiIkonu alan="Displacement"/>
                                                </span>
                                                {dispSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleObbbFiltreDisp(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: obbbFiltreDisp.has(v) ? 700 : 400,
                                                        border: `2px solid ${obbbFiltreDisp.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: obbbFiltreDisp.has(v) ? "#16a34a22" : "transparent",
                                                        color: obbbFiltreDisp.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {fvgOnaySecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    FVG ONAYI<BilgiIkonu alan="FVG Onayı"/>
                                                </span>
                                                {fvgOnaySecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleObbbFiltreFvgOnay(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: obbbFiltreFvgOnay.has(v) ? 700 : 400,
                                                        border: `2px solid ${obbbFiltreFvgOnay.has(v) ? "#0d9488" : "#334155"}`,
                                                        background: obbbFiltreFvgOnay.has(v) ? "#0d948822" : "transparent",
                                                        color: obbbFiltreFvgOnay.has(v) ? "#0d9488" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {gucSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    GÜÇ<BilgiIkonu alan="Güç"/>
                                                </span>
                                                {gucSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleObbbFiltreGuc(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: obbbFiltreGuc.has(v) ? 700 : 400,
                                                        border: `2px solid ${obbbFiltreGuc.has(v) ? "#eab308" : "#334155"}`,
                                                        background: obbbFiltreGuc.has(v) ? "#eab30822" : "transparent",
                                                        color: obbbFiltreGuc.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "idm" && (() => {
                                    const idmTipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["IDM Tipi"]).filter(Boolean))];
                                    const sweepDurumSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Sweep Durumu"]).filter(Boolean))];
                                    return (<>
                                        {idmTipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>IDM TİPİ</span>
                                                {idmTipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleIdmFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: idmFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${idmFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: idmFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: idmFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {sweepDurumSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    SWEEP DURUMU<BilgiIkonu alan="Sweep Durumu"/>
                                                </span>
                                                {sweepDurumSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleIdmFiltreSweep(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: idmFiltreSweep.has(v) ? 700 : 400,
                                                        border: `2px solid ${idmFiltreSweep.has(v) ? "#2563eb" : "#334155"}`,
                                                        background: idmFiltreSweep.has(v) ? "#2563eb22" : "transparent",
                                                        color: idmFiltreSweep.has(v) ? "#2563eb" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "pd" && (() => {
                                    const bolgeSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Bölge"]).filter(Boolean))];
                                    const yonOneriSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Yön Önerisi"]).filter(Boolean))];
                                    return (<>
                                        {bolgeSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    BÖLGE<BilgiIkonu alan="Bölge"/>
                                                </span>
                                                {bolgeSecenekleri.map(v => (
                                                    <button key={v} onClick={() => togglePdFiltreBolge(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: pdFiltreBolge.has(v) ? 700 : 400,
                                                        border: `2px solid ${pdFiltreBolge.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: pdFiltreBolge.has(v) ? "#3b82f622" : "transparent",
                                                        color: pdFiltreBolge.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {yonOneriSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    YÖN ÖNERİSİ<BilgiIkonu alan="Yön Önerisi"/>
                                                </span>
                                                {yonOneriSecenekleri.map(v => (
                                                    <button key={v} onClick={() => togglePdFiltreYon(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: pdFiltreYon.has(v) ? 700 : 400,
                                                        border: `2px solid ${pdFiltreYon.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: pdFiltreYon.has(v) ? "#16a34a22" : "transparent",
                                                        color: pdFiltreYon.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "smt" && (() => {
                                    const smtTipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["SMT Tipi"]).filter(Boolean))];
                                    const smtGucSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Güç"]).filter(Boolean))];
                                    return (<>
                                        {smtTipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>SMT TİPİ</span>
                                                {smtTipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleSmtFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: smtFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${smtFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: smtFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: smtFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {smtGucSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    GÜÇ<BilgiIkonu alan="SMT Güç"/>
                                                </span>
                                                {smtGucSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleSmtFiltreGuc(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: smtFiltreGuc.has(v) ? 700 : 400,
                                                        border: `2px solid ${smtFiltreGuc.has(v) ? "#eab308" : "#334155"}`,
                                                        background: smtFiltreGuc.has(v) ? "#eab30822" : "transparent",
                                                        color: smtFiltreGuc.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "killzone" && (() => {
                                    const hacimOnaySecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Hacim Onayı"]).filter(Boolean))];
                                    const sinifSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Sınıf"]).filter(Boolean))];
                                    return (<>
                                        {hacimOnaySecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    HACİM ONAYI<BilgiIkonu alan="Hacim Onayı"/>
                                                </span>
                                                {hacimOnaySecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleKzFiltreHacim(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: kzFiltreHacim.has(v) ? 700 : 400,
                                                        border: `2px solid ${kzFiltreHacim.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: kzFiltreHacim.has(v) ? "#16a34a22" : "transparent",
                                                        color: kzFiltreHacim.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {sinifSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    SINIF<BilgiIkonu alan="Sınıf"/>
                                                </span>
                                                {sinifSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleKzFiltreSinif(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: kzFiltreSinif.has(v) ? 700 : 400,
                                                        border: `2px solid ${kzFiltreSinif.has(v) ? "#eab308" : "#334155"}`,
                                                        background: kzFiltreSinif.has(v) ? "#eab30822" : "transparent",
                                                        color: kzFiltreSinif.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "topdown" && (() => {
                                    const trendSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Trend"]).filter(Boolean))];
                                    return (<>
                                        {trendSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>TREND</span>
                                                {trendSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleTopdownFiltreTrend(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: topdownFiltreTrend.has(v) ? 700 : 400,
                                                        border: `2px solid ${topdownFiltreTrend.has(v) ? (v === "LONG" ? "#16a34a" : "#dc2626") : "#334155"}`,
                                                        background: topdownFiltreTrend.has(v) ? (v === "LONG" ? "#16a34a22" : "#dc262622") : "transparent",
                                                        color: topdownFiltreTrend.has(v) ? (v === "LONG" ? "#16a34a" : "#dc2626") : "#94a3b8",
                                                    }}>{v === "LONG" ? "📈 LONG" : "📉 SHORT"}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "hacim_profili" && (() => {
                                    const hpSkorSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Hacim Yoğunluk Skoru"]).filter(v => v != null))].sort((a,b)=>a-b);
                                    const vaDurumSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["VA Durumu"]).filter(Boolean))];
                                    const hvnSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["HVN Yakın"]).filter(Boolean))];
                                    const lvnSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["LVN İçi"]).filter(Boolean))];
                                    return (<>
                                        {hpSkorSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    HP SKORU<BilgiIkonu alan="HP Skoru"/>
                                                </span>
                                                {hpSkorSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleHpFiltreSkor(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: hpFiltreSkor.has(v) ? 700 : 400,
                                                        border: `2px solid ${hpFiltreSkor.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: hpFiltreSkor.has(v) ? "#3b82f622" : "transparent",
                                                        color: hpFiltreSkor.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {vaDurumSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    VA DURUMU<BilgiIkonu alan="VA Durumu"/>
                                                </span>
                                                {vaDurumSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleHpFiltreVaDurum(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: hpFiltreVaDurum.has(v) ? 700 : 400,
                                                        border: `2px solid ${hpFiltreVaDurum.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: hpFiltreVaDurum.has(v) ? "#16a34a22" : "transparent",
                                                        color: hpFiltreVaDurum.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {hvnSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    HVN YAKIN<BilgiIkonu alan="HVN Yakın"/>
                                                </span>
                                                {hvnSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleHpFiltreHvn(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: hpFiltreHvn.has(v) ? 700 : 400,
                                                        border: `2px solid ${hpFiltreHvn.has(v) ? "#eab308" : "#334155"}`,
                                                        background: hpFiltreHvn.has(v) ? "#eab30822" : "transparent",
                                                        color: hpFiltreHvn.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {lvnSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    LVN İÇİ<BilgiIkonu alan="LVN İçi"/>
                                                </span>
                                                {lvnSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleHpFiltreLvn(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: hpFiltreLvn.has(v) ? 700 : 400,
                                                        border: `2px solid ${hpFiltreLvn.has(v) ? "#0d9488" : "#334155"}`,
                                                        background: hpFiltreLvn.has(v) ? "#0d948822" : "transparent",
                                                        color: hpFiltreLvn.has(v) ? "#0d9488" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "hacim_akisi" && (() => {
                                    const sinyalSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Sinyal"]).filter(Boolean))];
                                    return (<>
                                        {sinyalSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>SİNYAL</span>
                                                {sinyalSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleHaFiltreSinyal(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: haFiltreSinyal.has(v) ? 700 : 400,
                                                        border: `2px solid ${haFiltreSinyal.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: haFiltreSinyal.has(v) ? "#3b82f622" : "transparent",
                                                        color: haFiltreSinyal.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        <div style={{ width: 1, height: 20, background: "#334155" }} />
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                HA SKORU<BilgiIkonu alan="HA Skoru"/>
                                            </span>
                                            {HA_SKOR_ARALIKLARI.map(a => (
                                                <button key={a.label} onClick={() => toggleHaFiltreSkor(a.label)} style={{
                                                    padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                    fontWeight: haFiltreSkor.has(a.label) ? 700 : 400,
                                                    border: `2px solid ${haFiltreSkor.has(a.label) ? "#16a34a" : "#334155"}`,
                                                    background: haFiltreSkor.has(a.label) ? "#16a34a22" : "transparent",
                                                    color: haFiltreSkor.has(a.label) ? "#16a34a" : "#94a3b8",
                                                }}>{a.label}</button>
                                            ))}
                                        </div>
                                        <div style={{ width: 1, height: 20, background: "#334155" }} />
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                SÜREKLİLİK<BilgiIkonu alan="Süreklilik (Gün)"/>
                                            </span>
                                            {SUREKLILIK_ARALIKLARI.map(a => (
                                                <button key={a.label} onClick={() => toggleHaFiltreSurek(a.label)} style={{
                                                    padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                    fontWeight: haFiltreSurek.has(a.label) ? 700 : 400,
                                                    border: `2px solid ${haFiltreSurek.has(a.label) ? "#eab308" : "#334155"}`,
                                                    background: haFiltreSurek.has(a.label) ? "#eab30822" : "transparent",
                                                    color: haFiltreSurek.has(a.label) ? "#eab308" : "#94a3b8",
                                                }}>{a.label}</button>
                                            ))}
                                        </div>
                                    </>);
                                })()}

                                {kaynak === "divergence" && (() => {
                                    const tipSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Tip"]).filter(Boolean))];
                                    const konfSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Konfluence Skoru"]).filter(v => v != null))].sort((a,b)=>a-b);
                                    const onaySecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Onay Durumu"]).filter(Boolean))];
                                    const dvGucSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["Güç"]).filter(Boolean))];
                                    return (<>
                                        {tipSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>TİP</span>
                                                {tipSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleDvFiltreTip(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: dvFiltreTip.has(v) ? 700 : 400,
                                                        border: `2px solid ${dvFiltreTip.has(v) ? "#3b82f6" : "#334155"}`,
                                                        background: dvFiltreTip.has(v) ? "#3b82f622" : "transparent",
                                                        color: dvFiltreTip.has(v) ? "#3b82f6" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {konfSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    KONFLUENCE SKORU<BilgiIkonu alan="Konfluence Skoru"/>
                                                </span>
                                                {konfSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleDvFiltreKonf(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: dvFiltreKonf.has(v) ? 700 : 400,
                                                        border: `2px solid ${dvFiltreKonf.has(v) ? "#16a34a" : "#334155"}`,
                                                        background: dvFiltreKonf.has(v) ? "#16a34a22" : "transparent",
                                                        color: dvFiltreKonf.has(v) ? "#16a34a" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {onaySecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    ONAY DURUMU<BilgiIkonu alan="Onay Durumu"/>
                                                </span>
                                                {onaySecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleDvFiltreOnay(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: dvFiltreOnay.has(v) ? 700 : 400,
                                                        border: `2px solid ${dvFiltreOnay.has(v) ? "#eab308" : "#334155"}`,
                                                        background: dvFiltreOnay.has(v) ? "#eab30822" : "transparent",
                                                        color: dvFiltreOnay.has(v) ? "#eab308" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                        {dvGucSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                    GÜÇ<BilgiIkonu alan="Divergence Güç"/>
                                                </span>
                                                {dvGucSecenekleri.map(v => (
                                                    <button key={v} onClick={() => toggleDvFiltreGuc(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: dvFiltreGuc.has(v) ? 700 : 400,
                                                        border: `2px solid ${dvFiltreGuc.has(v) ? "#a78bfa" : "#334155"}`,
                                                        background: dvFiltreGuc.has(v) ? "#a78bfa22" : "transparent",
                                                        color: dvFiltreGuc.has(v) ? "#a78bfa" : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                {kaynak === "coklu" && (
                                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                        <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>REFERANS FİYAT</span>
                                        {["Bugünkü Fiyat", "En Yüksek Fiyat"].map(opt => (
                                            <button key={opt} onClick={() => setRefFiyat(opt)} style={{
                                                padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                fontWeight: refFiyat === opt ? 700 : 400,
                                                border: `2px solid ${refFiyat === opt ? "#7c3aed" : "#334155"}`,
                                                background: refFiyat === opt ? "#7c3aed22" : "transparent",
                                                color: refFiyat === opt ? "#7c3aed" : "#94a3b8",
                                            }}>
                                                {opt === "Bugünkü Fiyat" ? "📅 Bugünkü" : "🏆 En Yüksek"}
                                            </button>
                                        ))}
                                    </div>
                                )}

                                {kaynak === "islem_planlama" && (() => {
                                    const yonSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["yon"] ?? r["Yön"]).filter(Boolean))];
                                    return yonSecenekleri.length > 0 && (
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>YÖN</span>
                                            {yonSecenekleri.map(v => (
                                                <button key={v} onClick={() => toggleIpFiltreYon(v)} style={{
                                                    padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                    fontWeight: ipFiltreYon.has(v) ? 700 : 400,
                                                    border: `2px solid ${ipFiltreYon.has(v) ? (v?.includes("Long") ? "#16a34a" : "#dc2626") : "#334155"}`,
                                                    background: ipFiltreYon.has(v) ? (v?.includes("Long") ? "#16a34a22" : "#dc262622") : "transparent",
                                                    color: ipFiltreYon.has(v) ? (v?.includes("Long") ? "#16a34a" : "#dc2626") : "#94a3b8",
                                                }}>{v}</button>
                                            ))}
                                        </div>
                                    );
                                })()}

                                {kaynak === "puanlama" && (() => {
                                    const yonSecenekleri = [...new Set((sonuc?.sonuclar || []).map(r => r["yon"] ?? r["Yön"]).filter(Boolean))];
                                    return (<>
                                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                            <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap", display: "flex", alignItems: "center" }}>
                                                GÜVEN SKORU<BilgiIkonu alan="Güven Skoru"/>
                                            </span>
                                            {[
                                                { key:"Yüksek", label:"🟢 Yüksek 75-100", renk:"#16a34a" },
                                                { key:"Orta",   label:"🟡 Orta 50-74",     renk:"#d97706" },
                                                { key:"Düşük",  label:"🔴 Düşük 0-49",     renk:"#dc2626" },
                                            ].map(({ key, label, renk }) => (
                                                <button key={key} onClick={() => setGuvenFiltre(guvenFiltre === key ? "Tümü" : key)} style={{
                                                    padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                    fontWeight: guvenFiltre === key ? 700 : 400,
                                                    border: `2px solid ${guvenFiltre === key ? renk : "#334155"}`,
                                                    background: guvenFiltre === key ? renk + "22" : "transparent",
                                                    color: guvenFiltre === key ? renk : "#94a3b8",
                                                }}>{label}</button>
                                            ))}
                                        </div>
                                        {yonSecenekleri.length > 0 && (<>
                                            <div style={{ width: 1, height: 20, background: "#334155" }} />
                                            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                                <span style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", letterSpacing: "0.05em", whiteSpace: "nowrap" }}>YÖN</span>
                                                {yonSecenekleri.map(v => (
                                                    <button key={v} onClick={() => togglePFiltreYon(v)} style={{
                                                        padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                        fontWeight: pFiltreYon.has(v) ? 700 : 400,
                                                        border: `2px solid ${pFiltreYon.has(v) ? (v?.includes("Long") ? "#16a34a" : "#dc2626") : "#334155"}`,
                                                        background: pFiltreYon.has(v) ? (v?.includes("Long") ? "#16a34a22" : "#dc262622") : "transparent",
                                                        color: pFiltreYon.has(v) ? (v?.includes("Long") ? "#16a34a" : "#dc2626") : "#94a3b8",
                                                    }}>{v}</button>
                                                ))}
                                            </div>
                                        </>)}
                                    </>);
                                })()}

                                <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 10 }}>
                                    <span style={{ fontSize: 12, color: "#94a3b8" }}>
                                        <strong style={{ color: "#e2e8f0" }}>{satirlar.length}</strong> / {sonuc?.sonuclar?.length ?? 0} sonuç
                                    </span>
                                    {(filtre.size > 0 || durumFiltre !== "Tümü" || likFiltreSweep.size > 0 || likFiltreEqh.size > 0 || likFiltreKalite.size > 0 || fvgFiltreTip.size > 0 || fvgFiltreDurum.size > 0 || fvgFiltreBpr.size > 0 || capaFiltreTip.size > 0 || capaFiltreDurum.size > 0 || capaFiltreTemas.size > 0 || msbFiltreTip.size > 0 || msbFiltreGuclu.size > 0 || oteFiltreTip.size > 0 || obbbFiltreTip.size > 0 || obbbFiltreDisp.size > 0 || obbbFiltreFvgOnay.size > 0 || obbbFiltreGuc.size > 0 || idmFiltreTip.size > 0 || idmFiltreSweep.size > 0 || pdFiltreBolge.size > 0 || pdFiltreYon.size > 0 || smtFiltreTip.size > 0 || smtFiltreGuc.size > 0 || kzFiltreHacim.size > 0 || kzFiltreSinif.size > 0 || topdownFiltreTrend.size > 0 || hpFiltreSkor.size > 0 || hpFiltreVaDurum.size > 0 || hpFiltreHvn.size > 0 || hpFiltreLvn.size > 0 || haFiltreSinyal.size > 0 || haFiltreSkor.size > 0 || haFiltreSurek.size > 0 || dvFiltreTip.size > 0 || dvFiltreKonf.size > 0 || dvFiltreOnay.size > 0 || dvFiltreGuc.size > 0 || ipFiltreYon.size > 0 || pFiltreYon.size > 0) && (
                                        <button onClick={() => { setFiltre(new Set()); setDurumFiltre("Tümü"); setLikFiltreSweep(new Set()); setLikFiltreEqh(new Set()); setLikFiltreKalite(new Set()); setFvgFiltreTip(new Set()); setFvgFiltreDurum(new Set()); setFvgFiltreBpr(new Set()); setCapaFiltreTip(new Set()); setCapaFiltreDurum(new Set()); setCapaFiltreTemas(new Set()); setMsbFiltreTip(new Set()); setMsbFiltreGuclu(new Set()); setOteFiltreTip(new Set()); setObbbFiltreTip(new Set()); setObbbFiltreDisp(new Set()); setObbbFiltreFvgOnay(new Set()); setObbbFiltreGuc(new Set()); setIdmFiltreTip(new Set()); setIdmFiltreSweep(new Set()); setPdFiltreBolge(new Set()); setPdFiltreYon(new Set()); setSmtFiltreTip(new Set()); setSmtFiltreGuc(new Set()); setKzFiltreHacim(new Set()); setKzFiltreSinif(new Set()); setTopdownFiltreTrend(new Set()); setHpFiltreSkor(new Set()); setHpFiltreVaDurum(new Set()); setHpFiltreHvn(new Set()); setHpFiltreLvn(new Set()); setHaFiltreSinyal(new Set()); setHaFiltreSkor(new Set()); setHaFiltreSurek(new Set()); setDvFiltreTip(new Set()); setDvFiltreKonf(new Set()); setDvFiltreOnay(new Set()); setDvFiltreGuc(new Set()); setIpFiltreYon(new Set()); setPFiltreYon(new Set()); }}
                                            style={{ padding: "4px 12px", borderRadius: 20, fontSize: 12, cursor: "pointer",
                                                border: "1px solid #dc262666", background: "#dc262611", color: "#dc2626" }}>
                                            ✕ Temizle
                                        </button>
                                    )}
                                </div>
                            </div>
                        );
                    })()}


                    {/* KM Filtreleri — sadece karar_motoru modülünde */}
                    {kaynak === "karar_motoru" && sonuc?.sonuclar && (
                        <div style={{ background:"#1e293b", borderRadius:"10px", padding:"10px 16px",
                            marginBottom:"10px", boxShadow:"0 1px 4px rgba(0,0,0,0.06)",
                            display:"flex", gap:"16px", alignItems:"center", flexWrap:"wrap" }}>
                            <span style={{ fontSize:"12px", fontWeight:700, color:"#e2e8f0" }}>🔍 Filtrele:</span>

                            {/* Yön */}
                            <div style={{ display:"flex", gap:"4px", alignItems:"center" }}>
                                <span style={{ fontSize:"11px", color:"#94a3b8" }}>Yön:</span>
                                {["Tümü","long","short"].map(v => (
                                    <button key={v} onClick={() => setKmFiltreYon(v)}
                                        style={{ padding:"3px 10px", borderRadius:"20px", border:"none",
                                            cursor:"pointer", fontSize:"12px", fontWeight: kmFiltreYon===v ? 700 : 400,
                                            background: kmFiltreYon===v
                                                ? (v==="short" ? "#dc262622" : v==="long" ? "#16a34a22" : "#0f172a")
                                                : "#334155",
                                            color: kmFiltreYon===v
                                                ? (v==="short" ? "#dc2626" : v==="long" ? "#16a34a" : "white")
                                                : "#94a3b8" }}>
                                        {v==="Tümü" ? "Tümü" : v==="long" ? "📈 Long" : "📉 Short"}
                                    </button>
                                ))}
                            </div>

                            {/* Sınıf */}
                            <div style={{ display:"flex", gap:"4px", alignItems:"center" }}>
                                <span style={{ fontSize:"11px", color:"#94a3b8" }}>Sınıf:</span>
                                {["Tümü","A+","A","B","C"].map(v => (
                                    <button key={v} onClick={() => setKmFiltreSinif(v)}
                                        style={{ padding:"3px 10px", borderRadius:"20px", border:"none",
                                            cursor:"pointer", fontSize:"12px", fontWeight: kmFiltreSinif===v ? 700 : 400,
                                            background: kmFiltreSinif===v ? "#0f172a" : "#334155",
                                            color: kmFiltreSinif===v ? "white" : "#94a3b8" }}>
                                        {v}
                                    </button>
                                ))}
                            </div>

                            {/* Karar */}
                            <div style={{ display:"flex", gap:"4px", alignItems:"center" }}>
                                <span style={{ fontSize:"11px", color:"#94a3b8" }}>Karar:</span>
                                {["Tümü","AL","SAT","İZLE"].map(v => {
                                    const renk = v==="AL"   ? { bg:"#16a34a22", c:"#16a34a" }
                                               : v==="SAT"  ? { bg:"#dc262622", c:"#dc2626" }
                                               : v==="İZLE" ? { bg:"#eab30822", c:"#d97706" }
                                               : { bg:"#0f172a", c:"white" };
                                    return (
                                        <button key={v} onClick={() => setKmFiltreKarar(v)}
                                            style={{ padding:"3px 10px", borderRadius:"20px", border:"none",
                                                cursor:"pointer", fontSize:"12px", fontWeight: kmFiltreKarar===v ? 700 : 400,
                                                background: kmFiltreKarar===v ? renk.bg : "#334155",
                                                color: kmFiltreKarar===v ? renk.c : "#94a3b8" }}>
                                            {v}
                                        </button>
                                    );
                                })}
                            </div>

                            {/* Hedef */}
                            <div style={{ display:"flex", gap:"4px", alignItems:"center" }}>
                                <span style={{ fontSize:"11px", color:"#94a3b8" }}>Hedef:</span>
                                {["Tümü","H1 Geçti","H2 Geçti"].map(v => (
                                    <button key={v} onClick={() => setKmFiltreHedef(v==="H1 Geçti" ? "Hedef 1 Geçti" : v==="H2 Geçti" ? "Hedef 2 Geçti" : "Tümü")}
                                        style={{ padding:"3px 10px", borderRadius:"20px", border:"none",
                                            cursor:"pointer", fontSize:"12px",
                                            fontWeight: (kmFiltreHedef==="Hedef 1 Geçti"&&v==="H1 Geçti")||(kmFiltreHedef==="Hedef 2 Geçti"&&v==="H2 Geçti")||(kmFiltreHedef==="Tümü"&&v==="Tümü") ? 700 : 400,
                                            background: (kmFiltreHedef==="Hedef 1 Geçti"&&v==="H1 Geçti")||(kmFiltreHedef==="Hedef 2 Geçti"&&v==="H2 Geçti")||(kmFiltreHedef==="Tümü"&&v==="Tümü") ? "#7c3aed" : "#334155",
                                            color: (kmFiltreHedef==="Hedef 1 Geçti"&&v==="H1 Geçti")||(kmFiltreHedef==="Hedef 2 Geçti"&&v==="H2 Geçti")||(kmFiltreHedef==="Tümü"&&v==="Tümü") ? "white" : "#94a3b8" }}>
                                        {v}
                                    </button>
                                ))}
                            </div>

                            <span style={{ marginLeft:"auto", fontSize:"12px", color:"#94a3b8" }}>
                                {satirlar.length} / {sonuc.sonuclar?.length || 0} sonuç
                            </span>
                        </div>
                    )}

                    {/* Tablo */}
                    <div style={{ border: "1px solid #334155", borderRadius: 12, background: "#1e293b", overflow: "hidden" }}>
                    {satirlar.length > 0 ? (
                        kaynak === "likidite"
                        ? <TabloLikidite satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "fvg"
                        ? <TabloFvg satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} bprKontrol={sonuc?.bpr_kontrol} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "msb"
                        ? <TabloMsbTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "ote"
                        ? <TabloOteTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "divergence"
                        ? <TabloDivergence satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "coklu"
                        ? <TabloCoklu satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "hacim_akisi"
                        ? <TabloHacimAkisi satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "hacim_profili"
                        ? <TabloHacimProfili satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "karar_motoru"
                        ? <TabloKararMotoru satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "puanlama"
                        ? <TabloPuanlama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "islem_planlama"
                        ? <TabloIslemPlanlama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "topdown"
                        ? <TabloTopdownTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "killzone"
                        ? <TabloKillzoneTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "smt"
                        ? <TabloSmtTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "pd"
                        ? <TabloPdTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "idm"
                        ? <TabloIdmTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "obbb"
                        ? <TabloObbbTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : kaynak === "capa"
                        ? <TabloCapaTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                        : <TabloDipTarama satirlar={satirlar} siralamaKol={siralamaKol} siralamaYon={siralamaYon} siralaKol={siralaKol} s={s} refFiyat={refFiyat} grafikAc={grafikAc} secilenler={secilenler} toggleSec={toggleSec} tumSecili={tumSecili} toggleTum={toggleTum} />
                    ) : (
                        <div style={{textAlign:"center", padding:"3rem", color:"#94a3b8"}}>
                            ⚠️ Seçilen filtreye uygun sonuç yok.
                        </div>
                    )}
                    </div>
                </>
            )}

            {/* Hiç işlem yok popup */}
            {hicIslemPopup && (
                <div style={s.overlay}>
                    <div style={s.modal}>
                        <div style={{fontSize:"36px", textAlign:"center", marginBottom:"0.75rem"}}>⚠️</div>
                        <h3 style={{...s.modalBaslik, textAlign:"center"}}>Veri Bulunamadı</h3>
                        <p style={{fontSize:"14px", color:"#e2e8f0", lineHeight:"1.7",
                                   textAlign:"center", marginBottom:"1.5rem"}}>
                            Seçili hisselerin hiçbiri{" "}
                            <strong>{hicIslemPopup.simTarih
                                ? new Date(hicIslemPopup.simTarih).toLocaleDateString("tr-TR", {day:"2-digit", month:"long", year:"numeric"})
                                : simTarihi}</strong>
                            {hicIslemPopup.simTarih
                                ? ` (${new Date(hicIslemPopup.simTarih)
                                    .toLocaleDateString("tr-TR", {day:"2-digit", month:"long", year:"numeric"})})`
                                : ""}{" "}
                            işlem görmüyordu.
                            <br /><br />
                            Dip tarama kriterlerine göre <strong>tüm hisseler</strong> için
                            simülasyon yapılmasını ister misiniz?
                        </p>
                        <div style={{display:"flex", gap:"10px", justifyContent:"center"}}>
                            <button onClick={() => setHicIslemPopup(null)} style={s.btnVazgec}>
                                Hayır, İptal
                            </button>
                            <button onClick={tumHisselerIcinBaslat} style={s.btnPrimary}>
                                Evet, Tüm Hisseler İçin Başlat 🚀
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

const s = {
    sayfa:            { padding:24, background:"#0f172a", minHeight:"100vh", color:"#e2e8f0", fontFamily:"system-ui,sans-serif" },
    baslik:           { marginBottom:"0.5rem", fontSize:"20px" },
    aciklama:         { marginBottom:"1rem", fontSize:"14px", color:"#94a3b8", maxWidth:"720px" },
    banner:           { display:"flex", gap:"6px", alignItems:"center", flexWrap:"wrap",
                        background:"#16a34a1a", border:"1px solid #86efac",
                        borderRadius:"8px", padding:"8px 14px", marginBottom:"1rem",
                        fontSize:"13px", color:"#166534" },
    filtreSatiri:     { display:"flex", gap:"1rem", alignItems:"flex-end", flexWrap:"wrap",
                        background:"#1e293b", padding:"1.25rem", borderRadius:"12px",
                        marginBottom:"1rem", boxShadow:"0 1px 4px rgba(0,0,0,0.08)" },
    filtreGrup:       { display:"flex", flexDirection:"column", gap:"4px" },
    etiket:           { fontSize:"12px", color:"#94a3b8", fontWeight:"500" },
    select:           { padding:"0.5rem 0.75rem", borderRadius:"8px", border:"1px solid #475569",
                        fontSize:"14px", minWidth:"120px", cursor:"pointer",
                        background:"#0f172a", color:"#e2e8f0" },
    buton:            { padding:"0.55rem 1.25rem", color:"white", border:"none",
                        borderRadius:"8px", cursor:"pointer", fontSize:"14px" },
    bilgi:            { display:"flex", gap:16, background:"#1e293b", border:"1px solid #334155",
                        padding:"12px 20px", borderRadius:12, marginBottom:16, fontSize:13, flexWrap:"wrap",
                        alignItems:"center" },
    kartSatiri:       { display:"flex", gap:"12px", flexWrap:"wrap", marginBottom:"1.25rem" },
    ozKart:           { flex:"1", minWidth:"150px", background:"#1e293b", borderRadius:"10px",
                        padding:"1rem 1.25rem", boxShadow:"0 1px 4px rgba(0,0,0,0.08)",
                        display:"flex", flexDirection:"column", gap:"4px" },
    kartIkon:         { fontSize:"20px" },
    kartDeger:        { fontSize:"22px", fontWeight:"700", color:"#93c5fd" },
    kartAd:           { fontSize:"13px", fontWeight:"600", color:"#e2e8f0" },
    kartAlt:          { fontSize:"11px", color:"#94a3b8" },
    tablo:            { width:"100%", borderCollapse:"collapse", fontSize:"13px", background:"#1e293b",
                        boxShadow:"0 1px 4px rgba(0,0,0,0.08)", borderRadius:"8px", overflow:"hidden" },
    thead:            { background:"#0f172a" },
    th:               { padding:"0.6rem 0.8rem", color:"white", textAlign:"left",
                        whiteSpace:"nowrap", fontSize:"12px" },
    td:               { padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155" },
    ilerlemeSarici:   { background:"#1e293b", padding:"1rem 1.25rem", borderRadius:"12px",
                        marginBottom:"1rem", boxShadow:"0 1px 4px rgba(0,0,0,0.08)" },
    ilerlemeUst:      { display:"flex", justifyContent:"space-between", marginBottom:"8px",
                        fontSize:"14px", fontWeight:"500" },
    ilerlemeArkaplan: { background:"#334155", borderRadius:"99px", height:"10px", overflow:"hidden" },
    ilerlemeBar:      { height:"100%", borderRadius:"99px" },
    ilerlemeBilgi:    { marginTop:"6px", fontSize:"12px", color:"#94a3b8" },
    overlay:          { position:"fixed", inset:0, background:"rgba(0,0,0,0.55)",
                        display:"flex", alignItems:"center", justifyContent:"center", zIndex:1000 },
    modal:            { background:"#1e293b", borderRadius:"14px", padding:"2rem",
                        width:"480px", maxWidth:"95vw", boxShadow:"0 12px 48px rgba(0,0,0,0.25)" },
    modalBaslik:      { fontSize:"18px", fontWeight:"700", color:"#93c5fd", marginBottom:"0.75rem" },
    btnVazgec:        { padding:"8px 18px", borderRadius:"8px", border:"1px solid #475569",
                        background:"#1e293b", cursor:"pointer", fontSize:"13px", color:"#e2e8f0" },
    btnPrimary:       { padding:"8px 20px", borderRadius:"8px", border:"none",
                        background:"#0f172a", color:"white", cursor:"pointer",
                        fontSize:"13px", fontWeight:"600" },
};

// ─── Yardımcı ────────────────────────────────────────────────────────────────
const tipRenk     = (tip) => tip?.includes("Boğa") ? "#16a34a" : "#dc2626";
const kaliteRenk  = (k)   => {
    if (!k) return "#94a3b8";
    if (k.includes("Yüksek")) return "#16a34a";
    if (k.includes("Orta"))   return "#d97706";
    return "#94a3b8";
};

// ─── Dip Tarama Tablo Bileşeni ────────────────────────────────────────────────
function TabloDipTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const kolonlar = [
        ["Hisse",         "Hisse"],
        ["Alış Fiyatı",   "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat", enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",      enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Dip Seviyesi",  "Dip Seviyesi"],
        ["Fark %",        "Fark Yüzde"],
        ["Dip Tarihi",    "Dip Tarihi"],
        ["Durum",         "Durum"],
    ];
    return (
        <div style={{overflowX:"auto"}}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{...s.th, cursor:"pointer", userSelect:"none"}}
                                onClick={() => siralaKol(kol)}>
                                {label}{(label === "Dip Seviyesi" || label === "Durum") && <BilgiIkonu alan={label}/>}{siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        const fark   = r["Fark Yüzde"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"600", color:"#2563eb"}}>{r.Hisse}</td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal"}}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{...s.td, fontWeight:"700", color:getiriRengi(getiri)}}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{...s.td, fontSize:"12px", color:"#7c3aed"}}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["Dip Seviyesi"]}</td>
                                <td style={{...s.td, color:(fark||0)<=0?"#16a34a":"#94a3b8"}}>
                                    {fark != null ? `${fark > 0 ? "+" : ""}${fark.toFixed(2)}%` : "—"}
                                </td>
                                <td style={s.td}>{r["Dip Tarihi"]}</td>
                                <td style={s.td}>
                                    <span style={{
                                        padding:"2px 8px", borderRadius:"12px", fontSize:"12px",
                                        background: r.Durum?.includes("Dip") ? "#16a34a22" : "#eab30822",
                                        color:      r.Durum?.includes("Dip") ? "#16a34a" : "#eab308",
                                    }}>{r.Durum}</span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── Likidite Tablo Bileşeni ──────────────────────────────────────────────────
// ─── Likidite Detay Paneli (sağa dayalı) ─────────────────────────────────────
function LikiditeDetayPanel({ r, onKapat }) {
    if (!r) return null;
    const tipRenk = (tip) => {
        if (!tip) return "#94a3b8";
        if (tip.includes("Boğa")) return "#16a34a";
        if (tip.includes("Ayı")) return "#dc2626";
        return "#94a3b8";
    };
    const kaliteRenk = (k) => {
        if (!k) return "#94a3b8";
        if (k.includes("Yüksek")) return "#16a34a";
        if (k.includes("Orta")) return "#d97706";
        return "#94a3b8";
    };
    const kart = { background:"#0f172a", border:"1px solid #334155", borderTop:"3px solid #334155",
        borderRadius:8, padding:"12px 14px", fontSize:12, color:"#e2e8f0", lineHeight:1.7 };
    return (
        <>
            <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.3)", zIndex:250 }} onClick={onKapat} />
            <div style={{
                position:"fixed", top:0, right:0, bottom:0, width:460, maxWidth:"94vw",
                background:"#1e293b", borderLeft:"1px solid #334155",
                boxShadow:"-12px 0 32px rgba(0,0,0,0.5)", zIndex:300,
                overflowY:"auto", padding:"1.5rem",
            }}>
                <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start", marginBottom:16 }}>
                    <div>
                        <div style={{ fontSize:11, color:"#94a3b8", marginBottom:4 }}>Detay</div>
                        <div style={{ fontSize:18, fontWeight:800, color:"#e2e8f0" }}>{r["Hisse"]}</div>
                        <div style={{ fontSize:13, color:tipRenk(r["Sweep Tipi"]) }}>{r["Sweep Tipi"]}</div>
                    </div>
                    <button onClick={onKapat} style={{ background:"none", border:"none", color:"#94a3b8", fontSize:20, cursor:"pointer", padding:4 }}>✕</button>
                </div>

                <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                    <div style={kart}>
                        <div style={{fontWeight:"700", color:tipRenk(r["Sweep Tipi"]), marginBottom:"4px"}}>
                            {r["Sweep Tipi"]==="Boğa Sweep" ? "🟢" : "🔴"} Internal Likidite
                        </div>
                        <div>Ref. Seviye: <strong>{r["Referans Seviye"]}</strong></div>
                        <div>Fitil: <strong>%{parseFloat(r["Fitil %"]||0).toFixed(1)}</strong></div>
                        <div>EQH/EQL: <strong>{r["EQH/EQL"]}</strong></div>
                        <div style={{color:"#94a3b8"}}>{r["Referans Tarih"]}</div>
                    </div>

                    <div style={{...kart, borderTopColor:kaliteRenk(r["Kalite"])}}>
                        <div style={{fontWeight:"700", color:kaliteRenk(r["Kalite"]), marginBottom:"6px"}}>⭐ Kalite Puanlaması</div>
                        <div style={{display:"flex", alignItems:"center", gap:"8px", marginBottom:"8px"}}>
                            <span style={{fontSize:"22px", fontWeight:"800", color:kaliteRenk(r["Kalite"])}}>{r["Kalite Skoru"]??"-"}</span>
                            <span style={{padding:"2px 8px", borderRadius:"99px", fontSize:"11px", fontWeight:"600",
                                background:kaliteRenk(r["Kalite"])+"22", color:kaliteRenk(r["Kalite"])}}>{r["Kalite"]}</span>
                        </div>
                        {r["Kalite Detay"] && r["Kalite Detay"]!=="—"
                            ? r["Kalite Detay"].split(" | ").map((p,pi)=>{
                                const [label,puan]=p.split(":");
                                return (
                                    <div key={pi} style={{display:"flex", justifyContent:"space-between",
                                        padding:"2px 6px", borderRadius:"4px", marginBottom:"2px", background:"#16a34a1a"}}>
                                        <span style={{fontSize:"11px", color:"#e2e8f0"}}>• {label?.trim()}</span>
                                        <span style={{fontSize:"11px", fontWeight:"700", color:"#16a34a"}}>{puan?.trim()}</span>
                                    </div>
                                );
                            })
                            : <div style={{color:"#94a3b8", fontSize:"11px"}}>Detay yok</div>}
                        <div style={{marginTop:"6px", paddingTop:"5px", borderTop:"1px solid #334155",
                            fontSize:"10px", color:"#94a3b8", textAlign:"center"}}>
                            4-6 Yüksek | 2-3 Orta | 1 Düşük
                        </div>
                    </div>

                    <div style={{...kart, borderTopColor:"#16a34a"}}>
                        <div style={{fontWeight:"700", color:"#16a34a", marginBottom:"4px"}}>🎯 BSL (Alım Tarafı)</div>
                        {r["BSL Seviye"] ? <>
                            <div>Seviye: <strong style={{color:"#16a34a"}}>{r["BSL Seviye"]}</strong></div>
                            <div>Mesafe: <strong style={{color:"#16a34a"}}>+%{r["BSL Mesafe %"]}</strong></div>
                            <div style={{color:"#94a3b8"}}>{r["BSL Tarih"]||""}</div>
                            <div style={{marginTop:"4px", fontSize:"11px", color:"#94a3b8"}}>Sweep edilmemiş swing high</div>
                        </> : <div style={{color:"#94a3b8"}}>Tespit edilemedi</div>}
                    </div>

                    <div style={{...kart, borderTopColor:"#dc2626"}}>
                        <div style={{fontWeight:"700", color:"#dc2626", marginBottom:"4px"}}>🎯 SSL (Satış Tarafı)</div>
                        {r["SSL Seviye"] ? <>
                            <div>Seviye: <strong style={{color:"#dc2626"}}>{r["SSL Seviye"]}</strong></div>
                            <div>Mesafe: <strong style={{color:"#dc2626"}}>%{r["SSL Mesafe %"]}</strong></div>
                            <div style={{color:"#94a3b8"}}>{r["SSL Tarih"]||""}</div>
                            <div style={{marginTop:"4px", fontSize:"11px", color:"#94a3b8"}}>Sweep edilmemiş swing low</div>
                        </> : <div style={{color:"#94a3b8"}}>Tespit edilemedi</div>}
                    </div>

                    <div style={{...kart, borderTopColor:"#d97706"}}>
                        <div style={{fontWeight:"700", color:"#d97706", marginBottom:"4px"}}>🏊 Likidite Havuzu</div>
                        {r["EQH Seviye"] && <div style={{marginBottom:"6px"}}>
                            <div style={{fontWeight:"600", fontSize:"11px", color:"#dc2626"}}>EQH (Eşit Tepeler)</div>
                            <div>Seviye: <strong>{r["EQH Seviye"]}</strong></div>
                            <div>{r["EQH Adet"]} tepe — {r["EQH Tarih"]}</div>
                        </div>}
                        {r["EQL Seviye"] && <div>
                            <div style={{fontWeight:"600", fontSize:"11px", color:"#16a34a"}}>EQL (Eşit Dipler)</div>
                            <div>Seviye: <strong>{r["EQL Seviye"]}</strong></div>
                            <div>{r["EQL Adet"]} dip — {r["EQL Tarih"]}</div>
                        </div>}
                        {!r["EQH Seviye"] && !r["EQL Seviye"] && (
                            <div style={{color:"#94a3b8"}}>Havuz tespit edilemedi</div>
                        )}
                    </div>

                    <div style={{...kart, borderTopColor: (r["Getiri %"]||0) >= 0 ? "#16a34a" : "#dc2626"}}>
                        <div style={{fontWeight:"700", marginBottom:"4px",
                            color:(r["Getiri %"]||0) >= 0 ? "#16a34a" : "#dc2626"}}>
                            📈 Simülasyon Getirisi
                        </div>
                        <div>Alış: <strong>{r["Alış Fiyatı"]}</strong></div>
                        <div>Bugün: <strong>{r["Bugünkü Fiyat"] ?? "—"}</strong></div>
                        <div style={{marginTop:"6px", fontSize:"16px", fontWeight:"800",
                            color:(r["Getiri %"]||0) >= 0 ? "#16a34a" : "#dc2626"}}>
                            {r["Getiri %"] != null ? `${r["Getiri %"] >= 0 ? "+" : ""}${r["Getiri %"]}%` : "—"}
                        </div>
                        <div style={{color:"#94a3b8", fontSize:"11px"}}>{r["Sim Tarihi"]}</div>
                    </div>
                </div>
            </div>
        </>
    );
}

function TabloLikidite({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const [detayAcik, setDetayAcik] = useState(null); // null | satır objesi
    const enYuksek = refFiyat === "En Yüksek Fiyat";

    const kolonlar = [
        ["Hisse",          "Hisse"],
        ["Sweep Tipi",     "Sweep Tipi"],
        ["Alış Fiyatı",    "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat", enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",       enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Ref. Seviye",    "Referans Seviye"],
        ["Ref. Tarih",     "Referans Tarih"],
        ["Fitil %",        "Fitil %"],
        ["EQH/EQL",        "EQH/EQL"],
        ["Kalite",         "Kalite"],
        ["BSL Seviye",     "BSL Seviye"],
        ["BSL Mesafe %",   "BSL Mesafe %"],
        ["SSL Seviye",     "SSL Seviye"],
        ["SSL Mesafe %",   "SSL Mesafe %"],
        ["Detay",          "_detay"],
    ];

    return (
        <div style={{overflowX:"auto"}}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol}
                                style={{...s.th, cursor: kol !== "_detay" ? "pointer" : "default", userSelect:"none"}}
                                onClick={() => kol !== "_detay" && siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["Ref. Seviye","Fitil %","EQH/EQL","Kalite","BSL Seviye","BSL Mesafe %","SSL Seviye","SSL Mesafe %"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : (kol !== "_detay" ? " ↕" : "")}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>{r["Hisse"]}</td>
                                <td style={{...s.td, color:tipRenk(r["Sweep Tipi"]), fontWeight:"600"}}>
                                    {r["Sweep Tipi"]}
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal"}}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{...s.td, fontWeight:"700", color:getiriRengi(getiri)}}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{...s.td, fontSize:"12px", color:"#7c3aed"}}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["Referans Seviye"]}</td>
                                <td style={{...s.td, fontSize:"12px", color:"#94a3b8"}}>{r["Referans Tarih"] || "—"}</td>
                                <td style={s.td}>
                                    {r["Fitil %"] != null ? `%${parseFloat(r["Fitil %"]).toFixed(1)}` : "-"}
                                </td>
                                <td style={{...s.td, color:r["EQH/EQL"]==="✅ Evet"?"#16a34a":"#94a3b8", fontWeight:"500"}}>
                                    {r["EQH/EQL"]}
                                </td>
                                <td style={{...s.td, color:kaliteRenk(r["Kalite"]), fontWeight:"600"}}>
                                    {r["Kalite"]}
                                </td>
                                <td style={{...s.td, color:"#16a34a", fontWeight:"600"}}>{r["BSL Seviye"] || "—"}</td>
                                <td style={{...s.td, color:"#16a34a", fontSize:"12px"}}>
                                    {r["BSL Mesafe %"] != null ? `+%${r["BSL Mesafe %"]}` : "—"}
                                </td>
                                <td style={{...s.td, color:"#dc2626", fontWeight:"600"}}>{r["SSL Seviye"] || "—"}</td>
                                <td style={{...s.td, color:"#dc2626", fontSize:"12px"}}>
                                    {r["SSL Mesafe %"] != null ? `%${r["SSL Mesafe %"]}` : "—"}
                                </td>
                                <td style={{...s.td, cursor:"pointer"}}
                                    onClick={e => { e.stopPropagation(); setDetayAcik(r); }}>
                                    <span style={{color:"#2563eb", fontSize:"13px"}}>▼</span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {detayAcik && <LikiditeDetayPanel r={detayAcik} onKapat={() => setDetayAcik(null)} />}
        </div>
    );
}

// ─── Divergence Tablo Bileşeni ────────────────────────────────────────────────
function TabloDivergence({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat, grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";

    const tipRenk = (tip) => {
        if (!tip) return "#94a3b8";
        if (tip.includes("Bullish")) return "#16a34a";
        if (tip.includes("Bearish")) return "#dc2626";
        return "#94a3b8";
    };
    const gucRenk = (g) => {
        if (!g) return { bg:"#334155", c:"#94a3b8" };
        if (g.includes("Çok Güçlü")) return { bg:"#16a34a22", c:"#16a34a" };
        if (g.includes("Güçlü"))     return { bg:"#3b82f622", c:"#2563eb" };
        if (g.includes("Orta"))      return { bg:"#eab30822", c:"#a16207" };
        return { bg:"#334155", c:"#94a3b8" };
    };
    const skorRenk = (v) => v >= 75 ? "#16a34a" : v >= 50 ? "#2563eb" : v >= 25 ? "#d97706" : "#94a3b8";

    const kolonlar = [
        ["Hisse",                "Hisse"],
        ["Tip",                  "Tip"],
        ["Alış Fiyatı",          "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",             enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Konfluence Skoru",     "Konfluence Skoru"],
        ["Güç",                  "Güç"],
        ["Osilatörler",          "Osilatörler"],
        ["Onay Durumu",          "Onay Durumu"],
        ["Pivot Tipi",           "Pivot Tipi"],
        ["Pivot Mesafe",         "Pivot Mesafe (mum)"],
    ];

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor:"pointer", userSelect:"none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["Tip","Konfluence Skoru","Onay Durumu","Pivot Tipi","Pivot Mesafe"].includes(label) && <BilgiIkonu alan={label}/>}
                                    {label === "Güç" && <BilgiIkonu alan="Divergence Güç"/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"]    : r["Bugünkü Fiyat"];
                        const gr          = gucRenk(r["Güç"]);
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>{r["Hisse"]}</td>
                                <td style={{ ...s.td, fontWeight:"600", color: tipRenk(r["Tip"]), fontSize:"12px" }}>
                                    {r["Tip"] ?? "—"}
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"] ?? "—"}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight:"700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize:"12px", color:"#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, fontWeight:"700", color: skorRenk(r["Konfluence Skoru"] ?? 0) }}>
                                    {r["Konfluence Skoru"] ?? "—"}
                                </td>
                                <td style={{ ...s.td }}>
                                    <span style={{ padding:"2px 8px", borderRadius:"10px", fontSize:"12px",
                                                   background: gr.bg, color: gr.c, fontWeight:"700" }}>
                                        {r["Güç"] ?? "—"}
                                    </span>
                                </td>
                                <td style={{ ...s.td, fontSize:"11px", color:"#94a3b8" }}>{r["Osilatörler"] ?? "—"}</td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["Onay Durumu"] ?? "—"}</td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["Pivot Tipi"] ?? "—"}</td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["Pivot Mesafe (mum)"] ?? "—"} mum</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── Çoklu Tarama Tablo Bileşeni ──────────────────────────────────────────────
function TabloCoklu({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat, grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const kolonlar = [
        ["Hisse",       "Hisse"],
        ["Piyasa",      "Piyasa"],
        ["Para Birimi", "Para Birimi"],
        ["Fiyat",       "Fiyat"],
        ...(enYuksek
            ? [["En Yüksek Fiyat", "En Yüksek Fiyat"], ["Getiri %", "En Yüksek Getiri %"], ["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]]
            : [["Bugünkü Fiyat", "Bugünkü Fiyat"], ["Getiri %", "Getiri %"]]),
    ];
    return (
        <div style={{overflowX:"auto"}}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                {label}{siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        return (
                        <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                            <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                            </td>
                            <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>{r["Hisse"]}</td>
                            <td style={s.td}>{r["Piyasa"]}</td>
                            <td style={s.td}>{r["Para Birimi"]}</td>
                            <td style={{...s.td, fontWeight:"600"}}>{r["Fiyat"]}</td>
                            {enYuksek ? (<>
                                <td style={{...s.td, color:"#7c3aed", fontWeight:"600"}}>{r["En Yüksek Fiyat"] ?? "—"}</td>
                                <td style={{...s.td, fontWeight:"700", color: getiri == null ? "#94a3b8" : (getiri >= 0 ? "#16a34a" : "#dc2626")}}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                <td style={{...s.td, fontSize:"12px", color:"#94a3b8"}}>{r["En Yüksek Fiyat Tarihi"] ?? "—"}</td>
                            </>) : (<>
                                <td style={s.td}>{r["Bugünkü Fiyat"] ?? "—"}</td>
                                <td style={{...s.td, fontWeight:"700", color: getiri == null ? "#94a3b8" : (getiri >= 0 ? "#16a34a" : "#dc2626")}}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                            </>)}
                        </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}



// ─── Hacim Akışı Tablo Bileşeni ───────────────────────────────────────────────
function TabloHacimAkisi({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat, grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";

    const sinyalRenk = (sin) => {
        if (!sin) return { bg:"#334155", c:"#94a3b8" };
        if (sin.includes("Güçlü Alım")) return { bg:"#16a34a22", c:"#16a34a" };
        if (sin.includes("Orta Alım"))  return { bg:"#3b82f622", c:"#2563eb" };
        if (sin.includes("Zayıf Alım")) return { bg:"#eab30822", c:"#a16207" };
        if (sin.includes("Güçlü Satım")) return { bg:"#dc262622", c:"#991b1b" };
        if (sin.includes("Orta Satım"))  return { bg:"#dc262655", c:"#dc2626" };
        if (sin.includes("Zayıf Satım")) return { bg:"#eab30822", c:"#b45309" };
        return { bg:"#334155", c:"#94a3b8" };
    };
    const haSkorRenk = (v) => v >= 60 ? "#16a34a" : v >= 35 ? "#d97706" : "#94a3b8";
    const momentumRenk = (v) => v > 0.2 ? "#16a34a" : v < -0.2 ? "#dc2626" : "#94a3b8";

    const kolonlar = [
        ["Hisse",                "Hisse"],
        ["Alış Fiyatı",          "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",             enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Fiyat Değ. %",         "Fiyat Değişim (%)"],
        ["Hacim",                "Hacim"],
        ["Spike",                "Spike Katsayısı"],
        ["Hacim Değ. %",         "Hacim Değişim (%)"],
        ["Momentum",             "Momentum"],
        ["Süreklilik",           "Süreklilik (Gün)"],
        ["HA Skoru",             "HA Skoru"],
        ["Sinyal",               "Sinyal"],
    ];

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor:"pointer", userSelect:"none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {label === "Fiyat Değ. %" && <BilgiIkonu alan="Fiyat Değişim %"/>}
                                    {label === "Hacim" && <BilgiIkonu alan="Hacim"/>}
                                    {label === "Spike" && <BilgiIkonu alan="Spike Katsayısı"/>}
                                    {label === "Hacim Değ. %" && <BilgiIkonu alan="Hacim Değişim %"/>}
                                    {["Momentum","HA Skoru"].includes(label) && <BilgiIkonu alan={label}/>}
                                    {label === "Süreklilik" && <BilgiIkonu alan="Süreklilik (Gün)"/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"]    : r["Bugünkü Fiyat"];
                        const sr          = sinyalRenk(r["Sinyal"]);
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>{r["Hisse"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"] ?? "—"}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight:"700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize:"12px", color:"#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, fontWeight:"600", color: (r["Fiyat Değişim (%)"]||0) >= 0 ? "#16a34a" : "#dc2626" }}>
                                    {r["Fiyat Değişim (%)"] != null ? `${r["Fiyat Değişim (%)"] >= 0 ? "+" : ""}${r["Fiyat Değişim (%)"]}%` : "—"}
                                </td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["Hacim"] ?? "—"}</td>
                                <td style={{ ...s.td, fontWeight:"600", color:"#7c3aed" }}>{r["Spike Katsayısı"] ?? "—"}x</td>
                                <td style={{ ...s.td, fontSize:"12px", color: (r["Hacim Değişim (%)"]||0) >= 0 ? "#16a34a" : "#dc2626" }}>
                                    {r["Hacim Değişim (%)"] != null ? `${r["Hacim Değişim (%)"] >= 0 ? "+" : ""}${r["Hacim Değişim (%)"]}%` : "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight:"600", color: momentumRenk(r["Momentum"] ?? 0) }}>
                                    {r["Momentum"] ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["Süreklilik (Gün)"] ?? "—"} gün</td>
                                <td style={{ ...s.td, fontWeight:"700", color: haSkorRenk(r["HA Skoru"] ?? 0) }}>
                                    {r["HA Skoru"] ?? "—"}
                                </td>
                                <td style={{ ...s.td }}>
                                    <span style={{ padding:"2px 8px", borderRadius:"10px", fontSize:"12px",
                                                   background: sr.bg, color: sr.c, fontWeight:"700" }}>
                                        {r["Sinyal"] ?? "—"}
                                    </span>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}


// ─── Hacim Profili Tablo Bileşeni ─────────────────────────────────────────────
function TabloHacimProfili({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat, grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek  = refFiyat === "En Yüksek Fiyat";

    const vaDurumRenk = (d) => {
        if (!d) return "#94a3b8";
        if (d.includes("Premium"))     return "#dc2626";
        if (d.includes("Discount"))    return "#16a34a";
        if (d.includes("Equilibrium")) return "#d97706";
        return "#94a3b8";
    };
    const skorRenk = (s) => s >= 7 ? "#16a34a" : s >= 4 ? "#d97706" : "#94a3b8";
    const pocRenk  = (v) => {
        if (v == null) return "#94a3b8";
        return Math.abs(v) <= 1 ? "#16a34a" : Math.abs(v) <= 3 ? "#d97706" : "#94a3b8";
    };

    const kolonlar = [
        ["Hisse",                "Hisse"],
        ["Alış Fiyatı",          "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",             enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["POC",                  "POC"],
        ["POC Uzaklık %",        "POC Uzaklık %"],
        ["VAH",                  "VAH"],
        ["VAL",                  "VAL"],
        ["VA Durumu",            "VA Durumu"],
        ["Sinyal",               "Sinyal"],
        ["HP Skoru",             "Hacim Yoğunluk Skoru"],
        ["HVN Yakın",            "HVN Yakın"],
        ["LVN İçi",              "LVN İçi"],
    ];

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor:"pointer", userSelect:"none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["POC","VAH","VAL","POC Uzaklık %","VA Durumu","HVN Yakın","LVN İçi","HP Skoru"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"]    : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>{r["Hisse"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"] ?? "—"}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight:"700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize:"12px", color:"#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, fontWeight:"600", color:"#93c5fd" }}>{r["POC"] ?? "—"}</td>
                                <td style={{ ...s.td, fontWeight:"700", color: pocRenk(r["POC Uzaklık %"]) }}>
                                    {r["POC Uzaklık %"] != null ? `${r["POC Uzaklık %"] >= 0 ? "+" : ""}${r["POC Uzaklık %"]}%` : "—"}
                                </td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["VAH"] ?? "—"}</td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["VAL"] ?? "—"}</td>
                                <td style={{ ...s.td, fontSize:"12px", color: vaDurumRenk(r["VA Durumu"]), fontWeight:"600" }}>
                                    {r["VA Durumu"] ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontSize:"12px" }}>{r["Sinyal"] ?? "—"}</td>
                                <td style={{ ...s.td, fontWeight:"700", color: skorRenk(r["Hacim Yoğunluk Skoru"] ?? 0) }}>
                                    {r["Hacim Yoğunluk Skoru"] ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontSize:"12px", color: r["HVN Yakın"]==="🧱 Evet" ? "#d97706" : "#94a3b8" }}>
                                    {r["HVN Yakın"] ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontSize:"12px", color: r["LVN İçi"]==="⚡ Evet" ? "#7c3aed" : "#94a3b8" }}>
                                    {r["LVN İçi"] ?? "—"}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}


// ─── Karar Motoru Tablo Bileşeni ──────────────────────────────────────────────
function TabloKararMotoru({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat, grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek  = refFiyat === "En Yüksek Fiyat";
    const round2    = v => Math.round(v * 100) / 100;

    const sinifRenk = sinif => {
        if (!sinif) return { color:"#94a3b8", bg:"#334155" };
        if (sinif.startsWith("A+")) return { color:"#16a34a", bg:"#16a34a22" };
        if (sinif.startsWith("A"))  return { color:"#2563eb", bg:"#3b82f622" };
        if (sinif.startsWith("B"))  return { color:"#d97706", bg:"#eab30822" };
        return { color:"#dc2626", bg:"#dc262622" };
    };
    const kararRenk = karar => {
        if (!karar) return "#94a3b8";
        if (karar.includes("GÜÇLÜ AL")) return "#16a34a";
        if (karar.includes("AL"))       return "#16a34a";
        if (karar.includes("GÜÇLÜ SAT"))return "#dc2626";
        if (karar.includes("SAT"))      return "#dc2626";
        return "#94a3b8";
    };
    const yonRenk = yon => {
        if (!yon) return "#94a3b8";
        const y = yon.toLowerCase();
        if (y.includes("long") || y.includes("al") || y.includes("↗")) return "#16a34a";
        if (y.includes("short") || y.includes("sat") || y.includes("↘")) return "#dc2626";
        return "#94a3b8";
    };

    const fiyatLabel = enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat";
    const getiriLabel = enYuksek ? "En Yüksek Getiri %" : "Getiri %";

    // Hedefe uzaklık hesabı
    const uzaklik = (fiyat, hedef) => {
        if (!fiyat || !hedef) return null;
        try {
            const f = parseFloat(String(fiyat).replace(",",""));
            const h = parseFloat(String(hedef).replace(",",""));
            if (!h) return null;
            return round2((f - h) / h * 100);
        } catch { return null; }
    };

    const kolonlar = [
        ["Hisse",       "Hisse"],
        ["Yön",         "yon"],
        ["Skor",        "giris_skoru"],
        ["Sınıf",       "sinif"],
        ["Karar",       "karar"],
        ["Alış Fiyatı", "Alış Fiyatı"],
        [fiyatLabel,    fiyatLabel],
        ["Getiri %",    getiriLabel],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Hedef 1",     "hedef1"],
        ["H1 Uzaklık", "h1_uzaklik"],
        ["Hedef 2",     "hedef2"],
        ["H2 Uzaklık", "h2_uzaklik"],
    ];

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor:"pointer", userSelect:"none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["Skor","Karar"].includes(label) && <BilgiIkonu alan={label}/>}
                                    {label === "Sınıf" && <BilgiIkonu alan="KM Sınıf"/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"]    : r["Bugünkü Fiyat"];
                        const sr          = sinifRenk(r["sinif"]);
                        const h1uz        = uzaklik(fiyatGoster, r["hedef1"]);
                        const h2uz        = uzaklik(fiyatGoster, r["hedef2"]);
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>{r["Hisse"]}</td>
                                <td style={{ ...s.td, color: yonRenk(r["yon"]), fontWeight:"600", fontSize:"12px" }}>
                                    {(() => {
                                        const y = (r["yon"] || "").toLowerCase();
                                        if (y.includes("long"))  return "📈 Long";
                                        if (y.includes("short")) return "📉 Short";
                                        return r["yon"] || "—";
                                    })()}
                                </td>
                                <td style={{ ...s.td, fontWeight:"700", color: r["giris_skoru"] >= 70 ? "#16a34a" : r["giris_skoru"] >= 50 ? "#d97706" : "#dc2626" }}>
                                    {r["giris_skoru"] ?? "—"}
                                </td>
                                <td style={{ ...s.td }}>
                                    <span style={{ padding:"2px 8px", borderRadius:"10px", fontSize:"12px",
                                                   background: sr.bg, color: sr.color, fontWeight:"700" }}>
                                        {r["sinif"] || "—"}
                                    </span>
                                </td>
                                <td style={{ ...s.td, color: kararRenk(r["karar"]), fontWeight:"600", fontSize:"12px" }}>
                                    {r["karar"] || "—"}
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"] ?? "—"}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight:"700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize:"12px", color:"#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, color:"#e2e8f0", fontSize:"12px" }}>{r["hedef1"] ?? "—"}</td>
                                <td style={{ ...s.td, fontWeight:"700", fontSize:"12px",
                                    color: h1uz == null ? "#94a3b8" : h1uz >= 0 ? "#16a34a" : "#dc2626" }}>
                                    {h1uz != null ? `${h1uz >= 0 ? "+" : ""}${h1uz}%` : "—"}
                                </td>
                                <td style={{ ...s.td, color:"#e2e8f0", fontSize:"12px" }}>{r["hedef2"] ?? "—"}</td>
                                <td style={{ ...s.td, fontWeight:"700", fontSize:"12px",
                                    color: h2uz == null ? "#94a3b8" : h2uz >= 0 ? "#16a34a" : "#dc2626" }}>
                                    {h2uz != null ? `${h2uz >= 0 ? "+" : ""}${h2uz}%` : "—"}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}


// ─── Puanlama & Tahmin Tablo Bileşeni ────────────────────────────────────────
function TabloPuanlama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat, grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const round2   = v => Math.round(v * 100) / 100;

    const guvenRenk = puan => {
        if (puan >= 75) return { color:"#16a34a", bg:"#16a34a22", etiket:"🟢 Yüksek" };
        if (puan >= 50) return { color:"#d97706", bg:"#eab30822", etiket:"🟡 Orta" };
        return { color:"#dc2626", bg:"#dc262622", etiket:"🔴 Düşük" };
    };
    const yonRenk = yon => {
        if (!yon) return "#94a3b8";
        if (yon.includes("Boğa") || yon.includes("Long") || yon.includes("↗")) return "#16a34a";
        if (yon.includes("Ayı")  || yon.includes("Short") || yon.includes("↘")) return "#dc2626";
        return "#94a3b8";
    };

    // Hedefe uzaklık %: (referans_fiyat - hedef_alt) / hedef_alt * 100
    const hededeUzaklik = (fiyat, hedef) => {
        if (!fiyat || !hedef) return null;
        try {
            const f = parseFloat(String(fiyat).replace(",",""));
            const h = parseFloat(String(hedef).replace(",",""));
            if (!h || h === 0) return null;
            return round2((f - h) / h * 100);
        } catch { return null; }
    };

    const kolonlar = [
        ["Hisse",              "Hisse"],
        ["Güven Skoru",        "guven_skoru"],
        ["Yön",                "yon"],
        ["Alış Fiyatı",        "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",           enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Hedef Fiyat",        "hedef_alt"],
        ["Hedefe Uzaklık %",   "hedefe_uzaklik"],
        ["Stop",               "stop_loss"],
    ];

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {label === "Güven Skoru" && <BilgiIkonu alan="Güven Skoru"/>}
                                    {label === "Hedef Fiyat" && <BilgiIkonu alan="Hedef"/>}
                                    {label === "Hedefe Uzaklık %" && <BilgiIkonu alan="Fark %"/>}
                                    {label === "Stop" && <BilgiIkonu alan="Stop"/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        const gs          = r["guven_skoru"];
                        const gr          = guvenRenk(gs);
                        const uzaklik     = hededeUzaklik(fiyatGoster, r["hedef_alt"]);
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight: "bold", color:"#2563eb", textDecoration:"underline"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td }}>
                                    <span style={{ padding:"2px 8px", borderRadius:"10px", fontSize:"12px",
                                                   background: gr.bg, color: gr.color, fontWeight:"700" }}>
                                        {gs != null ? `${gs} ${gr.etiket}` : "—"}
                                    </span>
                                </td>
                                <td style={{ ...s.td, color: yonRenk(r["yon"]), fontWeight: "500", fontSize: "12px" }}>
                                    {r["yon"]}
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, color: "#e2e8f0", fontSize: "12px" }}>{r["hedef_alt"] ?? "—"}</td>
                                <td style={{ ...s.td, fontWeight: "700", fontSize: "12px",
                                    color: uzaklik == null ? "#94a3b8" : uzaklik >= 0 ? "#16a34a" : "#dc2626" }}>
                                    {uzaklik != null ? `${uzaklik >= 0 ? "+" : ""}${uzaklik}%` : "—"}
                                </td>
                                <td style={{ ...s.td, color: "#e2e8f0", fontSize: "12px" }}>{r["stop_loss"] ?? "—"}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── Native SVG Grafik Bileşeni ───────────────────────────────────────────────
function SvgLineChart({ data, alisFiyat, maxFiyat, formatTarih }) {
    const [tooltip, setTooltip] = React.useState(null);
    if (!data?.length) return null;

    const W = 760, H = 280, PAD = { top:20, right:20, bottom:40, left:60 };
    const innerW = W - PAD.left - PAD.right;
    const innerH = H - PAD.top  - PAD.bottom;

    const vals   = data.map(d => d.high);
    const minVal = Math.min(...vals) * 0.998;
    const maxVal = Math.max(...vals) * 1.002;
    const range  = maxVal - minVal || 1;

    const xScale = (i) => PAD.left + (i / (data.length - 1)) * innerW;
    const yScale = (v) => PAD.top + innerH - ((v - minVal) / range) * innerH;

    // Nokta koordinatları
    const pts = data.map((d, i) => ({ x: xScale(i), y: yScale(d.high), d }));
    const path = pts.map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(" ");

    // X ekseni tik'leri — 6 adet
    const xTicks = [0, 0.2, 0.4, 0.6, 0.8, 1].map(f => Math.round(f * (data.length - 1)));
    // Y ekseni tik'leri — 5 adet
    const yTicks = [0, 0.25, 0.5, 0.75, 1].map(f => minVal + f * range);

    const fmt = (v) => v >= 1000 ? `${(v/1000).toFixed(1)}k` : v.toFixed(v >= 10 ? 1 : 3);

    return (
        <div style={{ position:"relative", width:"100%", overflowX:"auto" }}>
            <svg viewBox={`0 0 ${W} ${H}`} style={{ width:"100%", height:"auto", display:"block" }}>
                {/* Grid */}
                {yTicks.map((v, i) => (
                    <line key={i} x1={PAD.left} x2={W-PAD.right}
                          y1={yScale(v)} y2={yScale(v)}
                          stroke="#334155" strokeWidth="1" />
                ))}

                {/* Alış fiyatı çizgisi */}
                {alisFiyat && (
                    <>
                        <line x1={PAD.left} x2={W-PAD.right}
                              y1={yScale(alisFiyat)} y2={yScale(alisFiyat)}
                              stroke="#2563eb" strokeWidth="1.5" strokeDasharray="6,3" />
                        <text x={PAD.left+4} y={yScale(alisFiyat)-4}
                              fill="#2563eb" fontSize="10">Alış: {fmt(alisFiyat)}</text>
                    </>
                )}

                {/* Max fiyat çizgisi */}
                {maxFiyat && (
                    <>
                        <line x1={PAD.left} x2={W-PAD.right}
                              y1={yScale(maxFiyat)} y2={yScale(maxFiyat)}
                              stroke="#7c3aed" strokeWidth="1.5" strokeDasharray="6,3" />
                        <text x={W-PAD.right-4} y={yScale(maxFiyat)-4}
                              fill="#7c3aed" fontSize="10" textAnchor="end">Maks: {fmt(maxFiyat)}</text>
                    </>
                )}

                {/* Fiyat çizgisi */}
                <path d={path} fill="none" stroke="white" strokeWidth="2" strokeLinejoin="round" />

                {/* X ekseni */}
                <line x1={PAD.left} x2={W-PAD.right} y1={H-PAD.bottom} y2={H-PAD.bottom}
                      stroke="#334155" strokeWidth="1" />
                {xTicks.map(idx => (
                    <text key={idx} x={xScale(idx)} y={H-PAD.bottom+14}
                          fontSize="10" fill="#94a3b8" textAnchor="middle">
                        {(() => { const d = new Date(data[idx].tarih+"T00:00:00");
                            return `${d.getDate()} ${["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"][d.getMonth()]}`; })()}
                    </text>
                ))}

                {/* Y ekseni */}
                {yTicks.map((v, i) => (
                    <text key={i} x={PAD.left-6} y={yScale(v)+4}
                          fontSize="10" fill="#94a3b8" textAnchor="end">{fmt(v)}</text>
                ))}

                {/* Hover alanı */}
                <rect x={PAD.left} y={PAD.top} width={innerW} height={innerH}
                      fill="transparent"
                      onMouseMove={e => {
                          const rect = e.currentTarget.closest("svg").getBoundingClientRect();
                          const svgX  = (e.clientX - rect.left) / rect.width * W;
                          const idx   = Math.round((svgX - PAD.left) / innerW * (data.length - 1));
                          const cIdx  = Math.max(0, Math.min(data.length-1, idx));
                          setTooltip({ idx: cIdx, x: pts[cIdx].x, y: pts[cIdx].y });
                      }}
                      onMouseLeave={() => setTooltip(null)} />

                {/* Tooltip nokta */}
                {tooltip && (
                    <>
                        <line x1={tooltip.x} x2={tooltip.x} y1={PAD.top} y2={H-PAD.bottom}
                              stroke="#475569" strokeWidth="1" strokeDasharray="3,3" />
                        <circle cx={tooltip.x} cy={tooltip.y} r="4"
                                fill="#0f172a" stroke="white" strokeWidth="2" />
                    </>
                )}
            </svg>

            {/* Tooltip kutusu */}
            {tooltip && (
                <div style={{ position:"absolute", top:8, left:8, background:"#1e293b",
                              border:"1px solid #334155", borderRadius:"6px",
                              padding:"6px 10px", fontSize:"12px", pointerEvents:"none",
                              boxShadow:"0 2px 8px rgba(0,0,0,0.1)" }}>
                    <div style={{color:"#94a3b8"}}>{formatTarih(data[tooltip.idx].tarih)}</div>
                    <div style={{fontWeight:"700",color:"#93c5fd"}}>
                        En Yüksek: {fmt(data[tooltip.idx].high)}
                    </div>
                </div>
            )}
        </div>
    );
}
function TabloIslemPlanlama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const yonRenk  = y => y?.includes("Long") ? "#16a34a" : y?.includes("Short") ? "#dc2626" : "#94a3b8";

    const kolonlar = [
        ["Hisse",             "Hisse"],
        ["Yön",               "yon"],
        ["Alış Fiyatı",       "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",          enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Yıl Seviyesi",      "yil_low"],
        ["3 Aylık Açılış",    "ceyrek_acilis"],
        ["Aylık Açılış",      "aylik_acilis"],
        ["Haftalık Açılış",   "haftalik_acilis"],
        ["Durum",             "durum"],
    ];

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {label === "Yıl Seviyesi" && <BilgiIkonu alan="Önceki Yıl Seviyesi"/>}
                                    {["3 Aylık Açılış","Aylık Açılış","Haftalık Açılış","Durum"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, color: yonRenk(r["yon"]), fontWeight: "600" }}>{r["yon"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, color: "#dc2626", fontSize: "12px" }}>{r["yil_low"]}</td>
                                <td style={{ ...s.td, color: "#d97706", fontSize: "12px" }}>{r["ceyrek_acilis"]}</td>
                                <td style={{ ...s.td, color: "#2563eb", fontSize: "12px" }}>{r["aylik_acilis"]}</td>
                                <td style={{ ...s.td, color: "#7c3aed", fontSize: "12px" }}>{r["haftalik_acilis"]}</td>
                                <td style={{ ...s.td, fontSize: "12px",
                                    color: r["durum"]?.includes("✅") ? "#16a34a" : "#d97706" }}>
                                    {r["durum"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── Topdown Cascade Tablo Bileşeni ──────────────────────────────────────────
function TabloTopdownTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const trendRenk = t => t === "LONG" ? "#16a34a" : "#dc2626";

    const kolonlar = [
        ["Hisse",         "Hisse"],
        ["Trend",         "Trend"],
        ["Alış Fiyatı",   "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",      enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["EMA200",        "EMA200"],
        ["4H Sweep",      "sweep_data"],
    ];

    return (
        <div style={{ overflowX: "auto" }}>
            <table style={{...s.tablo}}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["EMA200","4H Sweep"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td }}>
                                    <span style={{
                                        padding: "2px 8px", borderRadius: "10px", fontSize: "12px",
                                        background: trendRenk(r["Trend"]) + "18",
                                        color: trendRenk(r["Trend"]), fontWeight: "700"
                                    }}>
                                        {r["Trend"] === "LONG" ? "📈 LONG" : "📉 SHORT"}
                                    </span>
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, fontSize: "12px", color: "#94a3b8" }}>{r["EMA200"]}</td>
                                <td style={{ ...s.td, fontSize: "12px" }}>
                                    {r.sweep_data ? (
                                        <span style={{ color: r["Trend"] === "LONG" ? "#16a34a" : "#dc2626", fontWeight: "600" }}>
                                            ✅ Fitil %{r.sweep_data.fitil_pct}
                                        </span>
                                    ) : (
                                        <span style={{ color: "#94a3b8" }}>—</span>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── Killzone Tablo Bileşeni ──────────────────────────────────────────────────
function TabloKillzoneTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const KZ_RENK = {
        "BIST Açılış":      "#059669",
        "BIST Öğle":        "#0891b2",
        "BIST Kapanış":     "#be185d",
        "Londra Açılış":    "#2563eb",
        "New York Açılış":  "#dc2626",
        "Londra Kapanış":   "#d97706",
        "Asya KZ":          "#7c3aed",
    };
    const kzRenk = kz => {
        if (!kz) return "#94a3b8";
        const key = Object.keys(KZ_RENK).find(k => kz.includes(k));
        return key ? KZ_RENK[key] : "#94a3b8";
    };
    const sinifRenk = s => {
        if (!s) return "#94a3b8";
        if (s.includes("A+")) return "#16a34a";
        if (s.includes("A ")) return "#2563eb";
        return "#d97706";
    };

    const kolonlar = [
        ["Hisse",          "Hisse"],
        ["Killzone",       "Killzone"],
        ["Yapı Tipi",      "Yapı Tipi"],
        ["Alış Fiyatı",    "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",       enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Oluşum Saati",   "Oluşum Saati"],
        ["Hacim Onayı",    "Hacim Onayı"],
        ["Sınıf",          "Sınıf"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {label === "Killzone" && <BilgiIkonu alan="Killzone Seçimi"/>}
                                    {["Yapı Tipi","Hacim Onayı","Sınıf"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, fontSize: "11px" }}>
                                    <span style={{ padding:"2px 6px", borderRadius:"8px", fontSize:"11px",
                                                   background: kzRenk(r["Killzone"]) + "15",
                                                   color: kzRenk(r["Killzone"]), fontWeight:"600" }}>
                                        {r["Killzone"]?.split("(")[0].trim()}
                                    </span>
                                </td>
                                <td style={{ ...s.td, color: "#2563eb", fontWeight: "500" }}>{r["Yapı Tipi"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={{ ...s.td, fontSize: "12px", color: "#94a3b8" }}>{r["Oluşum Saati"]}</td>
                                <td style={{ ...s.td, color: r["Hacim Onayı"] === "✅" ? "#16a34a" : "#94a3b8" }}>
                                    {r["Hacim Onayı"]}
                                </td>
                                <td style={{ ...s.td, color: sinifRenk(r["Sınıf"]), fontWeight: "600" }}>
                                    {r["Sınıf"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── SMT Tablo Bileşeni ───────────────────────────────────────────────────────
function TabloSmtTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const tipRenk  = t => t?.includes("Boğa") ? "#16a34a" : "#dc2626";
    const korRenk  = k => {
        if (k == null) return "#94a3b8";
        const v = parseFloat(k);
        return v >= 0.85 ? "#16a34a" : v >= 0.70 ? "#d97706" : "#94a3b8";
    };

    const kolonlar = [
        ["Hisse",           "Hisse"],
        ["SMT Tipi",        "SMT Tipi"],
        ["Alış Fiyatı",     "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",        enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Hisse Swing",     "Hisse Swing"],
        ["Referans Swing",  "Referans Swing"],
        ["Korelasyon",      "Korelasyon"],
        ["Swing Tarihi",    "Swing Tarihi"],
        ["Güç",             "Güç"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["Hisse Swing","Referans Swing"].includes(label) && <BilgiIkonu alan={label}/>}
                                    {label === "Korelasyon" && <BilgiIkonu alan="Kolerasyon"/>}
                                    {label === "Güç" && <BilgiIkonu alan="SMT Güç"/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, color: tipRenk(r["SMT Tipi"]), fontWeight: "600" }}>{r["SMT Tipi"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["Hisse Swing"]}</td>
                                <td style={s.td}>{r["Referans Swing"]}</td>
                                <td style={{ ...s.td, color: korRenk(r["Korelasyon"]), fontWeight: "600" }}>
                                    {r["Korelasyon"]}
                                </td>
                                <td style={{ ...s.td, fontSize: "12px", color: "#94a3b8" }}>{r["Swing Tarihi"]}</td>
                                <td style={s.td}>{r["Güç"]}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── P/D Zone Tablo Bileşeni ─────────────────────────────────────────────────
function TabloPdTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const BOLGE_RENK = {
        "🟢 Discount":    { bg: "#16a34a22", color: "#16a34a" },
        "🟡 Equilibrium": { bg: "#eab30822", color: "#eab308" },
        "🔴 Premium":     { bg: "#dc262622", color: "#dc2626" },
    };

    const bolgeRenk = (bolge) => {
        if (!bolge) return { color: "#94a3b8", bg: "transparent" };
        if (BOLGE_RENK[bolge]) return BOLGE_RENK[bolge];
        if (bolge.includes("Equilibrium")) return BOLGE_RENK["🟡 Equilibrium"];
        return { color: "#94a3b8", bg: "#334155" };
    };

    const kolonlar = [
        ["Hisse",          "Hisse"],
        ["Alış Fiyatı",    "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",       enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Discount Üst",   "Discount Üst"],
        ["Premium Alt",    "Premium Alt"],
        ["Denge (EQ)",     "Denge (EQ)"],
        ["Fib %",          "Fib %"],
        ["Delta Volume %", "Delta Volume %"],
        ["Bölge",          "Bölge"],
        ["Yön Önerisi",    "Yön Önerisi"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["Discount Üst","Premium Alt","Denge (EQ)","Delta Volume %","Bölge","Yön Önerisi"].includes(label) && <BilgiIkonu alan={label}/>}
                                    {label === "Fib %" && <BilgiIkonu alan="PD Fib %"/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        const delta = parseFloat(r["Delta Volume %"]);
                        const br    = bolgeRenk(r["Bölge"]);
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["Discount Üst"]}</td>
                                <td style={s.td}>{r["Premium Alt"]}</td>
                                <td style={s.td}>{r["Denge (EQ)"]}</td>
                                <td style={s.td}>{r["Fib %"]}</td>
                                <td style={{ ...s.td,
                                    color: !isNaN(delta) ? (delta >= 0 ? "#16a34a" : "#dc2626") : "#94a3b8",
                                    fontWeight: "600" }}>
                                    {r["Delta Volume %"]}
                                </td>
                                <td style={s.td}>
                                    <span style={{ padding:"2px 8px", borderRadius:"10px", fontSize:"12px",
                                                   background: br.bg, color: br.color, fontWeight:"500" }}>
                                        {r["Bölge"]}
                                    </span>
                                </td>
                                <td style={{ ...s.td,
                                    color: r["Yön Önerisi"]?.includes("Al") ? "#16a34a"
                                         : r["Yön Önerisi"]?.includes("Sat") ? "#dc2626" : "#94a3b8",
                                    fontWeight: "500" }}>
                                    {r["Yön Önerisi"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── IDM Tablo Bileşeni ───────────────────────────────────────────────────────
function TabloIdmTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const tipRenk  = t => t?.includes("Boğa") ? "#16a34a" : "#dc2626";
    const durumRenk = d => {
        if (!d) return "#94a3b8";
        if (d.includes("Sweep")) return "#2563eb";
        if (d.includes("CHOCH")) return "#dc2626";
        if (d.includes("Bekliyor")) return "#d97706";
        return "#94a3b8";
    };

    const kolonlar = [
        ["Hisse",           "Hisse"],
        ["IDM Tipi",        "IDM Tipi"],
        ["Alış Fiyatı",     "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",        enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["IDM Seviyesi",    "IDM Seviyesi"],
        ["Pullback Sayısı", "Pullback Sayısı"],
        ["Sweep Durumu",    "Sweep Durumu"],
        ["Sonraki Hedef",   "Sonraki Hedef"],
        ["Durum",           "Durum"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["IDM Seviyesi","Pullback Sayısı","Sweep Durumu","Sonraki Hedef","Durum"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, color: tipRenk(r["IDM Tipi"]), fontWeight: "600" }}>{r["IDM Tipi"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["IDM Seviyesi"]}</td>
                                <td style={{ ...s.td, textAlign: "center" }}>{r["Pullback Sayısı"]}</td>
                                <td style={{ ...s.td, color: durumRenk(r["Sweep Durumu"]), fontWeight: "500" }}>
                                    {r["Sweep Durumu"]}
                                </td>
                                <td style={s.td}>{r["Sonraki Hedef"]}</td>
                                <td style={{ ...s.td, color: durumRenk(r["Durum"]), fontWeight: "500" }}>
                                    {r["Durum"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── OB/BB Tablo Bileşeni ─────────────────────────────────────────────────────
function TabloObbbTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const RENK_ETIKET = {
        "Boğa OB": { bg:"#16a34a22", color:"#16a34a" },
        "Ayı OB":  { bg:"#dc262622", color:"#dc2626" },
        "Boğa BB": { bg:"#16a34a22", color:"#059669" },
        "Ayı BB":  { bg:"#dc262655", color:"#f87171" },
    };
    const tazeRenk = t => t === "🟢 Taze" ? "#16a34a" : t === "🔴 Kullanılmış" ? "#dc2626" : "#d97706";
    const gucRenk  = g => g === "⭐⭐⭐ Yüksek" ? "#16a34a" : g === "⭐⭐ Orta" ? "#d97706" : "#94a3b8";

    const kolonlar = [
        ["Hisse",        "Hisse"],
        ["Tip",          "Tip"],
        ["Alış Fiyatı",  "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",     enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["OB Alt",       "OB Alt"],
        ["OB Üst",       "OB Üst"],
        ["Displacement", "Displacement"],
        ["FVG Onayı",    "FVG Onayı"],
        ["Tazelik",      "Tazelik"],
        ["Güç",          "Güç"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["OB Alt","OB Üst","Displacement","FVG Onayı","Tazelik","Güç"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        const etiket      = RENK_ETIKET[r["Tip"]] || { bg:"#334155", color:"#e2e8f0" };
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={s.td}>
                                    <span style={{ padding:"2px 8px", borderRadius:"10px", fontSize:"12px",
                                                   background: etiket.bg || "#334155",
                                                   color: etiket.color || "#e2e8f0", fontWeight:"600" }}>
                                        {r["Tip"]}
                                    </span>
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit",
                                             fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["OB Alt"]}</td>
                                <td style={s.td}>{r["OB Üst"]}</td>
                                <td style={{ ...s.td, color: r["Displacement"] === "✅" ? "#16a34a" : "#94a3b8" }}>
                                    {r["Displacement"]}
                                </td>
                                <td style={{ ...s.td, color: r["FVG Onayı"] === "✅" ? "#16a34a" : "#94a3b8" }}>
                                    {r["FVG Onayı"]}
                                </td>
                                <td style={{ ...s.td, color: tazeRenk(r["Tazelik"]), fontWeight: "500" }}>
                                    {r["Tazelik"]}
                                </td>
                                <td style={{ ...s.td, color: gucRenk(r["Güç"]), fontWeight: "600" }}>
                                    {r["Güç"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── OTE Tablo Bileşeni ───────────────────────────────────────────────────────
function TabloOteTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const tipRenk  = t => t?.includes("Boğa") ? "#16a34a" : "#dc2626";
    const rrRenk   = rr => { if (!rr) return "#94a3b8"; const v = parseFloat(rr); return v >= 3 ? "#16a34a" : v >= 2 ? "#d97706" : "#dc2626"; };

    const kolonlar = [
        ["Hisse",          "Hisse"],
        ["OTE Tipi",       "OTE Tipi"],
        ["Alış Fiyatı",    "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",       enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["OTE Alt",        "OTE Alt (0.618)"],
        ["OTE Orta",       "OTE Orta (0.705)"],
        ["OTE Üst",        "OTE Üst (0.79)"],
        ["Fib %",          "Fib Seviyesi %"],
        ["R/R",            "R/R Oranı"],
        ["Durum",          "Durum"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["OTE Alt","OTE Orta","OTE Üst","Fib %","R/R","Durum"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, color: tipRenk(r["OTE Tipi"]), fontWeight: "600" }}>{r["OTE Tipi"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["OTE Alt (0.618)"]}</td>
                                <td style={s.td}>{r["OTE Orta (0.705)"]}</td>
                                <td style={s.td}>{r["OTE Üst (0.79)"]}</td>
                                <td style={s.td}>{r["Fib Seviyesi %"]}</td>
                                <td style={{ ...s.td, color: rrRenk(r["R/R Oranı"]), fontWeight: "600" }}>
                                    {r["R/R Oranı"]}
                                </td>
                                <td style={{ ...s.td, fontSize: "12px",
                                    color: r["Durum"]?.includes("Yüksek") ? "#16a34a"
                                         : r["Durum"]?.includes("OTE") ? "#2563eb" : "#94a3b8",
                                    fontWeight: "500" }}>
                                    {r["Durum"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── MSB Tablo Bileşeni ───────────────────────────────────────────────────────
function TabloMsbTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const tipRenk = t => t === "Boğa MSB" ? "#16a34a" : "#dc2626";

    const kolonlar = [
        ["Hisse",           "Hisse"],
        ["MSB Tipi",        "MSB Tipi"],
        ["Alış Fiyatı",     "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat",
         enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",        enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Kırılan Seviye",  "Kırılan Seviye"],
        ["Seviye Tarihi",   "Seviye Tarihi"],
        ["Güçlü Kırılım",   "Güçlü Kırılım"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["Kırılan Seviye","Güçlü Kırılım"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, color: tipRenk(r["MSB Tipi"]), fontWeight: "600" }}>
                                    {r["MSB Tipi"]}
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit",
                                             fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["Kırılan Seviye"]}</td>
                                <td style={{ ...s.td, fontSize: "12px", color: "#94a3b8" }}>
                                    {r["Seviye Tarihi"] ? new Date(r["Seviye Tarihi"]).toLocaleDateString("tr-TR") : "—"}
                                </td>
                                <td style={{ ...s.td,
                                    color: r["Güçlü Kırılım"]?.includes("Evet") ? "#16a34a" : "#94a3b8",
                                    fontWeight: "500" }}>
                                    {r["Güçlü Kırılım"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── Çapa Noktası Tablo Bileşeni ─────────────────────────────────────────────
function TabloCapaTarama({ satirlar, siralamaKol, siralamaYon, siralaKol, s, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const tipRenk = t => t === "Boğa FVG" ? "#16a34a" : "#dc2626";

    const kolonlar = [
        ["Hisse",        "Hisse"],
        ["Tip",          "Tip"],
        ["Alış Fiyatı",  "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat", enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",     enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Alt Sınır",    "Alt Sınır"],
        ["Üst Sınır",    "Üst Sınır"],
        ["Temas Sayısı", "Temas Sayısı"],
        ["Çapa Durum",   "Çapa Durum"],
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {["Alt Sınır","Üst Sınır","Temas Sayısı"].includes(label) && <BilgiIkonu alan={label}/>}
                                    {label === "Çapa Durum" && <BilgiIkonu alan="Çapa Durumu"/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, color: tipRenk(r["Tip"]), fontWeight: "600" }}>{r["Tip"]}</td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["Alt Sınır"]}</td>
                                <td style={s.td}>{r["Üst Sınır"]}</td>
                                <td style={{ ...s.td, textAlign: "center" }}>{r["Temas Sayısı"]}</td>
                                <td style={{ ...s.td,
                                    color: r["Çapa Durum"]?.includes("aşıldı") ? "#16a34a" : "#d97706",
                                    fontWeight: "600" }}>
                                    {r["Çapa Durum"]}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}

// ─── FVG Tablo Bileşeni ───────────────────────────────────────────────────────
function TabloFvg({ satirlar, siralamaKol, siralamaYon, siralaKol, s, bprKontrol, refFiyat , grafikAc, secilenler, toggleSec, tumSecili, toggleTum }) {
    const enYuksek = refFiyat === "En Yüksek Fiyat";
    const fvgTipRenk = (tip) => {
        if (tip === "Boğa FVG") return "#16a34a";
        if (tip === "Ayı FVG")  return "#dc2626";
        return "#d97706";
    };

    const kolonlar = [
        ["Hisse",        "Hisse"],
        ["Tip",          "Tip"],
        ["Alış Fiyatı",  "Alış Fiyatı"],
        [enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat", enYuksek ? "En Yüksek Fiyat" : "Bugünkü Fiyat"],
        ["Getiri %",     enYuksek ? "En Yüksek Getiri %" : "Getiri %"],
        ...(enYuksek ? [["En Yüksek Tarih", "En Yüksek Fiyat Tarihi"]] : []),
        ["Alt Sınır",    "Alt Sınır"],
        ["Üst Sınır",    "Üst Sınır"],
        ["Mesafe %",     "Mesafe %"],
        ["FVG Durumu",   "FVG Durumu"],
        ...(bprKontrol ? [["BPR", "BPR"]] : []),
    ];


    return (
        <div style={{ overflowX: "auto" }}>
            <table style={s.tablo}>
                <thead style={s.thead}>
                    <tr>
                        <th style={{ ...s.th, width: 36, textAlign: "center" }}>
                            <input type="checkbox" checked={tumSecili} onChange={toggleTum} />
                        </th>
                        {kolonlar.map(([label, kol]) => (
                            <th key={kol} style={{ ...s.th, cursor: "pointer", userSelect: "none" }}
                                onClick={() => siralaKol(kol)}>
                                <span style={{display:"inline-flex", alignItems:"center"}}>
                                    {label}
                                    {label === "Mesafe %" && <BilgiIkonu alan="Mesafe"/>}
                                    {["Alt Sınır","Üst Sınır","FVG Durumu","BPR"].includes(label) && <BilgiIkonu alan={label}/>}
                                </span>
                                {siralamaKol === kol ? (siralamaYon === "asc" ? " ↑" : " ↓") : " ↕"}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {satirlar.map((r, i) => {
                        const getiri      = enYuksek ? r["En Yüksek Getiri %"] : r["Getiri %"];
                        const fiyatGoster = enYuksek ? r["En Yüksek Fiyat"] : r["Bugünkü Fiyat"];
                        return (
                            <tr key={i} onClick={() => grafikAc(r)} style={{ cursor:"pointer", background: secilenler.has(r.Hisse ?? r["Hisse"]) ? "#3b82f622" : (i % 2 === 0 ? "#1e293b" : "#182234") }}>
                                <td style={{ padding:"0.5rem 0.8rem", borderBottom:"1px solid #334155", textAlign:"center" }} onClick={e => e.stopPropagation()}>
                                    <input type="checkbox" checked={secilenler.has(r.Hisse ?? r["Hisse"])} onChange={() => toggleSec(r.Hisse ?? r["Hisse"])} />
                                </td>
                                <td style={{...s.td, fontWeight:"bold", color:"#2563eb"}}>
                                    {r["Hisse"]}
                                </td>
                                <td style={{ ...s.td, color: fvgTipRenk(r["Tip"]), fontWeight: "600" }}>
                                    {r["Tip"]}
                                </td>
                                <td style={s.td}>{r["Alış Fiyatı"]}</td>
                                <td style={{ ...s.td, color: enYuksek ? "#7c3aed" : "inherit", fontWeight: enYuksek ? "600" : "normal" }}>
                                    {fiyatGoster ?? "—"}
                                </td>
                                <td style={{ ...s.td, fontWeight: "700", color: getiriRengi(getiri) }}>
                                    {getiri != null ? `${getiri >= 0 ? "+" : ""}${getiri}%` : "—"}
                                </td>
                                {enYuksek && (
                                    <td style={{ ...s.td, fontSize: "12px", color: "#7c3aed" }}>
                                        {r["En Yüksek Fiyat Tarihi"] ?? "—"}
                                    </td>
                                )}
                                <td style={s.td}>{r["Alt Sınır"]}</td>
                                <td style={s.td}>{r["Üst Sınır"]}</td>
                                <td style={{ ...s.td, color: (r["Mesafe %"] || 0) <= 0 ? "#16a34a" : "#94a3b8" }}>
                                    {r["Mesafe %"] != null ? `${parseFloat(r["Mesafe %"]).toFixed(2)}%` : "—"}
                                </td>
                                <td style={s.td}>{r["FVG Durumu"]}</td>
                                {bprKontrol && (
                                    <td style={{ ...s.td,
                                        color: r["BPR"] === "Boğa BPR" ? "#16a34a"
                                             : r["BPR"] === "Ayı BPR"  ? "#dc2626" : "#94a3b8",
                                        fontWeight: r["BPR"] !== "❌" ? "600" : "normal",
                                    }}>
                                        {r["BPR"]}
                                    </td>
                                )}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}


// ─── Türkçe Ay Seçici ─────────────────────────────────────────────────────────
const TR_AYLAR = ["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran",
                  "Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"];

function TurkceAySecici({ value, onChange }) {
    const bugun = new Date(); bugun.setHours(0,0,0,0);
    const ref = React.useRef(null);

    // Takvim her açılışta BUGÜNÜ gösterir
    const [acik,       setAcik]       = useState(false);
    const [gorunenYil, setGorunenYil] = useState(bugun.getFullYear());
    const [gorunenAy,  setGorunenAy]  = useState(bugun.getMonth());
    const [yilMod,     setYilMod]     = useState(false);
    const [ayMod,      setAyMod]      = useState(false);

    // Takvim açılınca bugüne sıfırla
    const takvimAc = () => {
        setGorunenYil(bugun.getFullYear());
        setGorunenAy(bugun.getMonth());
        setYilMod(false);
        setAyMod(false);
        setAcik(v => !v);
    };

    // Dışa tıklayınca kapat
    React.useEffect(() => {
        const h = e => {
            if (ref.current && !ref.current.contains(e.target)) {
                setAcik(false); setYilMod(false); setAyMod(false);
            }
        };
        document.addEventListener("mousedown", h);
        return () => document.removeEventListener("mousedown", h);
    }, []);

    const kapat = () => { setAcik(false); setYilMod(false); setAyMod(false); };

    const seciliTarih = value ? (() => {
        const d = new Date(value + "T00:00:00"); d.setHours(0,0,0,0); return d;
    })() : null;

    // Takvim günleri
    const baslangicGun = (new Date(gorunenYil, gorunenAy, 1).getDay() + 6) % 7;
    const gunSayisi    = new Date(gorunenYil, gorunenAy + 1, 0).getDate();
    const gunler = [];
    for (let i = 0; i < baslangicGun; i++) gunler.push(null);
    for (let d = 1; d <= gunSayisi; d++) gunler.push(d);

    const gunSec = gun => {
        if (!gun) return;
        const t = new Date(gorunenYil, gorunenAy, gun); t.setHours(0,0,0,0);
        if (t >= bugun) return;
        onChange(`${gorunenYil}-${String(gorunenAy+1).padStart(2,"0")}-${String(gun).padStart(2,"0")}`);
        kapat();
    };

    const oncekiAy = () => {
        if (gorunenAy === 0) { setGorunenYil(y => y-1); setGorunenAy(11); }
        else setGorunenAy(m => m-1);
    };
    const sonrakiAy = () => {
        const ny = gorunenAy === 11 ? 0 : gorunenAy+1;
        const fy = gorunenAy === 11 ? gorunenYil+1 : gorunenYil;
        if (new Date(fy, ny, 1) >= bugun) return;
        setGorunenAy(ny); setGorunenYil(fy);
    };

    const gosterim = value ? (() => {
        const d = new Date(value + "T00:00:00");
        return `${String(d.getDate()).padStart(2,"0")} ${TR_AYLAR[d.getMonth()]} ${d.getFullYear()}`;
    })() : "Tarih seçin";

    // Yıl listesi 1990'dan bugüne
    const yillar = [];
    for (let y = bugun.getFullYear(); y >= 1990; y--) yillar.push(y);

    const sonrakiAyDevre = new Date(
        gorunenAy === 11 ? gorunenYil+1 : gorunenYil,
        gorunenAy === 11 ? 0 : gorunenAy+1, 1
    ) >= bugun;

    return (
        <div ref={ref} style={{position:"relative"}}>
            {/* Trigger */}
            <button type="button" onClick={takvimAc} style={{
                padding:"0.5rem 0.75rem", borderRadius:"8px",
                border:"1px solid #475569", background:"#1e293b",
                fontSize:"13px", cursor:"pointer", minWidth:"180px",
                textAlign:"left", display:"flex", justifyContent:"space-between",
                alignItems:"center", gap:"8px", color:"#e2e8f0",
            }}>
                <span>📅 {gosterim}</span>
                <span style={{fontSize:"10px", color:"#94a3b8"}}>{acik ? "▲" : "▼"}</span>
            </button>

            {acik && (
                <div style={{
                    position:"absolute", top:"calc(100% + 4px)", left:0, zIndex:500,
                    background:"#1e293b", borderRadius:"12px",
                    boxShadow:"0 8px 32px rgba(0,0,0,0.18)",
                    border:"1px solid #334155", padding:"14px", minWidth:"272px",
                }}>

                    {/* Navigasyon başlığı */}
                    <div style={{display:"flex", justifyContent:"space-between",
                                 alignItems:"center", marginBottom:"10px", gap:"4px"}}>
                        <button type="button" onClick={oncekiAy} style={navBtn}>‹</button>

                        {/* Ay seçici */}
                        <div style={{position:"relative"}}>
                            <button type="button"
                                onClick={() => { setAyMod(v => !v); setYilMod(false); }}
                                style={{fontWeight:"600", fontSize:"14px", color:"#93c5fd",
                                        background: ayMod ? "#3b82f622" : "none",
                                        border: ayMod ? "1px solid #3b82f655" : "1px solid transparent",
                                        cursor:"pointer", padding:"3px 8px", borderRadius:"6px"}}>
                                {TR_AYLAR[gorunenAy]} ▾
                            </button>
                            {ayMod && (
                                <div style={{
                                    position:"absolute", top:"calc(100% + 4px)", left:"50%",
                                    transform:"translateX(-50%)", zIndex:600,
                                    background:"#1e293b", borderRadius:"10px",
                                    boxShadow:"0 4px 20px rgba(0,0,0,0.15)",
                                    border:"1px solid #334155", padding:"8px",
                                    display:"grid", gridTemplateColumns:"1fr 1fr 1fr", gap:"4px",
                                    minWidth:"190px",
                                }}>
                                    {TR_AYLAR.map((ay, i) => {
                                        const devreDisiBu = new Date(gorunenYil, i, 1) >= bugun;
                                        return (
                                            <button key={ay} type="button"
                                                disabled={devreDisiBu}
                                                onClick={() => { setGorunenAy(i); setAyMod(false); }}
                                                style={{
                                                    padding:"6px 4px", borderRadius:"6px", border:"none",
                                                    fontSize:"12px",
                                                    cursor: devreDisiBu ? "default" : "pointer",
                                                    background: i === gorunenAy ? "#0f172a" : "transparent",
                                                    color: i === gorunenAy ? "white" : devreDisiBu ? "#475569" : "#e2e8f0",
                                                    fontWeight: i === gorunenAy ? "600" : "400",
                                                }}>
                                                {ay.slice(0,3)}
                                            </button>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* Yıl seçici */}
                        <div style={{position:"relative"}}>
                            <button type="button"
                                onClick={() => { setYilMod(v => !v); setAyMod(false); }}
                                style={{fontWeight:"600", fontSize:"14px", color:"#93c5fd",
                                        background: yilMod ? "#3b82f622" : "none",
                                        border: yilMod ? "1px solid #3b82f655" : "1px solid transparent",
                                        cursor:"pointer", padding:"3px 8px", borderRadius:"6px"}}>
                                {gorunenYil} ▾
                            </button>
                            {yilMod && (
                                <div style={{
                                    position:"absolute", top:"calc(100% + 4px)", left:"50%",
                                    transform:"translateX(-50%)", zIndex:600,
                                    background:"#1e293b", borderRadius:"10px",
                                    boxShadow:"0 4px 20px rgba(0,0,0,0.15)",
                                    border:"1px solid #334155",
                                    maxHeight:"180px", overflowY:"auto",
                                    minWidth:"80px",
                                }}>
                                    {yillar.map(y => (
                                        <button key={y} type="button"
                                            onClick={() => { setGorunenYil(y); setYilMod(false); }}
                                            style={{
                                                display:"block", width:"100%", padding:"6px 14px",
                                                border:"none", textAlign:"center", fontSize:"13px",
                                                cursor:"pointer",
                                                background: y === gorunenYil ? "#0f172a" : "transparent",
                                                color: y === gorunenYil ? "white" : "#e2e8f0",
                                                fontWeight: y === gorunenYil ? "600" : "400",
                                            }}>
                                            {y}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        <button type="button" onClick={sonrakiAy}
                            style={{...navBtn, opacity: sonrakiAyDevre ? 0.3 : 1,
                                    cursor: sonrakiAyDevre ? "default" : "pointer"}}>›</button>
                    </div>

                    {/* Gün isimleri */}
                    <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)",
                                 gap:"2px", marginBottom:"4px"}}>
                        {["Pt","Sa","Ça","Pe","Cu","Ct","Pz"].map(g => (
                            <div key={g} style={{textAlign:"center", fontSize:"11px",
                                                 color:"#94a3b8", fontWeight:"600", padding:"2px"}}>
                                {g}
                            </div>
                        ))}
                    </div>

                    {/* Günler */}
                    <div style={{display:"grid", gridTemplateColumns:"repeat(7,1fr)", gap:"2px"}}>
                        {gunler.map((gun, i) => {
                            if (!gun) return <div key={"e"+i} />;
                            const t = new Date(gorunenYil, gorunenAy, gun); t.setHours(0,0,0,0);
                            const gelecek = t >= bugun;
                            const secili  = seciliTarih && t.getTime() === seciliTarih.getTime();
                            const bugunku = t.getTime() === bugun.getTime();
                            return (
                                <button key={gun} type="button"
                                    onClick={() => gunSec(gun)} disabled={gelecek}
                                    style={{
                                        padding:"5px 2px", border:"none", borderRadius:"6px",
                                        fontSize:"12px", cursor: gelecek ? "default" : "pointer",
                                        background: secili ? "#0f172a" : bugunku ? "#3b82f622" : "transparent",
                                        color: secili ? "white" : gelecek ? "#475569" : bugunku ? "#2563eb" : "#e2e8f0",
                                        fontWeight: secili || bugunku ? "700" : "400",
                                    }}>
                                    {gun}
                                </button>
                            );
                        })}
                    </div>

                    {/* Hızlı seçim */}
                    <div style={{borderTop:"1px solid #334155", marginTop:"10px",
                                 paddingTop:"8px", display:"flex", gap:"6px", flexWrap:"wrap"}}>
                        {[["1 Ay",1],["3 Ay",3],["6 Ay",6],["1 Yıl",12],["2 Yıl",24],["3 Yıl",36]].map(([label, ay]) => (
                            <button key={label} type="button" onClick={() => {
                                const d = new Date(bugun);
                                d.setMonth(d.getMonth() - ay);
                                const iso = d.toISOString().split("T")[0];
                                onChange(iso);
                                setGorunenYil(d.getFullYear());
                                setGorunenAy(d.getMonth());
                                kapat();
                            }} style={{
                                padding:"3px 10px", borderRadius:"12px", fontSize:"11px",
                                border:"1px solid #334155", background:"#182234",
                                cursor:"pointer", color:"#e2e8f0",
                            }}>
                                {label}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

const navBtn = {
    padding:"4px 10px", border:"1px solid #334155", borderRadius:"6px",
    background:"#1e293b", cursor:"pointer", fontSize:"16px", color:"#e2e8f0", lineHeight:"1",
};
